import React, { useState, useEffect } from 'react';
import './App.css';
import ScheduleManager from './components/ScheduleManager';
import StockHistory from './components/StockHistory';

// Intercepteur global : joint le token admin (vérifié côté serveur) à tous les appels API
if (!window.__adminFetchPatched) {
  window.__adminFetchPatched = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (url, opts = {}) => {
    try {
      const token = sessionStorage.getItem('adminToken');
      if (token && typeof url === 'string' && url.includes('/api/')) {
        opts = { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` } };
      }
    } catch (err) { /* sessionStorage indisponible */ }
    return originalFetch(url, opts);
  };
}
import { Scissors, Clock, Award, Sparkles, ShoppingBag, Droplets, Package, Star, Home, Camera, Calendar, ClipboardList, Wallet, Phone, MessageCircle, Instagram } from 'lucide-react';

// Désactiver console.log en production (les console.error/warn restent pour le support)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

const translations = {
  pt: {
    tagline: "Mais que um barbeiro",
    subtitle: "Nova experiência de barbearia chegando",
    nav: {
      home: "Início",
      services: "Serviços",
      gallery: "Galeria",
      shop: "Loja",
      agenda: "Agenda",
      appointment: "Agendamento",
      contact: "Contato"
    },
    hero: {
      title: "MAFI BARBER",
      subtitle: "Experiência Premium em Barbearia",
      description: "Transformamos cada corte em uma obra de arte. Experimente o luxo e a elegância que você merece.",
      cta: "Agendar Agora"
    },
    services: {
      title: "Nossos Serviços",
      subtitle: "Qualidade e excelência profissional",
      loading: "Carregando serviços...",
      duration: "min",
      book: "Agendar",
      hairWashIncluded: "* Lavagem incluída (mediante preferência do cliente)",
      openingInfo: {
        title: "Horários de Funcionamento",
        schedule: "Aberto todos os dias",
        withAppointment: "Segunda a Domingo, 9h00-20h00: com marcação",
        sundayTuesday: "Domingo e Terça: marcação de hora em hora",
        evening: "Todos os dias após as 20h00: sem marcação prévia (custo adicional)",
        walkIn: "Sem marcação"
      },
      hairWashNote: {
        title: "Informação sobre lavagem",
        text: "O preço dos serviços de corte inclui lavagem de cabelo conforme a preferência do cliente."
      },
      lateServiceNote: {
        title: "Atendimento fora de horário",
        text: "Podemos receber clientes fora do horário de funcionamento. Contudo, os serviços fora de horário terão um custo adicional de 10€. Aconselhamos que ligue antes para confirmar a disponibilidade."
      },
      categories: {
        regular: "Regular",
        premium: "Premium", 
        barbe: "Barba",
        colorations: "Colorações",
        soins: "Cuidados"
      },
      serviceNames: {
        "Coupe Enfant (-12ans)": "Corte Criança (-12anos)",
        "Coupe + Coiffage": "Corte + Penteado", 
        "Coupe + Barbe (serviette chaude)": "Corte + Barba (toalha quente)",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Corte + Penteado + Tratamento Capilar ou Barba",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Corte + Penteado + Tratamento Capilar ou Barba + Barba",
        "Coupe + Coiffage + Soin Complet + Barbe": "Corte + Penteado + Tratamento Completo + Barba",
        "Barbe + Serviette Chaude": "Barba + Toalha Quente",
        "Barbe + Serviette Chaude + Soin": "Barba + Toalha Quente + Tratamento",
        "Rasage Crâne à la Lame": "Barbear Crânio à Navalha",
        "Rasage Crâne + Barbe (serviette chaude)": "Barbear Crânio + Barba (toalha quente)",
        "Black Beard Coloration": "Coloração de Barba Preta",
        "Black Hair Coloration": "Coloração de Cabelo Preto",
        "Coupe + Shampoing + Mèches": "Corte + Shampoo + Mechas",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Corte + Shampoo + Mechas (cabelo comprido)",
        "Permanente (sans coupe)": "Permanente (sem corte)",
        "Coupe + Shampooing + Coloration": "Corte + Shampoo + Coloração",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Corte + Shampoo + Coloração (cabelo comprido)",
        "Coupe + Shampooing + Décoloration + Coloration": "Corte + Shampoo + Descoloração + Coloração",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Corte + Shampoo + Descoloração + Coloração (cabelo comprido)",
        "Soin Barbe": "Tratamento de Barba",
        "Soin Cheveux": "Tratamento Capilar",
        "Soin Premium": "Tratamento Premium",
        "Vente Seule": "Venda Apenas"
      },
      serviceDescriptions: {
        "Coupe Enfant (-12ans)": "Corte adaptado para crianças menores de 12 anos",
        "Coupe + Coiffage": "Corte de cabelo com penteado profissional", 
        "Coupe + Barbe (serviette chaude)": "Corte completo com barba e toalha quente",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Serviço premium com tratamento capilar ou barba (à escolha)",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Serviço premium completo com tratamento (capilar ou barba à escolha) e barba",
        "Coupe + Coiffage + Soin Complet + Barbe": "Corte + penteado + tratamento de cabelo (shampoo + tratamento) + barba + tratamento de barba",
        "Barbe + Serviette Chaude": "Aparar e cuidar da barba com toalha quente",
        "Barbe + Serviette Chaude + Soin": "Serviço de barba completo com tratamento especializado",
        "Rasage Crâne à la Lame": "A arte do barbear tradicional no seu auge. Uma experiência precisa e refinada para um crânio perfeitamente liso.",
        "Rasage Crâne + Barbe (serviette chaude)": "O ritual completo do cavalheiro. Barbear do crânio à navalha combinado com o cuidado de barba tradicional com toalha quente.",
        "Black Beard Coloration": "Coloração profissional para barba - Preto intenso",
        "Black Hair Coloration": "Coloração profissional para cabelo - Preto intenso",
        "Coupe + Shampoing + Mèches": "Corte com mechas (mel, brancas, cinza)",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Corte com mechas para cabelo comprido (mel, brancas, cinza)",
        "Permanente (sans coupe)": "Permanente sem corte",
        "Coupe + Shampooing + Coloration": "Corte + shampoo + coloração",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Corte + shampoo + coloração para cabelo comprido",
        "Coupe + Shampooing + Décoloration + Coloration": "Corte + shampoo + descoloração + coloração",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Corte + shampoo + descoloração + coloração para cabelo comprido",
        "Soin Barbe": "Tratamento especializado para barba",
        "Soin Cheveux": "Tratamento capilar profissional",
        "Soin Premium": "Tratamento completo (cabelo, barba)",
        "Vente Seule": "Venda de produtos sem prestação de serviço"
      },
      extras: {
        title: "Toques de Requinte",
        subtitle: "Para uma experiência verdadeiramente personalizada, oferecemos também pequenos extras à medida dos seus desejos. Pode indicá-los nas observações ao agendar o seu horário.",
        items: {
          eyebrows: { name: "Design de sobrancelhas", price: "3€" },
          eyebrowsThread: { name: "Design de sobrancelhas com linha", price: "5€" },
          fullMassage: { name: "Massagem completa relaxante (cabeça, ombros, costas, braços)", price: "20€" },
          noseHair: { name: "Aparar pelos do nariz", price: "4€" },
          facialMassage: { name: "Massagem facial com creme + remoção de pontos negros", price: "10€" },
          facialCream: { name: "Creme facial revitalizante", price: "5€" }
        },
        note: "Suplementos sob pedido"
      }
    },
    shop: {
      title: "Loja",
      subtitle: "Produtos profissionais de alta qualidade",
      storeOnlyNotice: "Todos os artigos apresentados estão disponíveis exclusivamente no nosso salão. Não efetuamos vendas online.",
      loading: "Carregando produtos...",
      addToCart: "Comprar",
      inStock: "Em estoque",
      outOfStock: "Esgotado",
      stockLeft: "restante(s)",
      purchaseSuccess: "Compra realizada com sucesso!",
      purchaseError: "Erro na compra. Tente novamente.",
      adminPanel: "Painel Admin",
      updateStock: "Atualizar Stock",
      newStock: "Novo Stock",
      categories: {
        all: "Todos",
        styling: "Styling",
        barba: "Barba",
        cuidados: "Cuidados",
        acessorios: "Acessórios"
      }
    },
    agenda: {
      title: "Agenda",
      subtitle: "Gestão de horários e agendamentos",
      loading: "Carregando agenda...",
      noAppointments: "Nenhum agendamento encontrado",
      appointmentDetails: "Detalhes do Agendamento",
      client: "Cliente",
      service: "Serviço",
      date: "Data",
      time: "Horário",
      phone: "Telefone",
      email: "Email",
      notes: "Observações",
      status: "Status",
      actions: "Ações",
      cancel: "Cancelar",
      confirm: "Confirmar",
      today: "Hoje",
      tomorrow: "Amanhã",
      thisWeek: "Esta Semana",
      nextWeek: "Próxima Semana",
      viewType: {
        day: "Dia",
        week: "Semana",
        month: "Mês"
      },
      calendarView: "Vista Calendário",
      listView: "Vista Lista",
      appointmentsOnDate: "Agendamentos em",
            noAppointmentsOnDate: "Nenhum agendamento nesta data",
      adminOnly: "Esta seção é apenas para administradores", adminOnlySub: "Acesso reservado aos administradores",
      stockTitle: "Controlo de Stocks",
      stockSubtitle: "Gestão e acompanhamento do inventário em tempo real",
      imageCol: "Imagem", productCol: "Produto", brandCol: "Marca", categoryCol: "Categoria",
      priceCol: "Preço de Venda", stockCol: "Stock Atual", statusCol: "Estado", actionsCol: "Ações",
      units: "unidades", statusOut: "Rutura", statusLow: "Baixo", statusGood: "Bom", adjust: "Ajustar",
      totalProducts: "Total Produtos", unitsInStock: "Unidades em Stock",
      totalStockValue: "Valor Total do Stock", lowStockLabel: "Stock Baixo"
    },
    payments: {
      title: "Pagamentos",
      subtitle: "Gestão de pagamentos e receitas",
      newPayment: "Novo Pagamento",
      dashboard: "Dashboard",
      clientName: "Nome do Cliente",
      selectClient: "Selecionar Cliente",
      walkInClient: "Cliente sem Agendamento",
      servicePerformed: "Serviço Realizado",
      amount: "Montante",
      paymentMethod: "Método de Pagamento",
      selectPaymentMethod: "Escolha o método...",
      cash: "Dinheiro",
      card: "Cartão",
      mbway: "MBWay",
      paymentDate: "Data do Pagamento",
      paymentTime: "Hora do Pagamento",
      notes: "Observações",
      notesOptional: "Observações (opcional)",
      notesRequired: "Obrigatório (preço modificado)",
      notesPlaceholder: "Observações (opcional)",
      notesRequiredPlaceholder: "Explique porque o preço foi modificado...",
      save: "Guardar Pagamento",
      saveChanges: "Guardar Alterações",
      saving: "Guardando...",
      totalRevenue: "Receita Total",
      totalTransactions: "Total de Transações",
      revenueByMethod: "Receita por Método",
      revenueByService: "Receita por Serviço",
      dailyRevenue: "Receita Diária (30 dias)",
      noPayments: "Nenhum pagamento registado",
      paymentSaved: "Pagamento guardado com sucesso!",
      paymentError: "Erro ao guardar pagamento",
      productsSold: "Produtos vendidos (opcional)",
      addProduct: "Adicionar um produto",
      selectProduct: "Selecionar um produto...",
      selectedProducts: "Produtos selecionados:",
      totalProducts: "Total produtos:",
      clientNoShow: "Cliente Não Compareceu",
      confirmNoShow: "Confirmar que o cliente não compareceu? O agendamento será cancelado.",
      priceModifiedError: "O montante difere do preço base. Por favor adicione um comentário para justificar esta alteração.",
      monthlyPayments: "Pagamentos do Mês",
      editPayment: "Modificar",
      editPaymentTitle: "Modificar este pagamento",
      deletePayment: "Excluir",
      confirmDelete: "Tem certeza de que deseja excluir este pagamento?",
      at: "às",
      selectFromRecent: "Selecionar de Agendamentos Recentes",
      selectService: "Selecionar serviço",
      editTitle: "Modificar Pagamento",
      service: "Serviço",
      name: "Nome do Cliente",
      email: "Email",
      phone: "Telefone",
      methodBreakdown: "Repartição por Método",
      providerRevenue: "Receita por Prestador",
      servicesLabel: "Serviços",
      salesLabel: "Vendas",
      tipsLabel: "Gorjetas",
      transactionsDetail: "Detalhe das Transações",
      noPaymentsForDate: "Nenhum pagamento registado para esta data",
      timeCol: "Hora",
      clientCol: "Cliente",
      serviceProductsCol: "Serviço/Produtos",
      methodCol: "Método",
      actionsCol: "Ações",
      tipsOffBooks: "Tips (Fora das Contas)",
      tipField: "Tips (Gorjeta)",
      selectBarber: "Selecionar um barbeiro...",
      paymentDeleted: "Pagamento excluído com sucesso!"
    },
    missions: {
      title: "Missões",
      late: "Em atraso",
      todo: "A fazer",
      upcoming: "Nos próximos dias",
      doneRecent: "Concluídas recentemente",
      scheduled: "Agendadas (a vir)",
      anomalies: "Anomalias de contagem",
      validate: "Validar",
      commentOptional: "Comentário (opcional)",
      dueBy: "A fazer até",
      completedAt: "Concluída em",
      vapes_parfumsTitle: "Recontagem Vapes & Perfumes",
      cafe_bonbonsTitle: "Recontagem Café & Bombons",
      envelopesTitle: "Recolha dos envelopes",
      waterTitle: "Pagamento da água",
      vapesLabel: "Total de Vapes contados",
      parfumsLabel: "Total de Perfumes contados (todas as variedades)",
      cafeLabel: "Café contado",
      bonbonsLabel: "Bombons contados",
      envelopesLabel: "Número de envelopes recolhidos",
      waterConfirm: "✔ Confirmar pagamento efetuado",
      reminderBanner: "missão(ões) para hoje ou em atraso — clique aqui",
      noMissions: "Nenhuma missão",
      system: "Sistema",
      counted: "Contado",
      gap: "Diferença",
      fillAllFields: "Preencha todas as quantidades",
      missionDone: "Missão concluída com sucesso!"
    },
    archives: {
      title: "Arquivos",
      monthCol: "Mês",
      transactionsCol: "Transações",
      totalCol: "Total",
      servicesCol: "Serviços",
      productsCol: "Produtos",
      tipsCol: "Gorjetas",
      variation: "Variação",
      downloadExcel: "Descarregar Excel",
      noData: "Nenhum pagamento para este ano",
      yearTotal: "Total do ano",
      currentMonth: "Mês em curso",
      festive: "Festivo",
      augustBadge: "Agosto — comparado apenas com agosto",
      ca: "Receita",
      sales: "Vendas",
      incomplete: "dados parciais"
    },
    gallery: {
      title: "Galeria",
      subtitle: "Nossos melhores trabalhos"
    },
    appointment: {
      title: "Agendamento",
      subtitle: "Reserve seu horário",
      openingHours: "Aberto: Segunda a Domingo, 9h00-20h00",
      form: {
        name: "Nome Completo",
        email: "Email",
        phone: "Telefone",
        service: "Escolha o Serviço",
        date: "Selecionar Data",
        time: "Horário",
        notes: "Observações (opcional)",
        submit: "Confirmar Agendamento",
        selectDateFirst: "Selecione primeiro uma data",
        loadingTimes: "Carregando horários..."
      },
      success: "Agendamento realizado com sucesso!",
      error: "Erro ao realizar agendamento. Tente novamente.",
      confirmationModal: {
        title: "✅ Agendamento Confirmado!",
        message: "O seu agendamento foi confirmado com sucesso.",
        emailInfo: "Vai receber um email de confirmação em breve.",
        spamWarning: "(Verifique a pasta de spam/indesejáveis)",
        close: "Fechar"
      },
      calendar: {
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        daysShort: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        today: 'Hoje',
        closed: 'Fechado',
        available: 'Disponível',
        alwaysOpen: 'Sem Marcação (Dom/Seg)',
        selected: 'Selecionado',
        booked: 'Reservado',
        selectDate: 'Selecionar data',
        close: 'Fechar'
      }
    },
    contact: {
      title: "Contato",
      subtitle: "Entre em contato conosco",
      form: {
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        message: "Mensagem",
        submit: "Enviar Mensagem"
      },
      success: "Mensagem enviada com sucesso!",
      error: "Erro ao enviar mensagem. Tente novamente."
    }
  },
  fr: {
    tagline: "Plus qu'un barbier",
    subtitle: "Nouvelle expérience de barbier arrive",
    nav: {
      home: "Accueil",
      services: "Services",
      gallery: "Galerie",
      shop: "Boutique",
      agenda: "Agenda",
      appointment: "Rendez-vous",
      contact: "Contact"
    },
    hero: {
      title: "MAFI BARBER",
      subtitle: "Expérience Premium en Barberie",
      description: "Nous transformons chaque coupe en œuvre d'art. Découvrez le luxe et l'élégance que vous méritez.",
      cta: "Réserver Maintenant"
    },
    services: {
      title: "Nos Services",
      subtitle: "Qualité et excellence professionnelle",
      loading: "Chargement des services...",
      duration: "min",
      book: "Réserver",
      hairWashIncluded: "* Lavage inclus (selon préférence du client)",
      openingInfo: {
        title: "Horaires d'Ouverture",
        schedule: "Ouvert tous les jours",
        withAppointment: "Lundi à Dimanche, 9h00-20h00 : sur rendez-vous",
        sundayTuesday: "Dimanche et Mardi : rendez-vous toutes les heures",
        evening: "Tous les jours après 20h00 : sans rendez-vous (coût supplémentaire)",
        walkIn: "Sans rendez-vous"
      },
      hairWashNote: {
        title: "Note sur le lavage des cheveux",
        text: "Le prix des prestations de coupe de cheveux inclut le lavage selon les préférences du client."
      },
      lateServiceNote: {
        title: "Prestations hors horaires",
        text: "Nous pouvons recevoir des clients en dehors des horaires d'ouverture. Cependant, les prestations hors horaires entraînent un coût supplémentaire de 10€. Nous vous conseillons d'appeler avant pour confirmer la disponibilité."
      },
      categories: {
        regular: "Régulier",
        premium: "Premium", 
        barbe: "Barbe",
        colorations: "Colorations",
        soins: "Soins"
      },
      serviceNames: {
        "Coupe Enfant (-12ans)": "Coupe Enfant (-12ans)",
        "Coupe + Coiffage": "Coupe + Coiffage", 
        "Coupe + Barbe (serviette chaude)": "Coupe + Barbe (serviette chaude)",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Coupe + Coiffage + Soin Cheveux ou Barbe",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe",
        "Coupe + Coiffage + Soin Complet + Barbe": "Coupe + Coiffage + Soin Complet + Barbe",
        "Barbe + Serviette Chaude": "Barbe + Serviette Chaude",
        "Barbe + Serviette Chaude + Soin": "Barbe + Serviette Chaude + Soin",
        "Rasage Crâne à la Lame": "Rasage Crâne à la Lame",
        "Rasage Crâne + Barbe (serviette chaude)": "Rasage Crâne + Barbe (serviette chaude)",
        "Black Beard Coloration": "Coloration Barbe Noire",
        "Black Hair Coloration": "Coloration Cheveux Noirs",
        "Coupe + Shampoing + Mèches": "Coupe + Shampoing + Mèches",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Coupe + Shampoing + Mèches (cheveux longs)",
        "Permanente (sans coupe)": "Permanente (sans coupe)",
        "Coupe + Shampooing + Coloration": "Coupe + Shampoing + Coloration",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Coupe + Shampoing + Coloration (cheveux longs)",
        "Coupe + Shampooing + Décoloration + Coloration": "Coupe + Shampoing + Décoloration + Coloration",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Coupe + Shampoing + Décoloration + Coloration (cheveux longs)",
        "Soin Barbe": "Soin Barbe",
        "Soin Cheveux": "Soin Cheveux",
        "Soin Premium": "Soin Premium",
        "Vente Seule": "Vente Seule"
      },
      serviceDescriptions: {
        "Coupe Enfant (-12ans)": "Coupe adaptée pour enfants de moins de 12 ans",
        "Coupe + Coiffage": "Coupe de cheveux avec coiffage professionnel", 
        "Coupe + Barbe (serviette chaude)": "Coupe complète avec barbe et serviette chaude",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Service premium avec soin capillaire ou barbe (au choix)",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Service premium complet avec soin (capillaire ou barbe au choix) et barbe",
        "Coupe + Coiffage + Soin Complet + Barbe": "Coupe + coiffage + soin cheveux (shampoing + soin) + barbe + soin barbe",
        "Barbe + Serviette Chaude": "Taille et soin de la barbe avec serviette chaude",
        "Barbe + Serviette Chaude + Soin": "Service barbe complet avec soin spécialisé",
        "Rasage Crâne à la Lame": "L'art du rasage traditionnel à son apogée. Une expérience précise et raffinée pour un crâne parfaitement lisse.",
        "Rasage Crâne + Barbe (serviette chaude)": "Le rituel complet du gentleman. Rasage du crâne à la lame combiné au soin barbe traditionnel avec serviette chaude.",
        "Black Beard Coloration": "Coloration professionnelle pour barbe - Noir intense",
        "Black Hair Coloration": "Coloration professionnelle pour cheveux - Noir intense",
        "Coupe + Shampoing + Mèches": "Coupe avec mèches (miel, blanches, grises)",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Coupe avec mèches pour cheveux longs (miel, blanches, grises)",
        "Permanente (sans coupe)": "Permanente sans coupe",
        "Coupe + Shampooing + Coloration": "Coupe + shampoing + coloration",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Coupe + shampoing + coloration pour cheveux longs",
        "Coupe + Shampooing + Décoloration + Coloration": "Coupe + shampoing + décoloration + coloration",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Coupe + shampoing + décoloration + coloration pour cheveux longs",
        "Soin Barbe": "Soin spécialisé pour la barbe",
        "Soin Cheveux": "Soin capillaire professionnel",
        "Soin Premium": "Soin complet (cheveux, barbe)",
        "Vente Seule": "Vente de produits sans prestation de service"
      },
      extras: {
        title: "Touches de Raffinement",
        subtitle: "Pour une expérience véritablement sur-mesure, nous proposons également de petits extras selon vos envies. Vous pouvez les indiquer dans les remarques lors de votre prise de rendez-vous.",
        items: {
          eyebrows: { name: "Taille des sourcils", price: "3€" },
          eyebrowsThread: { name: "Taille des sourcils au fil", price: "5€" },
          fullMassage: { name: "Massage complet relaxant (tête, épaules, dos, bras)", price: "20€" },
          noseHair: { name: "Tonte poil de nez", price: "4€" },
          facialMassage: { name: "Massage visage à la crème + retrait points noirs", price: "10€" },
          facialCream: { name: "Crème visage revitalisante", price: "5€" }
        },
        note: "Suppléments sur demande"
      }
    },
    shop: {
      title: "Boutique",
      subtitle: "Produits professionnels de haute qualité",
      storeOnlyNotice: "Tous les articles présentés sont disponibles uniquement dans notre salon. Nous n'effectuons pas de ventes en ligne.",
      loading: "Chargement des produits...",
      addToCart: "Acheter",
      inStock: "En stock",
      outOfStock: "Épuisé",
      stockLeft: "restant(s)",
      purchaseSuccess: "Achat réalisé avec succès!",
      purchaseError: "Erreur lors de l'achat. Réessayez.",
      adminPanel: "Panneau Admin",
      updateStock: "Mettre à jour Stock",
      newStock: "Nouveau Stock",
      categories: {
        all: "Tous",
        styling: "Styling",
        barba: "Barbe",
        cuidados: "Soins",
        acessorios: "Accessoires"
      }
    },
    agenda: {
      title: "Agenda",
      subtitle: "Gestion des horaires et rendez-vous",
      loading: "Chargement agenda...",
      noAppointments: "Aucun rendez-vous trouvé",
      appointmentDetails: "Détails du Rendez-vous",
      client: "Client",
      service: "Service",
      date: "Date",
      time: "Heure",
      phone: "Téléphone",
      email: "Email",
      notes: "Remarques",
      status: "Statut",
      actions: "Actions",
      cancel: "Annuler",
      confirm: "Confirmer",
      today: "Aujourd'hui",
      tomorrow: "Demain",
      thisWeek: "Cette Semaine",
      nextWeek: "Semaine Prochaine",
      viewType: {
        day: "Jour",
        week: "Semaine",
        month: "Mois"
      },
      calendarView: "Vue Calendrier",
      listView: "Vue Liste",
      appointmentsOnDate: "Rendez-vous du",
            noAppointmentsOnDate: "Aucun rendez-vous à cette date",
      adminOnly: "Cette section est réservée aux administrateurs", adminOnlySub: "Accès réservé aux administrateurs",
      stockTitle: "Suivi des Stocks",
      stockSubtitle: "Gestion et suivi en temps réel de l'inventaire",
      imageCol: "Image", productCol: "Produit", brandCol: "Marque", categoryCol: "Catégorie",
      priceCol: "Prix de Vente", stockCol: "Stock Actuel", statusCol: "Statut", actionsCol: "Actions",
      units: "unités", statusOut: "Rupture", statusLow: "Faible", statusGood: "Bon", adjust: "Ajuster",
      totalProducts: "Total Produits", unitsInStock: "Unités en Stock",
      totalStockValue: "Valeur Totale Stock", lowStockLabel: "Stock Faible"
    },
    payments: {
      title: "Paiements",
      subtitle: "Gestion des paiements et revenus",
      newPayment: "Nouveau Paiement",
      dashboard: "Tableau de Bord",
      clientName: "Nom du Client",
      selectClient: "Sélectionner Client",
      walkInClient: "Client sans RDV",
      servicePerformed: "Service Effectué",
      amount: "Montant",
      paymentMethod: "Méthode de Paiement",
      selectPaymentMethod: "Choisissez la méthode...",
      cash: "Espèces",
      card: "Carte",
      mbway: "MBWay",
      paymentDate: "Date du Paiement",
      paymentTime: "Heure du Paiement",
      notes: "Remarques",
      notesOptional: "Remarques (optionnel)",
      notesRequired: "Obligatoire (prix modifié)",
      notesPlaceholder: "Remarques (optionnel)",
      notesRequiredPlaceholder: "Expliquez pourquoi le prix a été modifié...",
      save: "Enregistrer Paiement",
      saveChanges: "Enregistrer Modifications",
      saving: "Enregistrement...",
      totalRevenue: "Revenu Total",
      totalTransactions: "Total Transactions",
      revenueByMethod: "Revenu par Méthode",
      revenueByService: "Revenu par Service",
      dailyRevenue: "Revenu Quotidien (30 jours)",
      noPayments: "Aucun paiement enregistré",
      paymentSaved: "Paiement enregistré avec succès!",
      paymentError: "Erreur lors de l'enregistrement",
      productsSold: "Produits vendus (optionnel)",
      addProduct: "Ajouter un produit",
      selectProduct: "Sélectionner un produit...",
      selectedProducts: "Produits sélectionnés :",
      totalProducts: "Total produits :",
      clientNoShow: "Client Non Venu",
      confirmNoShow: "Confirmer que le client ne s'est pas présenté ? Le rendez-vous sera annulé.",
      priceModifiedError: "Le montant diffère du prix de base. Veuillez ajouter un commentaire pour justifier ce changement.",
      monthlyPayments: "Paiements du Mois",
      editPayment: "Modifier",
      editPaymentTitle: "Modifier ce paiement",
      deletePayment: "Supprimer",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce paiement ?",
      at: "à",
      selectFromRecent: "Sélectionner parmi les RDV récents",
      selectService: "Sélectionner un service",
      editTitle: "Modifier le Paiement",
      service: "Service",
      name: "Nom du Client",
      email: "Email",
      phone: "Téléphone",
      methodBreakdown: "Répartition par Méthode",
      providerRevenue: "Revenus par Prestataire",
      servicesLabel: "Services",
      salesLabel: "Ventes",
      tipsLabel: "Pourboires",
      transactionsDetail: "Détail des Transactions",
      noPaymentsForDate: "Aucun paiement enregistré pour cette date",
      timeCol: "Heure",
      clientCol: "Client",
      serviceProductsCol: "Service/Produits",
      methodCol: "Méthode",
      actionsCol: "Actions",
      tipsOffBooks: "Tips (Hors Comptes)",
      tipField: "Tips (Pourboire)",
      selectBarber: "Sélectionner un barbier...",
      paymentDeleted: "Paiement supprimé avec succès !"
    },
    missions: {
      title: "Missions",
      late: "En retard",
      todo: "À faire",
      upcoming: "Dans les prochains jours",
      doneRecent: "Terminées récemment",
      scheduled: "À venir (planifiées)",
      anomalies: "Anomalies de comptage",
      validate: "Valider",
      commentOptional: "Commentaire (optionnel)",
      dueBy: "À faire avant le",
      completedAt: "Terminée le",
      vapes_parfumsTitle: "Recomptage Vapes & Parfums",
      cafe_bonbonsTitle: "Recomptage Café & Bonbons",
      envelopesTitle: "Récupération des enveloppes",
      waterTitle: "Paiement de l'eau",
      vapesLabel: "Total Vapes comptés",
      parfumsLabel: "Total Parfums comptés (toutes variétés)",
      cafeLabel: "Café compté",
      bonbonsLabel: "Bonbons comptés",
      envelopesLabel: "Nombre d'enveloppes récupérées",
      waterConfirm: "✔ Confirmer le paiement effectué",
      reminderBanner: "mission(s) pour aujourd'hui ou en retard — cliquez ici",
      noMissions: "Aucune mission",
      system: "Système",
      counted: "Compté",
      gap: "Écart",
      fillAllFields: "Remplissez toutes les quantités",
      missionDone: "Mission terminée avec succès !"
    },
    archives: {
      title: "Archives",
      monthCol: "Mois",
      transactionsCol: "Transactions",
      totalCol: "Total",
      servicesCol: "Services",
      productsCol: "Produits",
      tipsCol: "Pourboires",
      variation: "Variation",
      downloadExcel: "Télécharger Excel",
      noData: "Aucun paiement pour cette année",
      yearTotal: "Total de l'année",
      currentMonth: "Mois en cours",
      festive: "Festif",
      augustBadge: "Août — comparé uniquement à août",
      ca: "CA",
      sales: "Ventes",
      incomplete: "données partielles"
    },
    gallery: {
      title: "Galerie",
      subtitle: "Nos meilleurs travaux"
    },
    appointment: {
      title: "Rendez-vous",
      subtitle: "Réservez votre créneau",
      openingHours: "Ouvert : Lundi à Dimanche, 9h00-20h00",
      form: {
        name: "Nom Complet",
        email: "Email",
        phone: "Téléphone",
        service: "Choisissez le Service",
        date: "Sélectionner Date",
        time: "Heure",
        notes: "Remarques (optionnel)",
        submit: "Confirmer le Rendez-vous",
        selectDateFirst: "Veuillez d'abord sélectionner une date",
        loadingTimes: "Chargement des horaires..."
      },
      success: "Rendez-vous confirmé avec succès!",
      error: "Erreur lors de la réservation. Veuillez réessayer.",
      confirmationModal: {
        title: "✅ Rendez-vous Confirmé!",
        message: "Votre rendez-vous a bien été confirmé.",
        emailInfo: "Vous allez recevoir un email de confirmation.",
        spamWarning: "(Vérifiez vos spam/indésirables)",
        close: "Fermer"
      },
      calendar: {
        months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        daysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        today: "Aujourd'hui",
        closed: 'Fermé',
        available: 'Disponible',
        alwaysOpen: 'Sans RDV (Dim/Lun)',
        selected: 'Sélectionné',
        booked: 'Réservé',
        selectDate: 'Sélectionner une date',
        close: 'Fermer'
      }
    },
    contact: {
      title: "Contact",
      subtitle: "Contactez-nous",
      form: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        message: "Message",
        submit: "Envoyer le Message"
      },
      success: "Message envoyé avec succès!",
      error: "Erreur lors de l'envoi. Veuillez réessayer."
    }
  },
  en: {
    tagline: "More than a barber",
    subtitle: "New barbering experience coming",
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      shop: "Shop",
      agenda: "Calendar",
      appointment: "Appointment",
      contact: "Contact"
    },
    hero: {
      title: "MAFI BARBER",
      subtitle: "Premium Barbering Experience",
      description: "We transform every cut into a work of art. Experience the luxury and elegance you deserve.",
      cta: "Book Now"
    },
    services: {
      title: "Our Services",
      subtitle: "Quality and professional excellence",
      loading: "Loading services...",
      duration: "min",
      book: "Book",
      hairWashIncluded: "* Wash included (upon client preference)",
      openingInfo: {
        title: "Opening Hours",
        schedule: "Open every day",
        withAppointment: "Monday to Sunday, 9:00 AM-8:00 PM: by appointment",
        sundayTuesday: "Sunday and Tuesday: hourly appointments",
        evening: "Every day after 8:00 PM: walk-in only (additional cost)",
        walkIn: "Walk-in"
      },
      hairWashNote: {
        title: "Hair Wash Note",
        text: "The price of haircut services includes washing according to client preference."
      },
      lateServiceNote: {
        title: "Out-of-hours services",
        text: "We can accommodate clients outside of opening hours. However, out-of-hours services incur an additional charge of €10. We recommend calling ahead to confirm availability."
      },
      categories: {
        regular: "Regular",
        premium: "Premium", 
        barbe: "Beard",
        colorations: "Coloring",
        soins: "Treatments"
      },
      serviceNames: {
        "Coupe Enfant (-12ans)": "Kids Cut (-12 years)",
        "Coupe + Coiffage": "Cut + Styling", 
        "Coupe + Barbe (serviette chaude)": "Cut + Beard (hot towel)",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Cut + Styling + Hair or Beard Treatment",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Cut + Styling + Hair or Beard Treatment + Beard",
        "Coupe + Coiffage + Soin Complet + Barbe": "Cut + Styling + Complete Treatment + Beard",
        "Barbe + Serviette Chaude": "Beard + Hot Towel",
        "Barbe + Serviette Chaude + Soin": "Beard + Hot Towel + Treatment",
        "Rasage Crâne à la Lame": "Head Shave with Razor",
        "Rasage Crâne + Barbe (serviette chaude)": "Head Shave + Beard (hot towel)",
        "Black Beard Coloration": "Black Beard Coloration",
        "Black Hair Coloration": "Black Hair Coloration",
        "Coupe + Shampoing + Mèches": "Cut + Shampoo + Highlights",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Cut + Shampoo + Highlights (long hair)",
        "Permanente (sans coupe)": "Perm (no cut)",
        "Coupe + Shampooing + Coloration": "Cut + Shampoo + Coloring",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Cut + Shampoo + Coloring (long hair)",
        "Coupe + Shampooing + Décoloration + Coloration": "Cut + Shampoo + Bleaching + Coloring",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Cut + Shampoo + Bleaching + Coloring (long hair)",
        "Soin Barbe": "Beard Treatment",
        "Soin Cheveux": "Hair Treatment",
        "Soin Visage": "Face Treatment",
        "Soin Premium": "Premium Treatment",
        "Vente Seule": "Sale Only"
      },
      serviceDescriptions: {
        "Coupe Enfant (-12ans)": "Adapted cut for children under 12 years old",
        "Coupe + Coiffage": "Haircut with professional styling", 
        "Coupe + Barbe (serviette chaude)": "Complete cut with beard and hot towel",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Premium service with hair or beard treatment (choice)",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Complete premium service with treatment (hair or beard choice) and beard",
        "Coupe + Coiffage + Soin Complet + Barbe": "Cut + styling + hair treatment (shampoo + treatment) + beard + beard treatment",
        "Barbe + Serviette Chaude": "Trim and care for beard with hot towel",
        "Barbe + Serviette Chaude + Soin": "Complete beard service with specialized treatment",
        "Rasage Crâne à la Lame": "The art of traditional shaving at its peak. A precise and refined experience for a perfectly smooth head.",
        "Rasage Crâne + Barbe (serviette chaude)": "The complete gentleman's ritual. Razor head shave combined with traditional beard care with hot towel.",
        "Black Beard Coloration": "Professional beard coloration - Intense black",
        "Black Hair Coloration": "Professional hair coloration - Intense black",
        "Coupe + Shampoing + Mèches": "Cut with highlights (honey, white, gray)",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Cut with highlights for long hair (honey, white, gray)",
        "Permanente (sans coupe)": "Perm without cut",
        "Coupe + Shampooing + Coloration": "Cut + shampoo + coloring",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Cut + shampoo + coloring for long hair",
        "Coupe + Shampooing + Décoloration + Coloration": "Cut + shampoo + bleaching + coloring",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Cut + shampoo + bleaching + coloring for long hair",
        "Soin Barbe": "Specialized beard treatment",
        "Soin Cheveux": "Professional hair treatment",
        "Soin Premium": "Complete treatment (hair, beard)",
        "Vente Seule": "Product sale without service"
      },
      extras: {
        title: "Refined Touches",
        subtitle: "For a truly bespoke experience, we also offer little extras tailored to your desires. You can mention them in the notes when booking your appointment.",
        items: {
          eyebrows: { name: "Eyebrow shaping", price: "3€" },
          eyebrowsThread: { name: "Eyebrow threading", price: "5€" },
          fullMassage: { name: "Full relaxing massage (head, shoulders, back, arms)", price: "20€" },
          noseHair: { name: "Nose hair trimming", price: "4€" },
          facialMassage: { name: "Facial massage with cream + blackhead removal", price: "10€" },
          facialCream: { name: "Revitalizing facial cream", price: "5€" }
        },
        note: "Extras upon request"
      }
    },
    shop: {
      title: "Shop",
      subtitle: "High quality professional products",
      storeOnlyNotice: "All products shown are available exclusively at our salon. We do not sell online.",
      loading: "Loading products...",
      addToCart: "Buy Now",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      stockLeft: "left",
      purchaseSuccess: "Purchase successful!",
      purchaseError: "Purchase error. Please try again.",
      adminPanel: "Admin Panel",
      updateStock: "Update Stock",
      newStock: "New Stock",
      categories: {
        all: "All",
        styling: "Styling",
        barba: "Beard",
        cuidados: "Care",
        acessorios: "Accessories"
      }
    },
    agenda: {
      title: "Calendar",
      subtitle: "Schedule and appointments management",
      loading: "Loading calendar...",
      noAppointments: "No appointments found",
      appointmentDetails: "Appointment Details",
      client: "Client",
      service: "Service",
      date: "Date",
      time: "Time",
      phone: "Phone",
      email: "Email",
      notes: "Notes",
      status: "Status",
      actions: "Actions",
      cancel: "Cancel",
      confirm: "Confirm",
      today: "Today",
      tomorrow: "Tomorrow",
      thisWeek: "This Week",
      nextWeek: "Next Week",
      viewType: {
        day: "Day",
        week: "Week",
        month: "Month"
      },
      calendarView: "Calendar View",
      listView: "List View",
      appointmentsOnDate: "Appointments on",
            noAppointmentsOnDate: "No appointments on this date",
      adminOnly: "This section is for administrators only", adminOnlySub: "Access reserved for administrators",
      stockTitle: "Stock Tracking",
      stockSubtitle: "Real-time inventory management",
      imageCol: "Image", productCol: "Product", brandCol: "Brand", categoryCol: "Category",
      priceCol: "Sale Price", stockCol: "Current Stock", statusCol: "Status", actionsCol: "Actions",
      units: "units", statusOut: "Out", statusLow: "Low", statusGood: "Good", adjust: "Adjust",
      totalProducts: "Total Products", unitsInStock: "Units in Stock",
      totalStockValue: "Total Stock Value", lowStockLabel: "Low Stock"
    },
    payments: {
      title: "Payments",
      subtitle: "Payment and revenue management",
      newPayment: "New Payment",
      dashboard: "Dashboard",
      clientName: "Client Name",
      selectClient: "Select Client",
      walkInClient: "Walk-in Client",
      servicePerformed: "Service Performed",
      amount: "Amount",
      paymentMethod: "Payment Method",
      selectPaymentMethod: "Choose method...",
      cash: "Cash",
      card: "Card",
      mbway: "MBWay",
      paymentDate: "Payment Date",
      paymentTime: "Payment Time",
      notes: "Notes",
      notesOptional: "Notes (optional)",
      notesRequired: "Required (price modified)",
      notesPlaceholder: "Notes (optional)",
      notesRequiredPlaceholder: "Explain why the price was modified...",
      save: "Save Payment",
      saveChanges: "Save Changes",
      saving: "Saving...",
      totalRevenue: "Total Revenue",
      totalTransactions: "Total Transactions",
      revenueByMethod: "Revenue by Method",
      revenueByService: "Revenue by Service",
      dailyRevenue: "Daily Revenue (30 days)",
      noPayments: "No payments recorded",
      paymentSaved: "Payment saved successfully!",
      paymentError: "Error saving payment",
      productsSold: "Products sold (optional)",
      addProduct: "Add a product",
      selectProduct: "Select a product...",
      selectedProducts: "Selected products:",
      totalProducts: "Total products:",
      clientNoShow: "Client No Show",
      confirmNoShow: "Confirm that the client did not show up? The appointment will be cancelled.",
      priceModifiedError: "The amount differs from the base price. Please add a comment to explain this change.",
      monthlyPayments: "Monthly Payments",
      editPayment: "Edit",
      editPaymentTitle: "Edit this payment",
      deletePayment: "Delete",
      confirmDelete: "Are you sure you want to delete this payment?",
      at: "at",
      selectFromRecent: "Select from Recent Appointments",
      selectService: "Select a service",
      editTitle: "Edit Payment",
      service: "Service",
      name: "Client Name",
      email: "Email",
      phone: "Phone",
      methodBreakdown: "Breakdown by Method",
      providerRevenue: "Revenue by Provider",
      servicesLabel: "Services",
      salesLabel: "Sales",
      tipsLabel: "Tips",
      transactionsDetail: "Transaction Details",
      noPaymentsForDate: "No payments recorded for this date",
      timeCol: "Time",
      clientCol: "Client",
      serviceProductsCol: "Service/Products",
      methodCol: "Method",
      actionsCol: "Actions",
      tipsOffBooks: "Tips (Off the Books)",
      tipField: "Tips (Tip)",
      selectBarber: "Select a barber...",
      paymentDeleted: "Payment deleted successfully!"
    },
    missions: {
      title: "Missions",
      late: "Overdue",
      todo: "To do",
      upcoming: "In the coming days",
      doneRecent: "Recently completed",
      scheduled: "Scheduled (upcoming)",
      anomalies: "Counting anomalies",
      validate: "Validate",
      commentOptional: "Comment (optional)",
      dueBy: "Due by",
      completedAt: "Completed on",
      vapes_parfumsTitle: "Vapes & Perfumes Recount",
      cafe_bonbonsTitle: "Coffee & Candy Recount",
      envelopesTitle: "Envelope Collection",
      waterTitle: "Water Bill Payment",
      vapesLabel: "Total Vapes counted",
      parfumsLabel: "Total Perfumes counted (all varieties)",
      cafeLabel: "Coffee counted",
      bonbonsLabel: "Candy counted",
      envelopesLabel: "Number of envelopes collected",
      waterConfirm: "✔ Confirm payment made",
      reminderBanner: "mission(s) due today or overdue — click here",
      noMissions: "No missions",
      system: "System",
      counted: "Counted",
      gap: "Gap",
      fillAllFields: "Fill in all quantities",
      missionDone: "Mission completed successfully!"
    },
    archives: {
      title: "Archives",
      monthCol: "Month",
      transactionsCol: "Transactions",
      totalCol: "Total",
      servicesCol: "Services",
      productsCol: "Products",
      tipsCol: "Tips",
      variation: "Variation",
      downloadExcel: "Download Excel",
      noData: "No payments for this year",
      yearTotal: "Year total",
      currentMonth: "Current month",
      festive: "Festive",
      augustBadge: "August — compared to August only",
      ca: "Revenue",
      sales: "Sales",
      incomplete: "partial data"
    },
    gallery: {
      title: "Gallery",
      subtitle: "Our finest work"
    },
    appointment: {
      title: "Appointment",
      subtitle: "Book your slot",
      openingHours: "Open: Monday to Sunday, 9:00 AM-8:00 PM",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        service: "Choose Service",
        date: "Select Date",
        time: "Time",
        notes: "Notes (optional)",
        submit: "Confirm Appointment",
        selectDateFirst: "Please select a date first",
        loadingTimes: "Loading available times..."
      },
      success: "Appointment booked successfully!",
      error: "Error booking appointment. Please try again.",
      confirmationModal: {
        title: "✅ Appointment Confirmed!",
        message: "Your appointment has been successfully confirmed.",
        emailInfo: "You will receive a confirmation email shortly.",
        spamWarning: "(Check your spam/junk folder)",
        close: "Close"
      },
      calendar: {
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        today: 'Today',
        closed: 'Closed',
        available: 'Available',
        alwaysOpen: 'Walk-in (Sun/Mon)',
        selected: 'Selected',
        booked: 'Booked',
        selectDate: 'Select a date',
        close: 'Close'
      }
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send Message"
      },
      success: "Message sent successfully!",
      error: "Error sending message. Please try again."
    }
  },
  es: {
    tagline: "Más que un barbero",
    subtitle: "Nueva experiencia de barbería próximamente",
    nav: {
      home: "Inicio",
      services: "Servicios",
      gallery: "Galería",
      shop: "Tienda",
      agenda: "Agenda",
      appointment: "Reservar Cita",
      contact: "Contacto"
    },
    hero: {
      title: "MAFI BARBER",
      subtitle: "Experiencia Premium de Barbería",
      description: "Transformamos cada corte en una obra de arte. Disfrute del lujo y la elegancia que se merece.",
      cta: "Reservar Ahora"
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Calidad y excelencia profesional",
      loading: "Cargando servicios...",
      duration: "min",
      book: "Reservar",
      hairWashIncluded: "* Lavado incluido (según preferencia del cliente)",
      openingInfo: {
        title: "Horario de Apertura",
        schedule: "Abierto todos los días",
        withAppointment: "Lunes a Domingo, 9h00-20h00: con cita",
        sundayTuesday: "Domingo y Martes: citas cada hora",
        evening: "Todos los días después de las 20h00: sin cita previa (coste adicional)",
        walkIn: "Sin cita"
      },
      hairWashNote: {
        title: "Información sobre el lavado",
        text: "El precio de los servicios de corte incluye el lavado del cabello según la preferencia del cliente."
      },
      lateServiceNote: {
        title: "Atención fuera de horario",
        text: "Podemos recibir clientes fuera del horario de apertura. Sin embargo, los servicios fuera de horario tendrán un coste adicional de 10€. Le aconsejamos llamar antes para confirmar la disponibilidad."
      },
      categories: {
        regular: "Regular",
        premium: "Premium",
        barbe: "Barba",
        colorations: "Coloraciones",
        soins: "Cuidados"
      },
      serviceNames: {
        "Coupe Enfant (-12ans)": "Corte Niño (-12 años)",
        "Coupe + Coiffage": "Corte + Peinado",
        "Coupe + Barbe (serviette chaude)": "Corte + Barba (toalla caliente)",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Corte + Peinado + Tratamiento Capilar o Barba",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Corte + Peinado + Tratamiento Capilar o Barba + Barba",
        "Coupe + Coiffage + Soin Complet + Barbe": "Corte + Peinado + Tratamiento Completo + Barba",
        "Barbe + Serviette Chaude": "Barba + Toalla Caliente",
        "Barbe + Serviette Chaude + Soin": "Barba + Toalla Caliente + Tratamiento",
        "Rasage Crâne à la Lame": "Afeitado de Cráneo a Navaja",
        "Rasage Crâne + Barbe (serviette chaude)": "Afeitado de Cráneo + Barba (toalla caliente)",
        "Black Beard Coloration": "Coloración de Barba Negra",
        "Black Hair Coloration": "Coloración de Cabello Negro",
        "Coupe + Shampoing + Mèches": "Corte + Champú + Mechas",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Corte + Champú + Mechas (cabello largo)",
        "Permanente (sans coupe)": "Permanente (sin corte)",
        "Coupe + Shampooing + Coloration": "Corte + Champú + Coloración",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Corte + Champú + Coloración (cabello largo)",
        "Coupe + Shampooing + Décoloration + Coloration": "Corte + Champú + Decoloración + Coloración",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Corte + Champú + Decoloración + Coloración (cabello largo)",
        "Soin Barbe": "Tratamiento de Barba",
        "Soin Cheveux": "Tratamiento Capilar",
        "Soin Premium": "Tratamiento Premium",
        "Soin Visage": "Tratamiento Facial",
        "Vente Seule": "Solo Venta"
      },
      serviceDescriptions: {
        "Coupe Enfant (-12ans)": "Corte adaptado para niños menores de 12 años",
        "Coupe + Coiffage": "Corte de cabello con peinado profesional",
        "Coupe + Barbe (serviette chaude)": "Corte completo con barba y toalla caliente",
        "Coupe + Coiffage + Soin Cheveux ou Barbe": "Servicio premium con tratamiento capilar o de barba (a elegir)",
        "Coupe + Coiffage + Soin Capillaire ou Barbe + Barbe": "Servicio premium completo con tratamiento (capilar o de barba a elegir) y barba",
        "Coupe + Coiffage + Soin Complet + Barbe": "Corte + peinado + tratamiento capilar (champú + tratamiento) + barba + tratamiento de barba",
        "Barbe + Serviette Chaude": "Recorte y cuidado de la barba con toalla caliente",
        "Barbe + Serviette Chaude + Soin": "Servicio de barba completo con tratamiento especializado",
        "Rasage Crâne à la Lame": "El arte del afeitado tradicional en su máxima expresión. Una experiencia precisa y refinada para un cráneo perfectamente liso.",
        "Rasage Crâne + Barbe (serviette chaude)": "El ritual completo del caballero. Afeitado de cráneo a navaja combinado con el cuidado tradicional de la barba con toalla caliente.",
        "Black Beard Coloration": "Coloración profesional para barba - Negro intenso",
        "Black Hair Coloration": "Coloración profesional para cabello - Negro intenso",
        "Coupe + Shampoing + Mèches": "Corte con mechas (miel, blancas, grises)",
        "Coupe + Shampooing + Mèches (cheveux longs)": "Corte con mechas para cabello largo (miel, blancas, grises)",
        "Permanente (sans coupe)": "Permanente sin corte",
        "Coupe + Shampooing + Coloration": "Corte + champú + coloración",
        "Coupe + Shampooing + Coloration (cheveux longs)": "Corte + champú + coloración para cabello largo",
        "Coupe + Shampooing + Décoloration + Coloration": "Corte + champú + decoloración + coloración",
        "Coupe + Shampooing + Décoloration + Coloration (cheveux longs)": "Corte + champú + decoloración + coloración para cabello largo",
        "Soin Barbe": "Tratamiento especializado para barba",
        "Soin Cheveux": "Tratamiento capilar profesional",
        "Soin Premium": "Tratamiento completo (cabello, barba)",
        "Vente Seule": "Venta de productos sin prestación de servicio"
      },
      extras: {
        title: "Toques de Refinamiento",
        subtitle: "Para una experiencia verdaderamente personalizada, también ofrecemos pequeños extras a medida de sus deseos. Puede indicarlos en las observaciones al reservar su cita.",
        items: {
          eyebrows: { name: "Diseño de cejas", price: "3€" },
          eyebrowsThread: { name: "Diseño de cejas con hilo", price: "5€" },
          fullMassage: { name: "Masaje completo relajante (cabeza, hombros, espalda, brazos)", price: "20€" },
          noseHair: { name: "Recorte de vello nasal", price: "4€" },
          facialMassage: { name: "Masaje facial con crema + eliminación de puntos negros", price: "10€" },
          facialCream: { name: "Crema facial revitalizante", price: "5€" }
        },
        note: "Suplementos bajo petición"
      }
    },
    shop: {
      title: "Tienda",
      subtitle: "Productos profesionales de alta calidad",
      storeOnlyNotice: "Todos los artículos presentados están disponibles exclusivamente en nuestro salón. No realizamos ventas online.",
      loading: "Cargando productos...",
      addToCart: "Comprar",
      inStock: "En stock",
      outOfStock: "Agotado",
      stockLeft: "restante(s)",
      purchaseSuccess: "¡Compra realizada con éxito!",
      purchaseError: "Error en la compra. Inténtelo de nuevo.",
      adminPanel: "Panel Admin",
      updateStock: "Actualizar Stock",
      newStock: "Nuevo Stock",
      categories: {
        all: "Todos",
        styling: "Styling",
        barba: "Barba",
        cuidados: "Cuidados",
        acessorios: "Accesorios"
      }
    },
    agenda: {
      title: "Agenda",
      subtitle: "Gestión de horarios y citas",
      loading: "Cargando agenda...",
      noAppointments: "No se encontraron citas",
      appointmentDetails: "Detalles de la Cita",
      client: "Cliente",
      service: "Servicio",
      date: "Fecha",
      time: "Hora",
      phone: "Teléfono",
      email: "Email",
      notes: "Observaciones",
      status: "Estado",
      actions: "Acciones",
      cancel: "Cancelar",
      confirm: "Confirmar",
      today: "Hoy",
      tomorrow: "Mañana",
      thisWeek: "Esta Semana",
      nextWeek: "Próxima Semana",
      viewType: {
        day: "Día",
        week: "Semana",
        month: "Mes"
      },
      calendarView: "Vista Calendario",
      listView: "Vista Lista",
      appointmentsOnDate: "Citas el",
            noAppointmentsOnDate: "Ninguna cita en esta fecha",
      adminOnly: "Esta sección es solo para administradores", adminOnlySub: "Acceso reservado a los administradores",
      stockTitle: "Control de Stock",
      stockSubtitle: "Gestión y seguimiento del inventario en tiempo real",
      imageCol: "Imagen", productCol: "Producto", brandCol: "Marca", categoryCol: "Categoría",
      priceCol: "Precio de Venta", stockCol: "Stock Actual", statusCol: "Estado", actionsCol: "Acciones",
      units: "unidades", statusOut: "Agotado", statusLow: "Bajo", statusGood: "Bueno", adjust: "Ajustar",
      totalProducts: "Total Productos", unitsInStock: "Unidades en Stock",
      totalStockValue: "Valor Total del Stock", lowStockLabel: "Stock Bajo"
    },
    payments: {
      title: "Pagos",
      subtitle: "Gestión de pagos e ingresos",
      newPayment: "Nuevo Pago",
      dashboard: "Dashboard",
      clientName: "Nombre del Cliente",
      selectClient: "Seleccionar Cliente",
      walkInClient: "Cliente sin Cita",
      servicePerformed: "Servicio Realizado",
      amount: "Importe",
      paymentMethod: "Método de Pago",
      selectPaymentMethod: "Elija el método...",
      cash: "Efectivo",
      card: "Tarjeta",
      mbway: "MBWay",
      paymentDate: "Fecha del Pago",
      paymentTime: "Hora del Pago",
      notes: "Observaciones",
      notesOptional: "Observaciones (opcional)",
      notesRequired: "Obligatorio (precio modificado)",
      notesPlaceholder: "Observaciones (opcional)",
      notesRequiredPlaceholder: "Explique por qué se modificó el precio...",
      save: "Guardar Pago",
      saveChanges: "Guardar Cambios",
      saving: "Guardando...",
      totalRevenue: "Ingresos Totales",
      totalTransactions: "Total de Transacciones",
      revenueByMethod: "Ingresos por Método",
      revenueByService: "Ingresos por Servicio",
      dailyRevenue: "Ingresos Diarios (30 días)",
      noPayments: "Ningún pago registrado",
      paymentSaved: "¡Pago guardado con éxito!",
      paymentError: "Error al guardar el pago",
      productsSold: "Productos vendidos (opcional)",
      addProduct: "Añadir un producto",
      selectProduct: "Seleccionar un producto...",
      selectedProducts: "Productos seleccionados:",
      totalProducts: "Total productos:",
      clientNoShow: "Cliente No Presentado",
      confirmNoShow: "¿Confirmar que el cliente no se presentó? La cita será cancelada.",
      priceModifiedError: "El importe difiere del precio base. Por favor, añada un comentario para justificar este cambio.",
      monthlyPayments: "Pagos del Mes",
      editPayment: "Modificar",
      editPaymentTitle: "Modificar este pago",
      deletePayment: "Eliminar",
      confirmDelete: "¿Está seguro de que desea eliminar este pago?",
      at: "a las",
      selectFromRecent: "Seleccionar de Citas Recientes",
      selectService: "Seleccionar servicio",
      editTitle: "Modificar Pago",
      service: "Servicio",
      name: "Nombre del Cliente",
      email: "Email",
      phone: "Teléfono",
      methodBreakdown: "Desglose por Método",
      providerRevenue: "Ingresos por Barbero",
      servicesLabel: "Servicios",
      salesLabel: "Ventas",
      tipsLabel: "Propinas",
      transactionsDetail: "Detalle de las Transacciones",
      noPaymentsForDate: "Ningún pago registrado para esta fecha",
      timeCol: "Hora",
      clientCol: "Cliente",
      serviceProductsCol: "Servicio/Productos",
      methodCol: "Método",
      actionsCol: "Acciones",
      tipsOffBooks: "Tips (Fuera de Cuentas)",
      tipField: "Tips (Propina)",
      selectBarber: "Seleccionar un barbero...",
      paymentDeleted: "¡Pago eliminado con éxito!"
    },
    missions: {
      title: "Misiones",
      late: "Atrasadas",
      todo: "Por hacer",
      upcoming: "En los próximos días",
      doneRecent: "Completadas recientemente",
      scheduled: "Programadas (próximas)",
      anomalies: "Anomalías de recuento",
      validate: "Validar",
      commentOptional: "Comentario (opcional)",
      dueBy: "Hacer antes del",
      completedAt: "Completada el",
      vapes_parfumsTitle: "Recuento Vapes & Perfumes",
      cafe_bonbonsTitle: "Recuento Café & Caramelos",
      envelopesTitle: "Recogida de sobres",
      waterTitle: "Pago del agua",
      vapesLabel: "Total de Vapes contados",
      parfumsLabel: "Total de Perfumes contados (todas las variedades)",
      cafeLabel: "Café contado",
      bonbonsLabel: "Caramelos contados",
      envelopesLabel: "Número de sobres recogidos",
      waterConfirm: "✔ Confirmar pago realizado",
      reminderBanner: "misión(es) para hoy o atrasadas — haga clic aquí",
      noMissions: "Ninguna misión",
      system: "Sistema",
      counted: "Contado",
      gap: "Diferencia",
      fillAllFields: "Rellene todas las cantidades",
      missionDone: "¡Misión completada con éxito!"
    },
    archives: {
      title: "Archivos",
      monthCol: "Mes",
      transactionsCol: "Transacciones",
      totalCol: "Total",
      servicesCol: "Servicios",
      productsCol: "Productos",
      tipsCol: "Propinas",
      variation: "Variación",
      downloadExcel: "Descargar Excel",
      noData: "Ningún pago para este año",
      yearTotal: "Total del año",
      currentMonth: "Mes en curso",
      festive: "Festivo",
      augustBadge: "Agosto — comparado solo con agosto",
      ca: "Ingresos",
      sales: "Ventas",
      incomplete: "datos parciales"
    },
    gallery: {
      title: "Galería",
      subtitle: "Nuestros mejores trabajos"
    },
    appointment: {
      title: "Reservar Cita",
      subtitle: "Reserve su horario",
      openingHours: "Abierto: Lunes a Domingo, 9h00-20h00",
      form: {
        name: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        service: "Elija el Servicio",
        date: "Seleccionar Fecha",
        time: "Hora",
        notes: "Observaciones (opcional)",
        submit: "Confirmar Cita",
        selectDateFirst: "Seleccione primero una fecha",
        loadingTimes: "Cargando horarios..."
      },
      success: "¡Cita reservada con éxito!",
      error: "Error al reservar la cita. Inténtelo de nuevo.",
      confirmationModal: {
        title: "✅ ¡Cita Confirmada!",
        message: "Su cita ha sido confirmada con éxito.",
        emailInfo: "Recibirá un email de confirmación en breve.",
        spamWarning: "(Revise la carpeta de spam/correo no deseado)",
        close: "Cerrar"
      },
      calendar: {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        daysShort: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        today: 'Hoy',
        closed: 'Cerrado',
        available: 'Disponible',
        alwaysOpen: 'Sin Cita (Dom/Lun)',
        selected: 'Seleccionado',
        booked: 'Reservado',
        selectDate: 'Seleccionar fecha',
        close: 'Cerrar'
      }
    },
    contact: {
      title: "Contacto",
      subtitle: "Póngase en contacto con nosotros",
      form: {
        name: "Nombre",
        email: "Email",
        phone: "Teléfono",
        message: "Mensaje",
        submit: "Enviar Mensaje"
      },
      success: "¡Mensaje enviado con éxito!",
      error: "Error al enviar el mensaje. Inténtelo de nuevo."
    }
  }
};

function App() {
  const [currentLang, setCurrentLang] = useState(() => {
    const saved = localStorage.getItem('mafi_lang');
    if (['pt', 'fr', 'en', 'es'].includes(saved)) return saved;
    const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
    return ['pt', 'fr', 'en', 'es'].includes(browserLang) ? browserLang : 'pt';
  });
  const [currentSection, setCurrentSection] = useState('home');
  const [services, setServices] = useState([]);
  const [products, setProducts] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);
  const [superAdminAccess, setSuperAdminAccess] = useState(false); // Mode Admin+ avec modification des paiements
  const [weakAdminAccess, setWeakAdminAccess] = useState(false); // Mode Barber : consultation agenda uniquement (lecture seule)

  // ===== Authentification admin côté serveur (P0 sécurité) =====
  const adminServerLogin = async (pin) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/admin-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin })
      });
      if (!res.ok) return null;
      const data = await res.json();
      sessionStorage.setItem('adminToken', data.token);
      sessionStorage.setItem('adminRole', data.role);
      return data.role;
    } catch (err) {
      return null;
    }
  };

  const applyAdminRole = (role) => {
    if (role === 'superadmin') {
      setAdminAccess(true); setSuperAdminAccess(true); setWeakAdminAccess(false);
    } else if (role === 'admin') {
      setAdminAccess(true); setSuperAdminAccess(false); setWeakAdminAccess(false);
    } else if (role === 'barber') {
      setWeakAdminAccess(true); setAdminAccess(false); setSuperAdminAccess(false);
    }
  };

  const clearAdminSession = () => {
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminRole');
    setAdminAccess(false); setSuperAdminAccess(false); setWeakAdminAccess(false);
    setShowAdminPanel(false);
  };

  // Sécurité : le code est redemandé à chaque rechargement de page
  useEffect(() => {
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminRole');
  }, []);

  // Sécurité : déconnexion automatique après 5 minutes d'inactivité
  useEffect(() => {
    const isLogged = adminAccess || superAdminAccess || weakAdminAccess;
    if (!isLogged) return;
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        clearAdminSession();
        setCurrentSection('home');
      }, 5 * 60 * 1000);
    };
    const events = ['mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [adminAccess, superAdminAccess, weakAdminAccess]);
  const [logoTapCount, setLogoTapCount] = useState(0); // Compteur pour les taps sur le logo
  const [logoTapTimer, setLogoTapTimer] = useState(null); // Timer pour réinitialiser
  const [stockUpdates, setStockUpdates] = useState({});
  const [calendarView, setCalendarView] = useState('week');
  const [appointmentForm, setAppointmentForm] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    service_id: '',
    appointment_date: '',
    appointment_time: '',
    notes: ''
  });
  const [phoneCountryCode, setPhoneCountryCode] = useState('+351'); // Portugal par défaut
  const [availableTimes, setAvailableTimes] = useState([]);
  const [closedDates, setClosedDates] = useState([]); // Dates de fermeture du salon
  const [message, setMessage] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [currentCalendarMonth, setCurrentCalendarMonth] = useState(new Date());
  const [isMobile, setIsMobile] = useState(false);
  const [selectedServiceCategory, setSelectedServiceCategory] = useState('Regular');
  const [adminCalendarMonth, setAdminCalendarMonth] = useState(new Date());
  const [adminViewMode, setAdminViewMode] = useState('calendar'); // Mode par défaut: calendrier uniquement
  const [selectedAdminDate, setSelectedAdminDate] = useState(null);
  const [showClosedDatesPanel, setShowClosedDatesPanel] = useState(false); // Panel admin gestion fermetures
  const [newClosedDate, setNewClosedDate] = useState(''); // Input ajout date fermée
  const [payments, setPayments] = useState([]);
  const [paymentStats, setPaymentStats] = useState(null);
  const [paymentForm, setPaymentForm] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    service_id: '',
    amount: '',
    tips: '',  // Pourboire (seulement pour card/mbway)
    payment_method: '',  // Vide pour forcer la sélection
    barber: '',  // Prestataire (obligatoire)
    appointment_id: '',
    payment_date: new Date().toISOString().split('T')[0],
    payment_time: new Date().toTimeString().slice(0, 5),
    notes: ''
  });
  const [barbers, setBarbers] = useState([]); // Liste des prestataires
  const [selectedProducts, setSelectedProducts] = useState([]); // Produits sélectionnés pour la vente
  const [paymentViewMode, setPaymentViewMode] = useState('dashboard'); // 'dashboard', 'new', 'stock' or 'missions'
  const [missions, setMissions] = useState([]);
  const [missionInputs, setMissionInputs] = useState({});
  const [showEnvelopePopup, setShowEnvelopePopup] = useState(false);
  const [archiveYear, setArchiveYear] = useState(new Date().getFullYear());
  const [archiveSummary, setArchiveSummary] = useState(null);
  const [paymentPhoneCountryCode, setPaymentPhoneCountryCode] = useState('+351'); // Indicatif pays pour paiements
  const [availableMonths, setAvailableMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [monthlyPayments, setMonthlyPayments] = useState([]);
  const [monthlyStats, setMonthlyStats] = useState(null);
  const [showRevenueDetails, setShowRevenueDetails] = useState(false); // Contrôle l'affichage des détails de recette
  const [editingPayment, setEditingPayment] = useState(null); // Paiement en cours d'édition (Super Admin)
  const [showEditModal, setShowEditModal] = useState(false); // Modal d'édition de paiement
  const [clientSuggestions, setClientSuggestions] = useState([]); // Suggestions de clients pour auto-complétion
  const [showClientSuggestions, setShowClientSuggestions] = useState(false); // Afficher les suggestions
  const [appointmentClientSuggestions, setAppointmentClientSuggestions] = useState([]); // Suggestions pour rendez-vous
  const [showAppointmentClientSuggestions, setShowAppointmentClientSuggestions] = useState(false); // Afficher suggestions RDV
  
  // Daily stats
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Format YYYY-MM-DD
  const [dailyStats, setDailyStats] = useState(null);
  const [viewMode, setViewMode] = useState('monthly'); // 'monthly' ou 'daily'

  // Charger les stats journalières quand la date change
  useEffect(() => {
    if (viewMode === 'daily' && selectedDate) {
      fetchDailyStats(selectedDate);
    }
  }, [selectedDate, viewMode]);

  // Detect mobile device
  useEffect(() => {
    const detectMobile = () => {
      const userAgent = navigator.userAgent;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;
      setIsMobile(isMobileDevice || isSmallScreen);
    };

    detectMobile();
    window.addEventListener('resize', detectMobile);
    return () => window.removeEventListener('resize', detectMobile);
  }, []);

  const t = translations[currentLang];
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // ===== MISSIONS (secrétaire) =====
  const fetchMissions = async () => {
    try {
      const res = await fetch(`${backendUrl}/api/missions`);
      if (res.ok) {
        const data = await res.json();
        setMissions(data.missions || []);
      }
    } catch (error) {
      console.error('Error fetching missions:', error);
    }
  };

  const completeMission = async (mission) => {
    const inputs = missionInputs[mission.id] || {};
    let values = {};
    if (mission.type === 'vapes_parfums') {
      if (inputs.vapes === undefined || inputs.vapes === '' || inputs.parfums === undefined || inputs.parfums === '') {
        setMessage('❌ ' + t.missions.fillAllFields);
        setTimeout(() => setMessage(''), 4000);
        return;
      }
      values = { vapes: parseInt(inputs.vapes), parfums: parseInt(inputs.parfums) };
    } else if (mission.type === 'cafe_bonbons') {
      if (inputs.cafe === undefined || inputs.cafe === '' || inputs.bonbons === undefined || inputs.bonbons === '') {
        setMessage('❌ ' + t.missions.fillAllFields);
        setTimeout(() => setMessage(''), 4000);
        return;
      }
      values = { cafe: parseInt(inputs.cafe), bonbons: parseInt(inputs.bonbons) };
    } else if (mission.type === 'envelopes') {
      if (inputs.envelopes === undefined || inputs.envelopes === '') {
        setMessage('❌ ' + t.missions.fillAllFields);
        setTimeout(() => setMessage(''), 4000);
        return;
      }
      values = { envelopes: parseInt(inputs.envelopes) };
    }
    try {
      const res = await fetch(`${backendUrl}/api/missions/${mission.id}/complete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ values, comment: inputs.comment || '' })
      });
      if (res.ok) {
        if (mission.type === 'envelopes') {
          setShowEnvelopePopup(true);
        } else {
          setMessage('✅ ' + t.missions.missionDone);
          setTimeout(() => setMessage(''), 3000);
        }
        setMissionInputs(prev => ({ ...prev, [mission.id]: {} }));
        fetchMissions();
      } else {
        const err = await res.json();
        setMessage(`Erro: ${err.detail || 'Erreur'}`);
        setTimeout(() => setMessage(''), 5000);
      }
    } catch (error) {
      setMessage(`Erro: ${error.message}`);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  useEffect(() => {
    if (adminAccess && currentSection === 'payments') {
      fetchMissions();
    }
  }, [adminAccess, currentSection]);

  // Note : la validation des dates de fermeture est gérée côté backend
  // via la collection closed_dates (Super Admin peut en ajouter/retirer).
  // Le frontend affiche les dates fermées grisées dans le calendrier.

  // Charger les services et produits UNE SEULE FOIS au démarrage
  useEffect(() => {
    fetchServices();
    fetchProducts();
    fetchClosedDates();
    fetchBarbers();
  }, []); // Dépendances vides = exécuté une seule fois

  // Charger les données admin quand l'accès admin change
  useEffect(() => {
    if (adminAccess || weakAdminAccess) {
      fetchAppointments();
    }
  }, [adminAccess, weakAdminAccess]);

  // Charger les paiements quand on accède à la section paiements en mode admin
  useEffect(() => {
    if (adminAccess && currentSection === 'payments') {
      fetchPayments();
      fetchPaymentStats();
      fetchAvailableMonths();
    }
  }, [adminAccess, currentSection]);

  // Gestionnaire de raccourcis clavier admin (séparé pour éviter les re-rendus)
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.ctrlKey && event.altKey && event.key.toLowerCase() === 'l') {
        const handleSecondKey = (secondEvent) => {
          if (secondEvent.key.toLowerCase() === 'm') {
            secondEvent.preventDefault();
            // Ouvrir la même modal masquée que le logo lotus (saisie type=password)
            setShowAdminPanel(true);
            document.removeEventListener('keydown', handleSecondKey);
          }
        };
        
        document.addEventListener('keydown', handleSecondKey);
        setTimeout(() => {
          document.removeEventListener('keydown', handleSecondKey);
        }, 1000);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []); // Dépendances vides - n'a pas besoin de re-créer

  // Fermer le calendrier quand on clique en dehors
  useEffect(() => {
    if (!showCalendar) return; // Ne pas ajouter de listener si calendrier fermé
    
    const handleClickOutside = (event) => {
      if (!event.target.closest('.calendar-overlay') && !event.target.closest('.date-selector-btn')) {
        setShowCalendar(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showCalendar]);
  // Charger les paiements mensuels quand un mois est sélectionné
  useEffect(() => {
    if (selectedMonth) {
      fetchMonthlyPayments(selectedMonth);
    }
  }, [selectedMonth]);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/services`);
      const data = await response.json();
      setServices(data);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/products`);
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchShopProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/products/shop/visible`);
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching shop products:', error);
    } finally {
      setLoading(false);
    }
  };

  // Charger les dates de fermeture du salon (jours bloqués pour réservation)
  const fetchClosedDates = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/closed-dates`);
      const data = await response.json();
      setClosedDates(data.closed_dates || []);
    } catch (error) {
      console.error('Error fetching closed dates:', error);
      setClosedDates([]);
    }
  };

  // Charger la liste des prestataires (Carlos / Segundo / Cabeleireira)
  const fetchBarbers = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/barbers`);
      const data = await response.json();
      setBarbers(data.barbers || []);
    } catch (error) {
      console.error('Error fetching barbers:', error);
      setBarbers([]);
    }
  };

  // Ajouter une date de fermeture (Admin)
  const addClosedDate = async () => {
    if (!newClosedDate) {
      setMessage('Selecione uma data');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    try {
      const response = await fetch(`${backendUrl}/api/closed-dates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date: newClosedDate }),
      });
      if (response.ok) {
        setNewClosedDate('');
        await fetchClosedDates();
        setMessage('✅ Data adicionada');
        setTimeout(() => setMessage(''), 3000);
      } else {
        const err = await response.json();
        setMessage(err.detail || 'Erro ao adicionar data');
        setTimeout(() => setMessage(''), 4000);
      }
    } catch (error) {
      console.error('Error adding closed date:', error);
      setMessage('Erro ao adicionar data');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  // Supprimer une date de fermeture (Admin)
  const removeClosedDate = async (date) => {
    if (!window.confirm(`Remover a data de fechamento ${date} ?`)) return;
    try {
      const response = await fetch(`${backendUrl}/api/closed-dates/${date}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        await fetchClosedDates();
        setMessage('✅ Data removida');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('Erro ao remover data');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      console.error('Error removing closed date:', error);
      setMessage('Erro ao remover data');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  // Fonction pour gérer les taps sur le logo (5 taps = mode admin)
  const handleLogoTap = () => {
    // Augmenter le compteur
    const newCount = logoTapCount + 1;
    setLogoTapCount(newCount);
    
    // Réinitialiser le timer existant
    if (logoTapTimer) {
      clearTimeout(logoTapTimer);
    }
    
    // Si 5 taps, ouvrir le formulaire admin
    if (newCount >= 5) {
      setShowAdminPanel(true);
      setLogoTapCount(0);
      setLogoTapTimer(null);
    } else {
      // Sinon, créer un nouveau timer de 2 secondes pour réinitialiser
      const timer = setTimeout(() => {
        setLogoTapCount(0);
      }, 2000);
      setLogoTapTimer(timer);
    }
  };


  // Supprimer un rendez-vous (Super Admin uniquement)
  const deleteAppointment = async (appointment) => {
    if (!superAdminAccess) return;
    const confirmMsg = `Eliminar definitivamente o agendamento de ${appointment.client_name} em ${appointment.appointment_date} às ${appointment.appointment_time} ?\n\nEsta ação não pode ser desfeita.`;
    if (!window.confirm(confirmMsg)) return;
    try {
      const response = await fetch(`${backendUrl}/api/appointments/${appointment.id}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        await fetchAppointments();
        setMessage('✅ Agendamento eliminado');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('Erro ao eliminar o agendamento');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      console.error('Error deleting appointment:', error);
      setMessage('Erro ao eliminar o agendamento');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const fetchAppointments = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/appointments`);
      const data = await response.json();
      setAppointments(data);
    } catch (error) {
      console.error('Error fetching appointments:', error);
    }
  };

  // Recherche de clients pour auto-complétion (uniquement en mode Admin)
  const searchClients = async (query) => {
    if (!adminAccess || !query || query.length < 2) {
      setClientSuggestions([]);
      setShowClientSuggestions(false);
      return;
    }
    
    try {
      const response = await fetch(`${backendUrl}/api/clients/search?q=${encodeURIComponent(query)}`);
      const data = await response.json();
      setClientSuggestions(data);
      setShowClientSuggestions(data.length > 0);
    } catch (error) {
      console.error('Error searching clients:', error);
      setClientSuggestions([]);
    }
  };

  // Sélectionner un client depuis les suggestions
  const selectClient = (client) => {
    setPaymentForm({
      ...paymentForm,
      client_name: client.name,
      client_email: client.email || '',
      client_phone: client.phone || ''
    });
    setShowClientSuggestions(false);
    setClientSuggestions([]);
  };

  // Recherche de clients pour les rendez-vous (Admin uniquement)
  const searchClientsForAppointment = async (query) => {
    if (!adminAccess || !query || query.length < 2) {
      setAppointmentClientSuggestions([]);
      setShowAppointmentClientSuggestions(false);
      return;
    }
    
    try {
      const response = await fetch(`${backendUrl}/api/clients/search?q=${encodeURIComponent(query)}`);
      const data = await response.json();
      setAppointmentClientSuggestions(data);
      setShowAppointmentClientSuggestions(data.length > 0);
    } catch (error) {
      console.error('Error searching clients for appointment:', error);
      setAppointmentClientSuggestions([]);
    }
  };

  // Sélectionner un client pour un rendez-vous
  const selectClientForAppointment = (client) => {
    // Extraire le code pays du numéro de téléphone si présent
    let phone = client.phone || '';
    let countryCode = '+351'; // Default Portugal
    
    if (phone.startsWith('+')) {
      const match = phone.match(/^(\+\d{1,3})\s*(.*)$/);
      if (match) {
        countryCode = match[1];
        phone = match[2];
      }
    }
    
    setPhoneCountryCode(countryCode);
    setAppointmentForm({
      ...appointmentForm,
      client_name: client.name,
      client_email: client.email || '',
      client_phone: phone
    });
    setShowAppointmentClientSuggestions(false);
    setAppointmentClientSuggestions([]);
  };

  const fetchAvailableTimes = async (date) => {
    try {
      console.log('Fetching available times for date:', date);
      const response = await fetch(`${backendUrl}/api/available-times/${date}`);
      const data = await response.json();
      console.log('Available times received:', data.available_times);
      setAvailableTimes(data.available_times || []);
    } catch (error) {
      console.error('Error fetching available times:', error);
      setAvailableTimes([]);
    }
  };

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();
    
    // Validation côté client avant envoi
    if (!appointmentForm.client_name.trim()) {
      setMessage('Nome é obrigatório');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    if (!appointmentForm.client_email.trim()) {
      setMessage('Email é obrigatório');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    if (!appointmentForm.client_phone.trim()) {
      setMessage('Telefone é obrigatório');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    if (!appointmentForm.service_id) {
      setMessage('Escolha um serviço');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    if (!appointmentForm.appointment_date) {
      setMessage('Selecione uma data');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    if (!appointmentForm.appointment_time) {
      setMessage('Selecione um horário');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    setLoading(true);
    try {
      // Ajouter la langue du client au rendez-vous et combiner indicatif + numéro
      const fullPhoneNumber = `${phoneCountryCode} ${appointmentForm.client_phone}`;
      const appointmentData = {
        ...appointmentForm,
        client_phone: fullPhoneNumber,
        client_language: currentLang // Langue sélectionnée par le client
      };
      
      const response = await fetch(`${backendUrl}/api/appointments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(appointmentData),
      });

      if (response.ok) {
        // Afficher la modale de confirmation
        setShowConfirmationModal(true);
        
        // Réinitialiser le formulaire
        setAppointmentForm({
          client_name: '',
          client_email: '',
          client_phone: '',
          service_id: '',
          appointment_date: '',
          appointment_time: '',
          notes: ''
        });
        setAvailableTimes([]);
      } else {
        const errorData = await response.json();
        setMessage(errorData.detail || t.appointment.error);
        setTimeout(() => setMessage(''), 5000);
      }
    } catch (error) {
      console.error('Error submitting appointment:', error);
      setMessage(t.appointment.error);
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  // Composant Calendrier admin pour afficher les rendez-vous
  const renderAdminCalendar = () => {
    const monthNames = t.appointment.calendar.months;
    
    const dayNames = t.appointment.calendar.days;
    
    const year = adminCalendarMonth.getFullYear();
    const month = adminCalendarMonth.getMonth();
    
    // Premier jour du mois
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    
    const days = [];
    const currentDate = new Date(startDate);
    
    // Générer 42 jours (6 semaines)
    for (let i = 0; i < 42; i++) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    // Fonction pour obtenir les rendez-vous d'une date (sans problème de timezone)
    const getAppointmentsForDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const dateString = `${year}-${month}-${day}`;
      // Retourner TOUS les rendez-vous, y compris les annulés
      return appointments.filter(apt => apt.appointment_date === dateString);
    };
    
    return (
      <div className="admin-calendar-container">
        <div className="admin-calendar-header">
          <button 
            type="button"
            className="calendar-nav"
            onClick={() => {
              const newMonth = new Date(adminCalendarMonth);
              newMonth.setMonth(newMonth.getMonth() - 1);
              setAdminCalendarMonth(newMonth);
            }}
          >
            ‹
          </button>
          <h3>{monthNames[month]} {year}</h3>
          <button 
            type="button"
            className="calendar-nav"
            onClick={() => {
              const newMonth = new Date(adminCalendarMonth);
              newMonth.setMonth(newMonth.getMonth() + 1);
              setAdminCalendarMonth(newMonth);
            }}
          >
            ›
          </button>
        </div>
        
        <div className="calendar-days-header">
          {(isMobile ? t.appointment.calendar.daysShort : dayNames).map((day, index) => (
            <div key={index} className="calendar-day-header">{day}</div>
          ))}
        </div>
        
        <div className="admin-calendar-grid">
          {days.map((day, index) => {
            const isCurrentMonth = day.getMonth() === month;
            const isToday = day.toDateString() === new Date().toDateString();
            const dayAppointments = getAppointmentsForDate(day);
            const hasAppointments = dayAppointments.length > 0;
            const isSelected = selectedAdminDate && day.toDateString() === selectedAdminDate.toDateString();
            
            // Calculer les compteurs par statut
            const confirmedCount = dayAppointments.filter(apt => apt.status === 'confirmed').length;
            const pendingCount = dayAppointments.filter(apt => apt.status === 'pending').length;
            
            return (
              <div
                key={index}
                className={`admin-calendar-day ${isCurrentMonth ? 'current-month' : 'other-month'} 
                           ${isToday ? 'today' : ''} 
                           ${hasAppointments ? 'has-appointments' : ''} 
                           ${isSelected ? 'selected' : ''}`}
                onClick={() => {
                  if (isCurrentMonth) {
                    setSelectedAdminDate(day);
                  }
                }}
              >
                <span className="day-number">{day.getDate()}</span>
                {hasAppointments && (
                  <div className="appointment-indicators">
                    {confirmedCount > 0 && (
                      <span className="appointment-count confirmed">{confirmedCount}</span>
                    )}
                    {pendingCount > 0 && (
                      <span className="appointment-count pending">{pendingCount}</span>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Composant Calendrier personnalisé pour la sélection de date
  const renderCalendar = () => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Minuit aujourd'hui
    const maxDate = new Date(today);
    maxDate.setMonth(today.getMonth() + 3); // 3 mois maximum
    
    // Utiliser les traductions pour les mois et jours
    const monthNames = t.appointment.calendar.months;
    const dayNames = t.appointment.calendar.days;
    const daysShort = t.appointment.calendar.daysShort;
    
    const year = currentCalendarMonth.getFullYear();
    const month = currentCalendarMonth.getMonth();
    
    // Premier jour du mois
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    
    const days = [];
    const currentDate = new Date(startDate);
    
    // Générer 42 jours (6 semaines)
    for (let i = 0; i < 42; i++) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    const canGoBack = currentCalendarMonth > today;
    const canGoForward = currentCalendarMonth < maxDate;
    
    return (
      <div className={`calendar-popup ${isMobile ? 'mobile-calendar' : ''}`}>
        <div className="calendar-header">
          <button 
            type="button"
            className="calendar-nav"
            onClick={() => {
              const newMonth = new Date(currentCalendarMonth);
              newMonth.setMonth(newMonth.getMonth() - 1);
              setCurrentCalendarMonth(newMonth);
            }}
            disabled={!canGoBack}
          >
            ‹
          </button>
          <h3>{monthNames[month]} {year}</h3>
          <button 
            type="button"
            className="calendar-nav"
            onClick={() => {
              const newMonth = new Date(currentCalendarMonth);
              newMonth.setMonth(newMonth.getMonth() + 1);
              setCurrentCalendarMonth(newMonth);
            }}
            disabled={!canGoForward}
          >
            ›
          </button>
        </div>
        
        <div className="calendar-days-header">
          {(isMobile ? daysShort : dayNames).map((day, index) => (
            <div key={index} className="calendar-day-header">{day}</div>
          ))}
        </div>
        
        <div className="calendar-grid">
          {days.map((day, index) => {
            const isCurrentMonth = day.getMonth() === month;
            const isToday = day.toDateString() === today.toDateString();
            const isPast = day < today;
            // Calculer la date au format YYYY-MM-DD (sans timezone shift)
            const dayYear = day.getFullYear();
            const dayMonth = String(day.getMonth() + 1).padStart(2, '0');
            const dayNum = String(day.getDate()).padStart(2, '0');
            const dateStr = `${dayYear}-${dayMonth}-${dayNum}`;
            const isClosed = closedDates.includes(dateStr);
            const isSelected = appointmentForm.appointment_date === dateStr;
            const isDisabled = isPast || !isCurrentMonth || day > maxDate || isClosed;
            
            return (
              <button
                key={index}
                type="button"
                className={`calendar-day ${isCurrentMonth ? 'current-month' : 'other-month'} 
                           ${isToday ? 'today' : ''} 
                           ${isPast ? 'past' : ''} 
                           ${isClosed ? 'closed' : ''} 
                           ${isSelected ? 'selected' : ''} 
                           ${isDisabled ? 'disabled' : 'available'}`}
                title={isClosed ? t.appointment.calendar.closed : ''}
                onClick={() => {
                  if (!isDisabled) {
                    setAppointmentForm({
                      ...appointmentForm, 
                      appointment_date: dateStr,
                      appointment_time: ''
                    });
                    fetchAvailableTimes(dateStr);
                    setShowCalendar(false);
                  }
                }}
                disabled={isDisabled}
              >
                {day.getDate()}
              </button>
            );
          })}
        </div>
        
        <div className="calendar-legend">
          <div className="legend-item">
            <span className="legend-color available"></span>
            <span>{t.appointment.calendar.available}</span>
          </div>
          <div className="legend-item">
            <span className="legend-color weekend"></span>
            <span>{t.appointment.calendar.alwaysOpen}</span>
          </div>
          <div className="legend-item">
            <span className="legend-color selected"></span>
            <span>{t.appointment.calendar.selected}</span>
          </div>
        </div>
        
        <div className="calendar-footer">
          <button 
            type="button" 
            className="calendar-close"
            onClick={() => setShowCalendar(false)}
          >
            {t.appointment.calendar.close}
          </button>
        </div>
      </div>
    );
  };

  // Fonction pour changer le statut d'un rendez-vous
  const updateAppointmentStatus = async (appointmentId, newStatus) => {
    try {
      const response = await fetch(`${backendUrl}/api/appointments/${appointmentId}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (response.ok) {
        // Recharger les rendez-vous après la mise à jour
        fetchAppointments();
        console.log(`✅ Appointment ${appointmentId} status updated to ${newStatus}`);
      } else {
        console.error('Error updating appointment status');
      }
    } catch (error) {
      console.error('Error updating appointment status:', error);
    }
  };

  // Fonctions pour les paiements
  const fetchPayments = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/payments`);
      if (response.ok) {
        const data = await response.json();
        setPayments(data);
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
    }
  };

  const fetchPaymentStats = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/payments/stats`);
      if (response.ok) {
        const data = await response.json();
        setPaymentStats(data);
      }
    } catch (error) {
      console.error('Error fetching payment stats:', error);
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validation des champs requis
    if (!paymentForm.client_name || !paymentForm.service_id || !paymentForm.payment_date || !paymentForm.payment_time) {
      setMessage('Veuillez remplir tous les champs obligatoires');
      setLoading(false);
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    // Validation : prestataire obligatoire
    if (!paymentForm.barber) {
      setMessage('⚠️ Selecione um barbeiro');
      setLoading(false);
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    // Validation : méthode de paiement obligatoire
    if (!paymentForm.payment_method) {
      setMessage('⚠️ Escolha o método de pagamento');
      setLoading(false);
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    // Valider que le montant est un nombre valide
    const amount = parseFloat(paymentForm.amount);
    if (isNaN(amount) || amount <= 0) {
      setMessage('Le montant doit être supérieur à 0');
      setLoading(false);
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    // Vérifier si le montant diffère du prix de base du service
    const selectedService = getServiceById(paymentForm.service_id);
    const basePrice = selectedService?.price || 0;
    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
    const expectedTotal = basePrice + productsTotal;
    
    // Si le montant est différent du total attendu, exiger un commentaire
    if (Math.abs(amount - expectedTotal) > 0.01 && (!paymentForm.notes || paymentForm.notes.trim() === '')) {
      setMessage('⚠️ Le montant diffère du prix de base. Veuillez ajouter un commentaire pour justifier ce changement.');
      setLoading(false);
      setTimeout(() => setMessage(''), 5000);
      return;
    }

    // Convert amount to number, include products sold, and combine phone with country code
    const fullPaymentPhone = paymentForm.client_phone ? `${paymentPhoneCountryCode} ${paymentForm.client_phone}` : '';
    const paymentData = {
      ...paymentForm,
      client_phone: fullPaymentPhone,
      amount: amount,
      tips: parseFloat(paymentForm.tips) || 0,  // Convertir tips en nombre
      products_sold: selectedProducts
    };

    console.log('📤 Sending payment data:', paymentData);

    try {
      const response = await fetch(`${backendUrl}/api/payments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(paymentData),
      });

      if (response.ok) {
        const result = await response.json();
        setMessage('Pagamento guardado com sucesso!');
        setPaymentForm({
          client_name: '',
          client_email: '',
          client_phone: '',
          service_id: '',
          amount: '',
          tips: '',  // Réinitialiser les tips
          payment_method: '',  // Vide pour forcer la sélection
          barber: '',  // Réinitialiser le prestataire
          appointment_id: '',
          payment_date: new Date().toISOString().split('T')[0],
          payment_time: new Date().toTimeString().slice(0, 5),
          notes: ''
        });
        setSelectedProducts([]); // Réinitialiser les produits sélectionnés
        
        // Rafraîchir toutes les données
        fetchPayments();
        fetchPaymentStats();
        fetchProducts(); // Recharger les produits pour avoir les stocks mis à jour
        fetchAvailableMonths(); // Recharger les mois disponibles
        fetchAppointments(); // Rafraîchir les rendez-vous pour mettre à jour le statut "payé"
        
        // Rafraîchir les paiements du mois en cours
        if (selectedMonth) {
          const [year, month] = selectedMonth.split('-');
          fetchMonthlyPayments(selectedMonth);
        }
        
        setPaymentViewMode('dashboard'); // Retourner au dashboard après sauvegarde
        setTimeout(() => setMessage(''), 3000);
        console.log('✅ Payment saved successfully:', result);
      } else {
        const errorData = await response.json();
        console.error('❌ Error response:', errorData);
        
        // Gérer les erreurs de validation Pydantic (422)
        if (Array.isArray(errorData.detail)) {
          const errorMessages = errorData.detail.map(err => `${err.loc.join('.')}: ${err.msg}`).join(', ');
          setMessage(`Erro de validação: ${errorMessages}`);
        } else if (typeof errorData.detail === 'string') {
          setMessage(`Erro: ${errorData.detail}`);
        } else {
          setMessage('Erro ao guardar pagamento');
        }
        
        setTimeout(() => setMessage(''), 5000);
      }
    } catch (error) {
      console.error('❌ Error creating payment:', error);
      setMessage(`Erro: ${error.message || 'Erro de conexão'}`);
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour éditer un paiement existant (Super Admin uniquement)
  const handleEditPayment = (payment) => {
    setEditingPayment(payment);
    setPaymentForm({
      client_name: payment.client_name || '',
      client_email: payment.client_email || '',
      client_phone: payment.client_phone || '',
      service_id: payment.service_id || '',
      amount: payment.amount || 0,
      tips: payment.tips || '',  // Charger les tips existants
      payment_method: payment.payment_method || 'cash',
      barber: payment.barber || '',  // Charger le prestataire existant (vide pour paiements historiques)
      payment_date: payment.payment_date || '',
      payment_time: payment.payment_time || '',
      notes: payment.notes || '',
      appointment_id: payment.appointment_id || ''
    });
    // S'assurer que products_sold est un tableau avec des total_price valides
    const productsSold = (payment.products_sold || []).map(p => ({
      ...p,
      total_price: p.total_price || (p.unit_price * p.quantity) || 0
    }));
    setSelectedProducts(productsSold);
    setShowEditModal(true);
  };

  // Suppression d'un paiement (Super Admin) avec confirmation
  const handleDeletePayment = async (payment) => {
    if (!window.confirm(t.payments.confirmDelete)) return;
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/${payment.id}`, { method: 'DELETE' });
      if (response.ok) {
        setMessage('✅ ' + t.payments.paymentDeleted);
        if (selectedMonth) fetchMonthlyPayments(selectedMonth);
        fetchAvailableMonths();
        if (viewMode === 'daily' && selectedDate) fetchDailyStats(selectedDate);
        setTimeout(() => setMessage(''), 3000);
      } else {
        const errorData = await response.json();
        setMessage(`Erro: ${errorData.detail || 'Erreur lors de la suppression'}`);
        setTimeout(() => setMessage(''), 5000);
      }
    } catch (error) {
      setMessage(`Erro: ${error.message || 'Erro de conexão'}`);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validation: si le montant diffère du prix de base, exiger un commentaire
    const selectedService = getServiceById(paymentForm.service_id);
    const basePrice = selectedService?.price || 0;
    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
    const expectedTotal = basePrice + productsTotal;
    const currentAmount = parseFloat(paymentForm.amount) || 0;
    
    if (Math.abs(currentAmount - expectedTotal) > 0.01 && (!paymentForm.notes || paymentForm.notes.trim() === '')) {
      setMessage(t.payments.priceModifiedError);
      setLoading(false);
      setTimeout(() => setMessage(''), 5000);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/${editingPayment.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...paymentForm,
          tips: parseFloat(paymentForm.tips) || 0,  // Convertir tips en nombre
          products_sold: selectedProducts
        })
      });

      if (response.ok) {
        setMessage('✅ Paiement modifié avec succès!');
        setShowEditModal(false);
        setEditingPayment(null);
        if (selectedMonth) fetchMonthlyPayments(selectedMonth);
        if (viewMode === 'daily' && selectedDate) fetchDailyStats(selectedDate);
        setTimeout(() => setMessage(''), 3000);
      } else {
        const errorData = await response.json();
        setMessage(`Erro: ${errorData.detail || 'Erreur lors de la modification'}`);
        setTimeout(() => setMessage(''), 5000);
      }
    } catch (error) {
      console.error('❌ Error updating payment:', error);
      setMessage(`Erro: ${error.message || 'Erro de conexão'}`);
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  const selectClientFromAppointment = (appointment) => {
    setPaymentForm({
      ...paymentForm,
      client_name: appointment.client_name,
      client_email: appointment.client_email,
      client_phone: appointment.client_phone,
      appointment_id: appointment.id,
      service_id: appointment.service_id,
      amount: getServiceById(appointment.service_id)?.price || ''
    });
  };

  const getServiceById = (serviceId) => {
    return services.find(service => service.id === serviceId);
  };

  // Fonction pour traduire le nom du service selon la langue
  const translateServiceName = (serviceName) => {
    return t.services.serviceNames[serviceName] || serviceName;
  };

  // Fonction pour traduire la description du service selon la langue
  const translateServiceDescription = (serviceName) => {
    return t.services.serviceDescriptions[serviceName] || serviceName;
  };

  // Fonction pour rediriger vers paiements avec les infos du client pré-remplies
  const redirectToPaymentWithClient = (appointment) => {
    // Pré-remplir le formulaire de paiement
    setPaymentForm({
      client_name: appointment.client_name,
      client_email: appointment.client_email || '',
      client_phone: appointment.client_phone || '',
      service_id: appointment.service_id,
      amount: getServiceById(appointment.service_id)?.price || 0,
      tips: '',
      payment_method: '', // L'utilisateur DOIT choisir le moyen de paiement
      barber: '',  // L'utilisateur DOIT sélectionner le prestataire au moment de l'encaissement
      appointment_id: appointment.id,
      payment_date: appointment.appointment_date,
      payment_time: appointment.appointment_time,
      notes: ''
    });
    
    // Changer vers la section paiements en mode formulaire
    setCurrentSection('payments');
    setPaymentViewMode('new'); // Changé de 'form' à 'new'
  };

  // Fonctions pour gérer les produits vendus
  const addProduct = (productId) => {
    const product = products.find(p => p.id === productId);
    if (!product) return;

    // Vérifier si le produit est déjà dans la liste
    const existingProduct = selectedProducts.find(p => p.product_id === productId);
    
    if (existingProduct) {
      // Augmenter la quantité
      setSelectedProducts(selectedProducts.map(p => 
        p.product_id === productId 
          ? { ...p, quantity: p.quantity + 1, total_price: (p.quantity + 1) * p.unit_price }
          : p
      ));
    } else {
      // Ajouter nouveau produit
      setSelectedProducts([...selectedProducts, {
        product_id: product.id,
        product_name: product.name,
        quantity: 1,
        unit_price: product.price,
        total_price: product.price
      }]);
    }
  };

  const removeProduct = (productId) => {
    setSelectedProducts(selectedProducts.filter(p => p.product_id !== productId));
  };

  const updateProductQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeProduct(productId);
      return;
    }
    
    setSelectedProducts(selectedProducts.map(p => 
      p.product_id === productId 
        ? { ...p, quantity: quantity, total_price: quantity * p.unit_price }
        : p
    ));
  };

  // Mettre à jour le montant total quand les produits ou le service changent
  useEffect(() => {
    const servicePrice = paymentForm.service_id ? (getServiceById(paymentForm.service_id)?.price || 0) : 0;
    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
    const total = servicePrice + productsTotal;
    
    // Toujours mettre à jour, même si vide au départ
    setPaymentForm(prev => ({ ...prev, amount: total }));
  }, [selectedProducts, paymentForm.service_id]);

  // Fonctions pour les onglets mensuels
  const fetchAvailableMonths = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/payments/months`);
      if (response.ok) {
        const months = await response.json();
        setAvailableMonths(months);
        // Sélectionner le mois actuel par défaut
        if (months.length > 0 && !selectedMonth) {
          setSelectedMonth(months[0].key);
        }
      }
    } catch (error) {
      console.error('Error fetching available months:', error);
    }
  };

  const fetchMonthlyPayments = async (monthKey) => {
    try {
      const [year, month] = monthKey.split('-');
      const response = await fetch(`${backendUrl}/api/payments/monthly/${year}/${parseInt(month)}`);
      if (response.ok) {
        const data = await response.json();
        setMonthlyPayments(data.payments);
        setMonthlyStats(data);
      }
    } catch (error) {
      console.error('Error fetching monthly payments:', error);
    }
  };

  const fetchDailyStats = async (date) => {
    try {
      const response = await fetch(`${backendUrl}/api/payments/daily/${date}`);
      if (response.ok) {
        const data = await response.json();
        setDailyStats(data);
      }
    } catch (error) {
      console.error('Error fetching daily stats:', error);
    }
  };

  // SUPPRIMÉ : cleanupOldPayments() effaçait automatiquement les paiements de plus de 3 mois.
  // L'historique complet des paiements est désormais conservé indéfiniment.

  const galleryImages = [
    "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxiYXJiZXIlMjBzaG9wfGVufDB8fHxibGFja3wxNzUyNjU3NzI1fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1517832606299-7ae9b720a186?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxiYXJiZXIlMjBzaG9wfGVufDB8fHxibGFja3wxNzUyNjU3NzI1fDA&ixlib=rb-4.1.0&q=85",
    "https://customer-assets.emergentagent.com/job_7834511f-e5c5-4120-ac57-59ea807e7b09/artifacts/5w70fhsq_Design%20sans%20titre.png",
    "https://images.unsplash.com/photo-1653875700322-cf550d9a52ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxiYXJiZXJpbmd8ZW58MHx8fGJsYWNrfDE3NTI2NTc3MzR8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1588778851773-cb9d7656d9c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxiYXJiZXJpbmd8ZW58MHx8fGJsYWNrfDE3NTI2NTc3MzR8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1596513057998-040d410e4623?w=800&q=85",
    "https://images.unsplash.com/photo-1520336811552-42878b67d25f?w=800&q=85",
    "https://images.unsplash.com/photo-1619233543640-af09c173763b?w=800&q=85"
  ];

  const renderHome = () => (
    <div className="home-section">
      {/* Hero Section */}
      <section className="hero-section luxury-hero">
        <div className="hero-overlay"></div>

        {/* Contenu principal */}
        <div className="hero-content luxury-content">
          
          {/* Logo Mafi Barber Paris - Logo principal blanc */}
          <div className="hero-brand-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_salon-catalog/artifacts/wvlwh9bx_ChatGPT%20Image%2020%20janv.%202026%2C%2014_39_29.png" 
              alt="Mafi Barber Paris" 
              className="brand-logo-img"
            />
          </div>
          
          <p className="hero-domicile-note" data-testid="hero-domicile-note">
            {currentLang === 'pt' && 'Para qualquer serviço ao domicílio, eventos, casamentos, batizados,... entre em contato connosco !'}
            {currentLang === 'fr' && 'Pour tout service à domicile, événements, mariages, baptêmes,... contactez-nous !'}
            {currentLang === 'en' && 'For any home service, events, weddings, christenings,... contact us!'}
            {currentLang === 'es' && 'Para cualquier servicio a domicilio, eventos, bodas, bautizos,... ¡contáctenos!'}
          </p>
          
          <p className="hero-tagline luxury-tagline">
            {currentLang === 'pt' && 'A excelência ao serviço do seu estilo'}
            {currentLang === 'fr' && 'L\'excellence au service de votre style'}
            {currentLang === 'en' && 'Excellence in the service of your style'}
            {currentLang === 'es' && 'La excelencia al servicio de su estilo'}
          </p>
          
          {/* Boutons d'action - AVANT la description */}
          <div className="hero-buttons">
            <button 
              className="hero-cta primary-cta"
              onClick={() => setCurrentSection('appointment')}
            >
              <span className="cta-icon">✂</span>
              {currentLang === 'pt' && 'Agendar Agora'}
              {currentLang === 'fr' && 'Prendre Rendez-vous'}
              {currentLang === 'en' && 'Book Now'}
              {currentLang === 'es' && 'Reservar Ahora'}
            </button>
            <button 
              className="hero-cta secondary-cta"
              onClick={() => setCurrentSection('services')}
            >
              <span className="cta-icon">👑</span>
              {currentLang === 'pt' && 'Nossos Serviços'}
              {currentLang === 'fr' && 'Nos Services'}
              {currentLang === 'en' && 'Our Services'}
              {currentLang === 'es' && 'Nuestros Servicios'}
            </button>
          </div>

          <p className="hero-description luxury-description">
            {currentLang === 'pt' && 'Descubra a arte da barbearia tradicional aliada às técnicas modernas. Um serviço excepcional num ambiente refinado em Chaves, Portugal.'}
            {currentLang === 'fr' && 'Découvrez l\'art du barbier traditionnel allié aux techniques modernes. Un service d\'exception dans un cadre raffiné à Chaves, Portugal.'}
            {currentLang === 'en' && 'Discover the art of traditional barbering combined with modern techniques. Exceptional service in a refined setting in Chaves, Portugal.'}
            {currentLang === 'es' && 'Descubra el arte de la barbería tradicional combinado con técnicas modernas. Un servicio excepcional en un ambiente refinado en Chaves, Portugal.'}
          </p>

          {/* Canaux de contact privilégiés */}
          <div className="contact-channels">
            <p className="channels-title">
              {currentLang === 'pt' && 'Contacte-nos'}
              {currentLang === 'fr' && 'Contactez-nous'}
              {currentLang === 'en' && 'Contact us'}
              {currentLang === 'es' && 'Contáctenos'}
            </p>
            <div className="channels-list">
              <a href="tel:+351924719857" className="channel-item">
                <Phone size={20} strokeWidth={1.5} />
                <span>
                  {currentLang === 'pt' && 'Telefone'}
                  {currentLang === 'fr' && 'Téléphone'}
                  {currentLang === 'en' && 'Phone'}
                  {currentLang === 'es' && 'Teléfono'}
                </span>
              </a>
              <a href="https://wa.me/351924719857?text=Olá! Gostaria de mais informações sobre os vossos serviços." target="_blank" rel="noopener noreferrer" className="channel-item">
                <MessageCircle size={20} strokeWidth={1.5} />
                <span>WhatsApp</span>
              </a>
              <a href="https://instagram.com/mafi.barber" target="_blank" rel="noopener noreferrer" className="channel-item">
                <Instagram size={20} strokeWidth={1.5} />
                <span>Instagram</span>
              </a>
            </div>
          </div>

          {/* Caractéristiques */}
          <div className="hero-features">
            <div className="feature-item">
              <div className="feature-icon"><Star size={24} strokeWidth={1.5} /></div>
              <div className="feature-text">
                <strong>
                  {currentLang === 'pt' && 'EXCELÊNCIA'}
                  {currentLang === 'fr' && 'EXCELLENCE'}
                  {currentLang === 'en' && 'EXCELLENCE'}
                  {currentLang === 'es' && 'EXCELENCIA'}
                </strong>
                <span>
                  {currentLang === 'pt' && 'Serviço Premium'}
                  {currentLang === 'fr' && 'Service Premium'}
                  {currentLang === 'en' && 'Premium Service'}
                  {currentLang === 'es' && 'Servicio Premium'}
                </span>
              </div>
            </div>
            <div className="feature-divider">|</div>
            <div className="feature-item">
              <div className="feature-icon"><Scissors size={24} strokeWidth={1.5} /></div>
              <div className="feature-text">
                <strong>
                  {currentLang === 'pt' && 'PERÍCIA'}
                  {currentLang === 'fr' && 'EXPERTISE'}
                  {currentLang === 'en' && 'EXPERTISE'}
                  {currentLang === 'es' && 'PERICIA'}
                </strong>
                <span>
                  {currentLang === 'pt' && 'Barbeiros Qualificados'}
                  {currentLang === 'fr' && 'Barbiers Qualifiés'}
                  {currentLang === 'en' && 'Qualified Barbers'}
                  {currentLang === 'es' && 'Barberos Cualificados'}
                </span>
              </div>
            </div>
            <div className="feature-divider">|</div>
            <div className="feature-item">
              <div className="feature-icon"><Award size={24} strokeWidth={1.5} /></div>
              <div className="feature-text">
                <strong>
                  {currentLang === 'pt' && 'PRESTÍGIO'}
                  {currentLang === 'fr' && 'PRESTIGE'}
                  {currentLang === 'en' && 'PRESTIGE'}
                  {currentLang === 'es' && 'PRESTIGIO'}
                </strong>
                <span>
                  {currentLang === 'pt' && 'Ambiente Luxuoso'}
                  {currentLang === 'fr' && 'Ambiance Luxueuse'}
                  {currentLang === 'en' && 'Luxurious Atmosphere'}
                  {currentLang === 'es' && 'Ambiente Lujoso'}
                </span>
              </div>
            </div>
          </div>

          <div className="hero-ornament-bottom">⚜</div>
        </div>

        {/* Effets de fumée sur les côtés */}
        <div className="smoke-container">
          <div className="smoke smoke-left smoke-1"></div>
          <div className="smoke smoke-left smoke-2"></div>
          <div className="smoke smoke-left smoke-3"></div>
          <div className="smoke smoke-right smoke-4"></div>
          <div className="smoke smoke-right smoke-5"></div>
          <div className="smoke smoke-right smoke-6"></div>
        </div>

        {/* Effets visuels */}
        <div className="hero-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </section>
    </div>
  );

  const renderServices = () => {
    const categoryKeys = ['regular', 'premium', 'barbe', 'colorations', 'soins'];
    const categoryMapping = {
      'regular': 'Regular',
      'premium': 'Premium',
      'barbe': 'Barbe', 
      'colorations': 'Colorations',
      'soins': 'Soins'
    };
    
    const selectedCategory = categoryMapping[Object.keys(categoryMapping).find(key => 
      t.services.categories[key].toLowerCase() === selectedServiceCategory.toLowerCase()
    )] || selectedServiceCategory;
    
    const filteredServices = services.filter(service => 
      service.category === selectedCategory && service.name !== "Vente Seule"
    ).sort((a, b) => a.price - b.price);

    return (
      <section className="services-section">
        <div className="section-header">
          <h2 className="section-title">{t.services.title}</h2>
          <p className="section-subtitle">{t.services.subtitle}</p>
        </div>
        
        {/* Informations importantes sur les horaires et services */}
        <div className="services-info-banner">
          <div className="info-card opening-hours">
            <div className="info-icon"><Clock size={24} strokeWidth={1.5} /></div>
            <div className="info-content">
              <h4>{t.services.openingInfo.title}</h4>
              <p>{t.services.openingInfo.schedule}</p>
              <div className="info-details">
                <span className="info-tag appointment">{t.services.openingInfo.withAppointment}</span>
                <span className="info-tag walkin">{t.services.openingInfo.evening}</span>
              </div>
            </div>
          </div>
          <div className="info-card hair-wash-note">
            <div className="info-icon"><Droplets size={24} strokeWidth={1.5} /></div>
            <div className="info-content">
              <h4>{t.services.hairWashNote.title}</h4>
              <p>{t.services.hairWashNote.text}</p>
              <div style={{marginTop: '15px', paddingTop: '15px', borderTop: '1px solid rgba(201, 169, 98, 0.3)'}}>
                <h4>{t.services.lateServiceNote.title}</h4>
                <p>{t.services.lateServiceNote.text}</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Onglets des catégories */}
        <div className="service-categories">
          {categoryKeys.map((categoryKey) => (
            <button
              key={categoryKey}
              className={`category-tab ${selectedServiceCategory === categoryMapping[categoryKey] ? 'active' : ''}`}
              onClick={() => setSelectedServiceCategory(categoryMapping[categoryKey])}
            >
              {t.services.categories[categoryKey]}
            </button>
          ))}
        </div>
        
        {loading ? (
          <div className="loading">{t.services.loading}</div>
        ) : (
          <div className="services-grid">
            {filteredServices.length === 0 ? (
              <div className="no-services">
                <p>Aucun service disponible dans cette catégorie</p>
              </div>
            ) : (
              filteredServices.map((service) => (
                <div key={service.id} className="service-card">
                  <div className="service-icon">
                    {selectedCategory === 'Regular' && <Scissors size={32} strokeWidth={1} />}
                    {selectedCategory === 'Premium' && <Sparkles size={32} strokeWidth={1} />}
                    {selectedCategory === 'Barbe' && <Scissors size={32} strokeWidth={1} />}
                    {selectedCategory === 'Colorations' && <Droplets size={32} strokeWidth={1} />}
                    {selectedCategory === 'Soins' && <Sparkles size={32} strokeWidth={1} />}
                  </div>
                  <h3>{t.services.serviceNames[service.name] || service.name}</h3>
                  <p>{t.services.serviceDescriptions[service.name] || service.description}</p>
                  {/* Afficher la note sur le lavage pour les services "Coupe" */}
                  {(service.name.toLowerCase().includes('coupe') || service.name.toLowerCase().includes('cut')) && (
                    <p className="service-note-hairwash">{t.services.hairWashIncluded}</p>
                  )}
                  <div className="service-details">
                    <span className="price">€{service.price.toFixed(2)}</span>
                    <span className="duration">{service.duration} {t.services.duration}</span>
                  </div>
                  <button 
                    className="book-btn"
                    onClick={() => {
                      setAppointmentForm({...appointmentForm, service_id: service.id});
                      setCurrentSection('appointment');
                    }}
                  >
                    {t.services.book}
                  </button>
                </div>
              ))
            )}
          </div>
        )}
        
        {/* Section Extras / Suppléments */}
        <div className="services-extras-section">
          <div className="extras-content">
            <div className="extras-icon">
              <Sparkles size={28} strokeWidth={1.5} />
            </div>
            <h3 className="extras-title">{t.services.extras.title}</h3>
            <p className="extras-subtitle">{t.services.extras.subtitle}</p>
            <div className="extras-list">
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.eyebrows.name}</span>
                <span className="extra-price">{t.services.extras.items.eyebrows.price}</span>
              </div>
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.eyebrowsThread.name}</span>
                <span className="extra-price">{t.services.extras.items.eyebrowsThread.price}</span>
              </div>
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.noseHair.name}</span>
                <span className="extra-price">{t.services.extras.items.noseHair.price}</span>
              </div>
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.facialCream.name}</span>
                <span className="extra-price">{t.services.extras.items.facialCream.price}</span>
              </div>
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.facialMassage.name}</span>
                <span className="extra-price">{t.services.extras.items.facialMassage.price}</span>
              </div>
              <div className="extra-item">
                <span className="extra-dot"></span>
                <span>{t.services.extras.items.fullMassage.name}</span>
                <span className="extra-price">{t.services.extras.items.fullMassage.price}</span>
              </div>
            </div>
            <p className="extras-note">{t.services.extras.note}</p>
          </div>
        </div>
      </section>
    );
  };

  const renderAgenda = () => {
    if (!adminAccess && !weakAdminAccess) {
      return (
        <section className="agenda-section">
          <div className="section-header">
            <h2 className="section-title">🔒 Acesso Restrito</h2>
            <p className="section-subtitle">{t.agenda.adminOnly}</p>
          </div>
          <div className="access-denied">
            <p>{t.agenda.adminOnlySub}</p>
          </div>
        </section>
      );
    }

    // Trier les rendez-vous par date et heure
    const sortedAppointments = [...appointments].sort((a, b) => {
      const dateA = new Date(`${a.appointment_date}T${a.appointment_time}`);
      const dateB = new Date(`${b.appointment_date}T${b.appointment_time}`);
      return dateA - dateB;
    });

    // Grouper par date
    const appointmentsByDate = sortedAppointments.reduce((acc, appointment) => {
      const date = appointment.appointment_date;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(appointment);
      return acc;
    }, {});

    // Fonction pour formater la date
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      
      if (date.toDateString() === today.toDateString()) {
        return t.agenda.today;
      } else if (date.toDateString() === tomorrow.toDateString()) {
        return t.agenda.tomorrow;
      } else {
        return date.toLocaleDateString('pt-PT', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        });
      }
    };

    // Trouver le service associé et le traduire
    const getServiceName = (serviceId) => {
      const service = services.find(s => s.id === serviceId);
      return service ? translateServiceName(service.name) : 'Service non trouvé';
    };

    // Fonction pour afficher les détails des rendez-vous d'une date sélectionnée
    const renderSelectedDateAppointments = () => {
      if (!selectedAdminDate) return null;
      
      // Utiliser la même méthode que getAppointmentsForDate pour éviter les problèmes de timezone
      const year = selectedAdminDate.getFullYear();
      const month = String(selectedAdminDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedAdminDate.getDate()).padStart(2, '0');
      const dateString = `${year}-${month}-${day}`;
      
      // Get current date and time for comparison
      const now = new Date();
      const nowDateString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      const nowTimeString = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      
      // Helper function to determine appointment color
      const getAppointmentColorClass = (appointment) => {
        // Si annulé -> Gris (ou on pourrait les cacher)
        if (appointment.status === 'cancelled') {
          return 'cancelled';
        }
        
        // Si payé -> Bleu
        if (appointment.paid) {
          return 'paid';
        }
        
        // Si l'heure est dépassée -> Rouge
        const appointmentDateTime = `${appointment.appointment_date} ${appointment.appointment_time}`;
        const nowDateTime = `${nowDateString} ${nowTimeString}`;
        
        if (appointmentDateTime < nowDateTime) {
          return 'overdue';
        }
        
        // Sinon à venir -> Vert
        return 'upcoming';
      };
      
      // Filtrer et trier par ordre horaire (du plus tôt au plus tard)
      // Inclure TOUS les rendez-vous, y compris les annulés
      const dayAppointments = appointments
        .filter(apt => apt.appointment_date === dateString)
        .sort((a, b) => {
          // Trier par appointment_time (format HH:MM)
          return a.appointment_time.localeCompare(b.appointment_time);
        });
      
      return (
        <div className="selected-date-appointments">
          <h3>
            {t.agenda.appointmentsOnDate} {selectedAdminDate.toLocaleDateString('pt-PT', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </h3>
          
          {dayAppointments.length === 0 ? (
            <p className="no-appointments-message">{t.agenda.noAppointmentsOnDate}</p>
          ) : (
            <div className="date-appointments-list">
              {dayAppointments.map((appointment, index) => {
                const colorClass = getAppointmentColorClass(appointment);
                if (!adminAccess) {
                  // Mode Barber : lecture seule, heure + nom du client + service
                  // + numéro du client visible UNIQUEMENT si l'heure du RDV est dépassée (heure portugaise)
                  const svcFound = services.find(s => s.id === appointment.service_id);
                  const svcLabel = svcFound ? getServiceName(appointment.service_id) : (appointment.service_name || '');
                  const lisbonNow = new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' });
                  const isPastAppointment = `${appointment.appointment_date} ${appointment.appointment_time}` < lisbonNow;
                  const showPhone = isPastAppointment && appointment.client_phone && appointment.status !== 'cancelled';
                  return (
                    <div
                      key={appointment.id}
                      className={`appointment-card-mini ${appointment.status || 'pending'} ${colorClass}`}
                      data-testid={`barber-appointment-${appointment.id}`}
                      style={{ cursor: 'default' }}
                    >
                      <div className="appointment-time-mini">
                        {appointment.appointment_time}
                        {appointment.status === 'cancelled' && <span className="cancelled-indicator"> ❌</span>}
                      </div>
                      <div className="appointment-info-mini">
                        <div className="client-name-mini">{appointment.client_name}</div>
                        <div className="service-name-mini" style={{ color: '#daa520', fontSize: '0.8rem', marginTop: '2px' }}>
                          {svcLabel}
                        </div>
                        {showPhone && (
                          <div className="client-phone-mini" data-testid={`barber-phone-${appointment.id}`} style={{ marginTop: '4px' }}>
                            <a href={`tel:${appointment.client_phone}`} style={{ color: '#7fd47f', textDecoration: 'none', fontSize: '0.85rem' }}>
                              📞 {appointment.client_phone}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
                return (
                  <div 
                    key={appointment.id} 
                    className={`appointment-card-mini ${appointment.status || 'pending'} ${colorClass}`}
                    onClick={() => !appointment.paid && appointment.status !== 'cancelled' && redirectToPaymentWithClient(appointment)}
                    title={appointment.paid ? "Paiement déjà effectué" : appointment.status === 'cancelled' ? "Client non venu - Annulé" : "Cliquer para registrar pagamento"}
                    style={{ cursor: (appointment.paid || appointment.status === 'cancelled') ? 'not-allowed' : 'pointer' }}
                  >
                    <div className="appointment-time-mini">
                      {appointment.appointment_time}
                      {appointment.paid && <span className="paid-indicator"> 💳</span>}
                      {appointment.status === 'cancelled' && <span className="cancelled-indicator"> ❌</span>}
                    </div>
                    <div className="appointment-info-mini">
                      <div className="client-name-mini">{appointment.client_name}</div>
                      <div className="service-name-mini">{getServiceName(appointment.service_id)}</div>
                      {appointment.client_phone && (
                        <div className="client-phone-mini">📱 {appointment.client_phone}</div>
                      )}
                      <div className="appointment-status-mini">
                        {appointment.status === 'cancelled' ? (
                          <span className="payment-status-cancelled">❌ {t.payments.clientNoShow}</span>
                        ) : appointment.paid ? (
                          <span className="payment-status-paid">💰 Payé</span>
                        ) : (
                          <span>Status: {appointment.status === 'confirmed' ? '✅ Confirmé' : 
                                   appointment.status === 'cancelled' ? '❌ Annulé' : '⏳ En attente'}</span>
                        )}
                      </div>
                    </div>
                    {appointment.status !== 'cancelled' && <div className="payment-arrow">💰 →</div>}
                    {superAdminAccess && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteAppointment(appointment);
                        }}
                        title="Eliminar agendamento (Super Admin)"
                        data-testid={`delete-appointment-${appointment.id}`}
                        style={{
                          background: 'transparent',
                          border: '1px solid #aa4444',
                          color: '#ff6666',
                          borderRadius: '4px',
                          padding: '4px 8px',
                          marginLeft: '8px',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          lineHeight: 1,
                          alignSelf: 'center'
                        }}
                      >
                        🗑️
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    };

    return (
      <section className="agenda-section">
        <div className="section-header">
          <h2 className="section-title">
            🗓️ {t.agenda.title} 
            <span className="admin-badge">{adminAccess ? 'ADMIN' : 'BARBER'}</span>
          </h2>
          <p className="section-subtitle">{t.agenda.subtitle}</p>
        </div>

        {loading ? (
          <div className="loading">{t.agenda.loading}</div>
        ) : (
          <div className="appointments-container">
            {/* Panneau de gestion des fermetures (Super Admin uniquement) */}
            {superAdminAccess && (
            <div className="closed-dates-admin-panel" style={{
              marginBottom: '20px',
              padding: '16px 20px',
              background: '#1a1a1a',
              border: '1px solid #333',
              borderRadius: '8px'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none'
              }}
                onClick={() => setShowClosedDatesPanel(!showClosedDatesPanel)}
                data-testid="toggle-closed-dates-panel"
              >
                <h3 style={{ margin: 0, color: '#daa520', fontSize: '1rem' }}>
                  🚫 Datas de Fechamento do Salão
                  <span style={{
                    marginLeft: '10px',
                    fontSize: '0.85rem',
                    color: '#888',
                    fontWeight: 'normal'
                  }}>
                    ({closedDates.length} {closedDates.length > 1 ? 'datas' : 'data'})
                  </span>
                </h3>
                <span style={{ color: '#daa520', fontSize: '1.2rem' }}>
                  {showClosedDatesPanel ? '▼' : '▶'}
                </span>
              </div>

              {showClosedDatesPanel && (
                <div style={{ marginTop: '16px' }}>
                  {/* Formulaire d'ajout */}
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '16px',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                  }}>
                    <input
                      type="date"
                      value={newClosedDate}
                      onChange={(e) => setNewClosedDate(e.target.value)}
                      style={{
                        padding: '10px 12px',
                        background: '#0a0a0a',
                        border: '1px solid #333',
                        borderRadius: '4px',
                        color: '#fff',
                        fontSize: '0.95rem',
                        flex: '1',
                        minWidth: '180px'
                      }}
                      data-testid="closed-date-input"
                    />
                    <button
                      type="button"
                      onClick={addClosedDate}
                      style={{
                        padding: '10px 20px',
                        background: '#daa520',
                        color: '#000',
                        border: 'none',
                        borderRadius: '4px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        fontSize: '0.9rem'
                      }}
                      data-testid="add-closed-date-btn"
                    >
                      + Adicionar
                    </button>
                  </div>

                  {/* Liste des dates fermées */}
                  {closedDates.length === 0 ? (
                    <p style={{ color: '#888', fontStyle: 'italic', margin: 0 }}>
                      Nenhuma data de fechamento programada
                    </p>
                  ) : (
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '8px'
                    }}>
                      {closedDates.map((date) => (
                        <div
                          key={date}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '6px 12px',
                            background: '#2a1a1a',
                            border: '1px solid #aa4444',
                            borderRadius: '4px',
                            color: '#fff',
                            fontSize: '0.9rem'
                          }}
                          data-testid={`closed-date-item-${date}`}
                        >
                          <span>📅 {date}</span>
                          <button
                            type="button"
                            onClick={() => removeClosedDate(date)}
                            style={{
                              background: 'transparent',
                              border: 'none',
                              color: '#ff6666',
                              cursor: 'pointer',
                              fontSize: '1.1rem',
                              padding: '0 4px',
                              lineHeight: 1
                            }}
                            title="Remover"
                            data-testid={`remove-closed-date-${date}`}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  <p style={{
                    margin: '14px 0 0',
                    fontSize: '0.8rem',
                    color: '#888',
                    fontStyle: 'italic'
                  }}>
                    💡 As datas adicionadas aqui ficam bloqueadas para reservas (calendário público).
                  </p>
                </div>
              )}
            </div>
            )}

            {/* Gestion du calendrier (Super Admin uniquement) */}
            {superAdminAccess && <ScheduleManager backendUrl={backendUrl} />}

            {/* Vue Calendrier uniquement */}
            <div className="admin-calendar-view">
              <div className="calendar-and-details">
                <div className="calendar-container">
                  {renderAdminCalendar()}
                </div>
                
                <div className="appointment-details-panel">
                  {renderSelectedDateAppointments()}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    );
  };

  // Fonction pour gérer le suivi des stocks
  const renderStockManagement = () => {
    return (
      <div className="stock-management-container">
        <div className="stock-header">
          <h2 className="stock-title">📦 {t.agenda.stockTitle}</h2>
          <p className="stock-subtitle">{t.agenda.stockSubtitle}</p>
        </div>

        <div className="stock-table-container">
          <table className="stock-table">
            <thead>
              <tr>
                <th>{t.agenda.imageCol}</th>
                <th>{t.agenda.productCol}</th>
                <th>{t.agenda.brandCol}</th>
                <th>{t.agenda.categoryCol}</th>
                <th>{t.agenda.priceCol}</th>
                <th>{t.agenda.stockCol}</th>
                <th>{t.agenda.statusCol}</th>
                <th>{t.agenda.actionsCol}</th>
              </tr>
            </thead>
            <tbody>
              {products.map(product => {
                const stockStatus = product.stock_quantity === 0 ? 'rupture' : 
                                   product.stock_quantity <= 5 ? 'faible' : 
                                   'bon';
                
                return (
                  <tr key={product.id} className={`stock-row stock-${stockStatus}`}>
                    <td className="stock-image-cell">
                      <img src={product.image_url} alt={product.name} className="stock-product-image" />
                    </td>
                    <td className="stock-product-name">{product.name}</td>
                    <td className="stock-brand">{product.brand}</td>
                    <td className="stock-category">{product.category}</td>
                    <td className="stock-price">€{product.price.toFixed(2)}</td>
                    <td className="stock-quantity">
                      <span className={`quantity-badge quantity-${stockStatus}`}>
                        {product.stock_quantity} {t.agenda.units}
                      </span>
                    </td>
                    <td className="stock-status">
                      {stockStatus === 'rupture' && <span className="status-badge status-rupture">❌ {t.agenda.statusOut}</span>}
                      {stockStatus === 'faible' && <span className="status-badge status-faible">⚠️ {t.agenda.statusLow}</span>}
                      {stockStatus === 'bon' && <span className="status-badge status-bon">✅ {t.agenda.statusGood}</span>}
                    </td>
                    <td className="stock-actions">
                      {superAdminAccess ? (
                        <button 
                          className="stock-action-btn adjust-stock-btn"
                          onClick={async () => {
                            const newStock = prompt(`Ajuster le stock pour ${product.name}\nStock actuel: ${product.stock_quantity}`, product.stock_quantity);
                            if (newStock !== null && !isNaN(newStock)) {
                              try {
                                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products/${product.id}/stock`, {
                                  method: 'PUT',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ stock_quantity: parseInt(newStock) })
                                });
                                
                                if (response.ok) {
                                  await fetchProducts(); // Attendre que les produits soient rechargés
                                  alert('Stock mis à jour avec succès');
                                } else {
                                  alert('Erreur lors de la mise à jour du stock');
                                }
                              } catch (err) {
                                console.error('Erreur:', err);
                                alert('Erreur lors de la mise à jour');
                              }
                            }
                          }}
                        >
                          🔧 {t.agenda.adjust}
                        </button>
                      ) : (
                        <span className="no-permission" title="Accès réservé au Super Admin">🔒</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="stock-summary">
          <div className="summary-card">
            <div className="summary-icon">📊</div>
            <div className="summary-content">
              <div className="summary-label">{t.agenda.totalProducts}</div>
              <div className="summary-value">{products.length}</div>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon">📦</div>
            <div className="summary-content">
              <div className="summary-label">{t.agenda.unitsInStock}</div>
              <div className="summary-value">{products.reduce((sum, p) => sum + p.stock_quantity, 0)}</div>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon">💰</div>
            <div className="summary-content">
              <div className="summary-label">{t.agenda.totalStockValue}</div>
              <div className="summary-value">€{products.reduce((sum, p) => sum + (p.price * p.stock_quantity), 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="summary-card warning">
            <div className="summary-icon">⚠️</div>
            <div className="summary-content">
              <div className="summary-label">{t.agenda.lowStockLabel}</div>
              <div className="summary-value">{products.filter(p => p.stock_quantity <= 5 && p.stock_quantity > 0).length}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ===== RENDU DES MISSIONS =====
  const renderMissions = () => {
    const lisbonToday = new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' }).slice(0, 10);
    const MISSION_ICONS = { vapes_parfums: '🧮', cafe_bonbons: '☕', envelopes: '✉️', water: '💧' };
    const byStatus = (st) => missions.filter(m => m.computed_status === st);
    const fmtDate = (d) => new Date(d + 'T12:00:00').toLocaleDateString(
      currentLang === 'fr' ? 'fr-FR' : currentLang === 'en' ? 'en-GB' : currentLang === 'es' ? 'es-ES' : 'pt-PT',
      { day: 'numeric', month: 'long' }
    );
    const setInput = (id, field, value) => setMissionInputs(prev => ({ ...prev, [id]: { ...(prev[id] || {}), [field]: value } }));
    const getInput = (id, field) => (missionInputs[id] || {})[field] ?? '';

    const numInput = (m, field, label) => (
      <div className="form-group" style={{ marginBottom: '10px' }}>
        <label style={{ fontSize: '0.9rem' }}>{label}</label>
        <input
          type="number" min="0" value={getInput(m.id, field)}
          onChange={(e) => setInput(m.id, field, e.target.value)}
          data-testid={`mission-${m.type}-${field}-input`}
          style={{ width: '100%', padding: '10px', background: '#1a1a1a', border: '1px solid #daa520', borderRadius: '6px', color: '#fff' }}
        />
      </div>
    );

    const gapRow = (label, system, counted) => {
      const gap = counted - system;
      const color = gap === 0 ? '#4caf50' : '#ff5555';
      return (
        <div style={{ display: 'flex', gap: '15px', fontSize: '0.9rem', padding: '6px 10px', background: 'rgba(0,0,0,0.3)', borderRadius: '6px', borderLeft: `3px solid ${color}`, marginTop: '5px' }}>
          <span style={{ minWidth: '90px', fontWeight: 'bold' }}>{label}</span>
          <span>{t.missions.system}: {system}</span>
          <span>{t.missions.counted}: {counted}</span>
          <span style={{ color, fontWeight: 'bold' }}>{t.missions.gap}: {gap > 0 ? '+' : ''}{gap}</span>
        </div>
      );
    };

    const missionCard = (m) => {
      const isDone = m.computed_status === 'done';
      const isLate = m.computed_status === 'late';
      const borderColor = isDone ? '#4caf50' : isLate ? '#ff5555' : m.computed_status === 'todo' ? '#daa520' : '#555';
      return (
        <div key={m.id} data-testid={`mission-card-${m.type}-${m.period_key}`}
          style={{ background: '#111', border: `1px solid ${borderColor}`, borderLeft: `4px solid ${borderColor}`, borderRadius: '8px', padding: '15px 20px', marginBottom: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            <h4 style={{ margin: 0, color: '#f5f0e6' }}>{MISSION_ICONS[m.type]} {t.missions[`${m.type}Title`]}</h4>
            <span style={{ fontSize: '0.85rem', color: '#aaa' }}>
              {isDone
                ? `${t.missions.completedAt} ${m.completed_at ? m.completed_at.slice(0, 16).replace('T', ' ') : ''}`
                : `${t.missions.dueBy} ${fmtDate(m.due_date)}`}
            </span>
          </div>
          {!isDone && m.computed_status !== 'scheduled' && (
            <div style={{ marginTop: '12px', maxWidth: '420px' }}>
              {m.type === 'vapes_parfums' && (<>
                {numInput(m, 'vapes', t.missions.vapesLabel)}
                {numInput(m, 'parfums', t.missions.parfumsLabel)}
              </>)}
              {m.type === 'cafe_bonbons' && (<>
                {numInput(m, 'cafe', t.missions.cafeLabel)}
                {numInput(m, 'bonbons', t.missions.bonbonsLabel)}
              </>)}
              {m.type === 'envelopes' && numInput(m, 'envelopes', t.missions.envelopesLabel)}
              {m.type !== 'water' && (
                <input
                  type="text" placeholder={t.missions.commentOptional}
                  value={getInput(m.id, 'comment')}
                  onChange={(e) => setInput(m.id, 'comment', e.target.value)}
                  style={{ width: '100%', padding: '8px', background: '#1a1a1a', border: '1px solid #444', borderRadius: '6px', color: '#ccc', marginBottom: '10px' }}
                />
              )}
              <button
                onClick={() => completeMission(m)}
                data-testid={`mission-validate-${m.type}-${m.period_key}`}
                style={{ padding: '10px 25px', background: '#daa520', color: '#111', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {m.type === 'water' ? t.missions.waterConfirm : `✔ ${t.missions.validate}`}
              </button>
            </div>
          )}
          {isDone && (
            <div style={{ marginTop: '10px', fontSize: '0.9rem', color: '#ccc' }}>
              {m.result && m.type === 'vapes_parfums' && !superAdminAccess && (
                <span>Vapes: {m.result.vapes_counted} · {currentLang === 'pt' ? 'Perfumes' : currentLang === 'es' ? 'Perfumes' : currentLang === 'en' ? 'Perfumes' : 'Parfums'}: {m.result.parfums_counted}</span>
              )}
              {m.result && m.type === 'vapes_parfums' && superAdminAccess && m.snapshot && (<>
                {gapRow('Vapes', m.snapshot.vapes_system, m.result.vapes_counted)}
                {gapRow(currentLang === 'fr' ? 'Parfums' : 'Perfumes', m.snapshot.parfums_system, m.result.parfums_counted)}
              </>)}
              {m.result && m.type === 'cafe_bonbons' && (
                <span>{t.missions.cafeLabel}: {m.result.cafe_counted} · {t.missions.bonbonsLabel}: {m.result.bonbons_counted}</span>
              )}
              {m.result && m.type === 'envelopes' && (
                <span>{t.missions.envelopesLabel}: {m.result.envelopes_count}</span>
              )}
              {m.result && m.type === 'water' && <span>💧 ✔</span>}
              {m.comment && <div style={{ marginTop: '5px', fontStyle: 'italic', color: '#daa520' }}>💬 {m.comment}</div>}
            </div>
          )}
        </div>
      );
    };

    const section = (label, list, color) => (
      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ color, borderBottom: `1px solid ${color}`, paddingBottom: '8px' }}>{label} ({list.length})</h3>
        {list.length === 0 ? <p style={{ color: '#777', fontStyle: 'italic' }}>{t.missions.noMissions}</p> : list.map(missionCard)}
      </div>
    );

    const anomalies = missions.filter(m => m.computed_status === 'done' && m.has_anomaly);

    return (
      <div className="missions-view" data-testid="missions-view" style={{ maxWidth: '850px', margin: '0 auto' }}>
        {section(`🔴 ${t.missions.late}`, byStatus('late'), '#ff5555')}
        {section(`🟡 ${t.missions.todo}`, byStatus('todo'), '#daa520')}
        {section(`🔵 ${t.missions.upcoming}`, byStatus('upcoming'), '#6699cc')}
        {superAdminAccess && section(`⚪ ${t.missions.scheduled}`, byStatus('scheduled'), '#888')}
        {section(`🟢 ${t.missions.doneRecent}`, byStatus('done'), '#4caf50')}
        {superAdminAccess && anomalies.length > 0 && section(`⚠️ ${t.missions.anomalies}`, anomalies, '#ff8800')}
      </div>
    );
  };

  // ===== ARCHIVES ANNUELLES (Super Admin) =====
  const fetchArchiveSummary = async (year) => {
    try {
      const res = await fetch(`${backendUrl}/api/payments/yearly-summary?year=${year}`);
      if (res.ok) setArchiveSummary(await res.json());
    } catch (error) {
      console.error('Error fetching archive summary:', error);
    }
  };

  const downloadArchiveExcel = async () => {
    try {
      const res = await fetch(`${backendUrl}/api/payments/export-excel?year=${archiveYear}`);
      if (!res.ok) return;
      const blob = await res.blob();
      const u = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = u;
      a.download = `mafi-barber-pagamentos-${archiveYear}.xlsx`;
      a.click();
      URL.revokeObjectURL(u);
    } catch (error) {
      console.error('Error downloading excel:', error);
    }
  };

  const renderArchives = () => {
    const months = archiveSummary?.months || [];
    const years = archiveSummary?.available_years?.length ? archiveSummary.available_years : [String(archiveYear)];
    const monthName = (mk) => t.appointment.calendar.months[parseInt(mk.slice(5, 7), 10) - 1];
    const totals = months.reduce((acc, m) => ({
      count: acc.count + m.count, total: acc.total + m.total, services: acc.services + m.services,
      products: acc.products + m.products, vapes: acc.vapes + (m.vapes || 0), tips: acc.tips + m.tips
    }), { count: 0, total: 0, services: 0, products: 0, vapes: 0, tips: 0 });
    return (
      <div className="archives-view" data-testid="archives-view" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
          <h3 style={{ color: '#daa520', margin: 0 }}>📁 {t.archives.title}</h3>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <select
              value={archiveYear}
              onChange={(e) => { setArchiveYear(parseInt(e.target.value, 10)); fetchArchiveSummary(parseInt(e.target.value, 10)); }}
              data-testid="archive-year-select"
              style={{ padding: '8px 14px', background: '#1a1a1a', border: '1px solid #daa520', borderRadius: '6px', color: '#fff' }}
            >
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
            <button
              onClick={downloadArchiveExcel}
              data-testid="archive-download-excel-btn"
              style={{ padding: '8px 18px', background: '#daa520', color: '#111', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              📥 {t.archives.downloadExcel}
            </button>
          </div>
        </div>
        {months.length === 0 ? (
          <p style={{ color: '#777', fontStyle: 'italic', textAlign: 'center' }}>{t.archives.noData}</p>
        ) : (
          <>
          {/* Courbe du CA mois par mois */}
          {(() => {
            const W = 840, H = 240, padL = 50, padR = 25, padT = 30, padB = 35;
            const maxV = Math.max(...months.map(m => m.total), 1);
            const n = months.length;
            const x = (i) => n === 1 ? (padL + (W - padL - padR) / 2) : padL + (i * (W - padL - padR)) / (n - 1);
            const y = (v) => padT + (1 - v / maxV) * (H - padT - padB);
            const pts = months.map((m, i) => ({ px: x(i), py: y(m.total), m }));
            const path = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.px},${p.py}`).join(' ');
            const area = `${path} L${pts[pts.length - 1].px},${H - padB} L${pts[0].px},${H - padB} Z`;
            return (
              <div data-testid="archive-chart" style={{ background: '#111', border: '1px solid #333', borderRadius: '8px', padding: '15px', marginBottom: '25px', overflowX: 'auto' }}>
                <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', minWidth: '500px', height: 'auto' }}>
                  {[0.25, 0.5, 0.75, 1].map(f => (
                    <g key={f}>
                      <line x1={padL} y1={y(maxV * f)} x2={W - padR} y2={y(maxV * f)} stroke="#2a2a2a" strokeWidth="1" />
                      <text x={padL - 6} y={y(maxV * f) + 4} fill="#666" fontSize="10" textAnchor="end">{Math.round(maxV * f)}€</text>
                    </g>
                  ))}
                  <path d={area} fill="rgba(218,165,32,0.08)" />
                  <path d={path} fill="none" stroke="#daa520" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
                  {pts.map((p) => (
                    <g key={p.m.month}>
                      <circle cx={p.px} cy={p.py} r={p.m.is_current ? 5 : 4}
                        fill={p.m.is_current ? '#111' : '#daa520'} stroke="#daa520" strokeWidth="2" />
                      <text x={p.px} y={p.py - 10} fill="#f5f0e6" fontSize="11" fontWeight="bold" textAnchor="middle">
                        {Math.round(p.m.total)}€
                      </text>
                      <text x={p.px} y={H - padB + 16} fill="#999" fontSize="10" textAnchor="middle">
                        {monthName(p.m.month).slice(0, 3)}{p.m.is_current ? ' ⏳' : ''}
                      </text>
                    </g>
                  ))}
                </svg>
              </div>
            );
          })()}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#111', borderRadius: '8px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #daa520', color: '#daa520' }}>
                  {[t.archives.monthCol, t.archives.transactionsCol, `${t.archives.totalCol} (€)`, `${t.payments.cash} (€)`, `${t.payments.card} (€)`, 'MBWay (€)', `${t.archives.servicesCol} (€)`, `${t.archives.productsCol} (€)`, 'Vapes (€)', `${t.archives.tipsCol} (€)`, t.archives.variation].map(h => (
                    <th key={h} style={{ padding: '10px 8px', textAlign: 'left', fontSize: '0.85rem' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {months.map((m) => {
                  const fmtPct = (v) => v === null || v === undefined
                    ? <span style={{ color: '#777' }}>—</span>
                    : <span style={{ color: v >= 0 ? '#4caf50' : '#ff5555', fontWeight: 'bold' }}>{v >= 0 ? '+' : ''}{v.toFixed(1)}%</span>;
                  const compLine = (label, c) => (
                    <div style={{ fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                      <span style={{ color: '#888' }}>{label} {monthName(c.ref_month)} {c.ref_month.slice(0, 4)}:</span>{' '}
                      {t.archives.ca} {fmtPct(c.total_pct)} · {t.archives.servicesCol} {fmtPct(c.services_pct)} · {t.archives.sales} {fmtPct(c.products_pct)}
                    </div>
                  );
                  const badge = m.category === 'august'
                    ? <span title={t.archives.augustBadge} style={{ marginLeft: '6px', fontSize: '0.7rem', background: '#333', color: '#daa520', padding: '2px 6px', borderRadius: '8px' }}>🏖️</span>
                    : m.category === 'festive'
                      ? <span title={t.archives.festive} style={{ marginLeft: '6px', fontSize: '0.7rem', background: '#333', color: '#cc88ff', padding: '2px 6px', borderRadius: '8px' }}>🎉 {t.archives.festive}</span>
                      : null;
                  return (
                    <tr key={m.month} style={{ borderBottom: '1px solid #333', color: '#eee' }}>
                      <td style={{ padding: '10px 8px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>{monthName(m.month)} {m.month.slice(0, 4)}{badge}</td>
                      <td style={{ padding: '10px 8px' }}>{m.count}</td>
                      <td style={{ padding: '10px 8px', color: '#daa520', fontWeight: 'bold' }}>{m.total.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.cash.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.card.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.mbway.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.services.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.products.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px', color: '#88ccff' }}>{(m.vapes || 0).toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>{m.tips.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px' }}>
                        {m.is_current ? (
                          <span style={{ color: '#daa520', fontStyle: 'italic' }}>⏳ {t.archives.currentMonth}</span>
                        ) : (
                          <>
                            {m.comparable && compLine('vs', m.comparable)}
                            {m.yoy && compLine('vs', m.yoy)}
                            {!m.comparable && !m.yoy && <span style={{ color: '#777' }}>—</span>}
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr style={{ borderTop: '2px solid #daa520', color: '#daa520', fontWeight: 'bold' }}>
                  <td style={{ padding: '10px 8px' }}>{t.archives.yearTotal}</td>
                  <td style={{ padding: '10px 8px' }}>{totals.count}</td>
                  <td style={{ padding: '10px 8px' }}>{totals.total.toFixed(2)}</td>
                  <td colSpan={3}></td>
                  <td style={{ padding: '10px 8px' }}>{totals.services.toFixed(2)}</td>
                  <td style={{ padding: '10px 8px' }}>{totals.products.toFixed(2)}</td>
                  <td style={{ padding: '10px 8px' }}>{totals.vapes.toFixed(2)}</td>
                  <td style={{ padding: '10px 8px' }}>{totals.tips.toFixed(2)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          </>
        )}
      </div>
    );
  };

  const renderPayments = () => {
    if (!adminAccess) {
      return (
        <section className="payments-section">
          <div className="section-header">
            <h2 className="section-title">🔒 Acesso Restrito</h2>
            <p className="section-subtitle">{t.agenda.adminOnly}</p>
          </div>
          <div className="access-denied">
            <p>{t.agenda.adminOnlySub}</p>
          </div>
        </section>
      );
    }

    return (
      <section className="payments-section">
        <div className="section-header">
          <h2 className="section-title">
            💰 {t.payments.title}
            <span className="admin-badge">ADMIN</span>
          </h2>
          <p className="section-subtitle">{t.payments.subtitle}</p>
        </div>

        {/* Payment View Mode Toggle */}
        <div className="payment-controls">
          <div className="view-selector">
            <button
              className={`view-btn ${paymentViewMode === 'dashboard' ? 'active' : ''}`}
              onClick={() => setPaymentViewMode('dashboard')}
            >
              📊 {t.payments.dashboard}
            </button>
            {superAdminAccess && (
              <button
                className={`view-btn ${paymentViewMode === 'stock' ? 'active' : ''}`}
                onClick={() => setPaymentViewMode('stock')}
              >
                📦 Gestion des Stocks
              </button>
            )}
            {superAdminAccess && (
              <button
                className={`view-btn ${paymentViewMode === 'archives' ? 'active' : ''}`}
                onClick={() => { setPaymentViewMode('archives'); fetchArchiveSummary(archiveYear); }}
                data-testid="archives-tab-btn"
              >
                📁 {t.archives.title}
              </button>
            )}
            <button
              className={`view-btn ${paymentViewMode === 'missions' ? 'active' : ''}`}
              onClick={() => setPaymentViewMode('missions')}
              data-testid="missions-tab-btn"
            >
              📋 {t.missions.title}
              {missions.filter(m => m.computed_status === 'late' || (m.computed_status === 'todo' && m.due_date === new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' }).slice(0, 10))).length > 0 && (
                <span style={{ marginLeft: '6px', background: '#ff5555', color: '#fff', borderRadius: '10px', padding: '1px 8px', fontSize: '0.75rem', fontWeight: 'bold' }}>
                  {missions.filter(m => m.computed_status === 'late' || (m.computed_status === 'todo' && m.due_date === new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' }).slice(0, 10))).length}
                </span>
              )}
            </button>
            <button
              className={`view-btn ${paymentViewMode === 'new' ? 'active' : ''}`}
              onClick={() => setPaymentViewMode('new')}
            >
              ➕ {t.payments.newPayment}
            </button>
          </div>
        </div>

        {/* Bannière de rappel missions (échéance aujourd'hui ou retard) */}
        {paymentViewMode !== 'missions' && missions.some(m => m.computed_status === 'late' || (m.computed_status === 'todo' && m.due_date === new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' }).slice(0, 10))) && (
          <div
            onClick={() => setPaymentViewMode('missions')}
            data-testid="missions-reminder-banner"
            style={{ background: 'rgba(255,85,85,0.12)', border: '1px solid #ff5555', borderRadius: '8px', padding: '12px 20px', margin: '0 auto 20px auto', maxWidth: '850px', textAlign: 'center', color: '#ff8888', cursor: 'pointer', fontWeight: 'bold' }}
          >
            ⚠️ {missions.filter(m => m.computed_status === 'late' || (m.computed_status === 'todo' && m.due_date === new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Lisbon' }).slice(0, 10))).length} {t.missions.reminderBanner}
          </div>
        )}

        {/* Vue Missions */}
        {paymentViewMode === 'missions' && renderMissions()}

        {/* Vue Archives (Super Admin uniquement) */}
        {paymentViewMode === 'archives' && superAdminAccess && renderArchives()}

        {/* Vue Gestion des Stocks (Super Admin uniquement) */}
        {paymentViewMode === 'stock' && superAdminAccess && renderStockManagement()}

        {/* Toggle entre vue mensuelle et journalière */}
        {paymentViewMode === 'dashboard' && (
          <div className="view-toggle" style={{marginBottom: '20px', display: 'flex', gap: '10px', justifyContent: 'center'}}>
            <button 
              className={`toggle-btn ${viewMode === 'monthly' ? 'active' : ''}`}
              onClick={() => setViewMode('monthly')}
              style={{
                padding: '10px 20px',
                background: viewMode === 'monthly' ? 'linear-gradient(135deg, #daa520 0%, #b8860b 100%)' : '#2a2a2a',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontFamily: "'Oswald', sans-serif",
                fontSize: '1rem',
                fontWeight: '600',
                letterSpacing: '1px'
              }}
            >
              📅 Vue Mensuelle
            </button>
            <button 
              className={`toggle-btn ${viewMode === 'daily' ? 'active' : ''}`}
              onClick={() => setViewMode('daily')}
              style={{
                padding: '10px 20px',
                background: viewMode === 'daily' ? 'linear-gradient(135deg, #daa520 0%, #b8860b 100%)' : '#2a2a2a',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontFamily: "'Oswald', sans-serif",
                fontSize: '1rem',
                fontWeight: '600',
                letterSpacing: '1px'
              }}
            >
              📊 Vue Journalière
            </button>
          </div>
        )}

        {/* Sélecteur de date pour la vue journalière */}
        {paymentViewMode === 'dashboard' && viewMode === 'daily' && (
          <div style={{marginBottom: '20px', textAlign: 'center'}}>
            <input 
              type="date" 
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              style={{
                padding: '12px 20px',
                fontSize: '1rem',
                borderRadius: '4px',
                border: '2px solid #daa520',
                background: '#2a2a2a',
                color: '#fff',
                fontFamily: "'Oswald', sans-serif"
              }}
            />
          </div>
        )}

        {/* Onglets mensuels - seulement dans le dashboard ET vue mensuelle */}
        {paymentViewMode === 'dashboard' && viewMode === 'monthly' && (
          <div className="monthly-tabs">
            <div className="tabs-container">
              {availableMonths.map((month) => (
                <button
                  key={month.key}
                  className={`month-tab ${selectedMonth === month.key ? 'active' : ''}`}
                  onClick={() => setSelectedMonth(month.key)}
                >
                  {t.appointment.calendar.months[month.month - 1] || month.name} {month.year}
                  <span className="payment-count">({month.payment_count})</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {message && (
          <div className={`message ${message.includes('sucesso') || message.includes('success') || message.includes('succès') || message.includes('éxito') || message.includes('✅') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}

        {paymentViewMode === 'dashboard' && (
          // Dashboard View
          <div className="payments-dashboard">
            {/* Vue Journalière - UTILISE LES MÊMES CLASSES QUE VUE MENSUELLE */}
            {viewMode === 'daily' && dailyStats && (
              <>
                {/* En-tête avec date */}
                <div className="payment-stats">
                  <div className="stat-card" style={{gridColumn: '1 / -1', textAlign: 'center'}}>
                    <h3>📅 {new Date(dailyStats.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</h3>
                  </div>
                </div>

                {/* Stats principales - MÊMES CLASSES que vue mensuelle */}
                <div className="payment-stats">
                  <div className="stat-card stat-card-total">
                    <h3>{t.payments.totalRevenue.toUpperCase()}</h3>
                    <div className="stat-value">€{dailyStats.total_revenue.toFixed(2)}</div>
                  </div>
                  <div className="stat-card">
                    <h3>{t.payments.totalTransactions.toUpperCase()}</h3>
                    <div className="stat-value">{dailyStats.payment_count}</div>
                  </div>
                </div>

                {/* Répartition Services/Produits */}
                <div className="revenue-breakdown-section">
                  <div className="revenue-section-header">
                    <h3 className="revenue-section-title">💇 Receita de Serviços</h3>
                    <div className="revenue-section-total">€{dailyStats.service_revenue.total.toFixed(2)}</div>
                  </div>
                </div>

                <div className="revenue-breakdown-section">
                  <div className="revenue-section-header">
                    <h3 className="revenue-section-title">🛍️ Receita da Boutique</h3>
                    <div className="revenue-section-total">€{dailyStats.product_revenue.total.toFixed(2)}</div>
                  </div>
                </div>

                {/* Répartition par méthode - MÊMES CLASSES que vue mensuelle */}
                <div className="payment-methods-breakdown">
                  <h3 className="breakdown-title">{t.payments.methodBreakdown}</h3>
                  <div className="payment-methods-stats">
                    <div className="method-card method-cash">
                      <div className="method-icon">💵</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.cash}</div>
                        <div className="method-value">€{(dailyStats.revenue_by_method.cash || 0).toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="method-card method-card-payment">
                      <div className="method-icon">💳</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.card}</div>
                        <div className="method-value">€{(dailyStats.revenue_by_method.card || 0).toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="method-card method-mbway">
                      <div className="method-icon">📱</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.mbway}</div>
                        <div className="method-value">€{(dailyStats.revenue_by_method.mbway || 0).toFixed(2)}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Répartition par Prestataire */}
                {dailyStats.barber_revenue && Object.keys(dailyStats.barber_revenue).length > 0 && (
                  <div className="barber-breakdown-section" data-testid="daily-barber-breakdown" style={{
                    marginTop: '20px',
                    padding: '16px 20px',
                    background: '#1a1a1a',
                    border: '1px solid #333',
                    borderRadius: '8px'
                  }}>
                    <h3 style={{color: '#daa520', marginTop: 0, marginBottom: '14px'}}>✂️ {t.payments.providerRevenue}</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px'}}>
                      {Object.entries(dailyStats.barber_revenue).map(([barber, stats]) => (
                        <div key={barber} style={{
                          padding: '14px 16px',
                          background: '#0a0a0a',
                          border: '1px solid #333',
                          borderRadius: '6px'
                        }}>
                          <div style={{fontWeight: 600, color: '#daa520', marginBottom: '10px', fontSize: '0.95rem'}}>
                            {barber}
                            <span style={{
                              float: 'right',
                              fontSize: '0.8rem',
                              color: '#888',
                              fontWeight: 'normal'
                            }}>
                              {stats.count} {stats.count > 1 ? 'prestações' : 'prestação'}
                            </span>
                          </div>
                          <div style={{fontSize: '0.85rem', color: '#ccc', lineHeight: 1.7}}>
                            <div>{t.payments.servicesLabel} : <strong style={{color: '#fff'}}>€{stats.services.toFixed(2)}</strong></div>
                            {stats.products_sales > 0 && (
                              <div>{t.payments.salesLabel} : <strong style={{color: '#fff'}}>€{stats.products_sales.toFixed(2)}</strong></div>
                            )}
                            {stats.tips > 0 && (
                              <div>{t.payments.tipsLabel} : <strong style={{color: '#daa520'}}>€{stats.tips.toFixed(2)}</strong></div>
                            )}
                          </div>
                          <div style={{
                            marginTop: '10px',
                            paddingTop: '10px',
                            borderTop: '1px dashed #333',
                            fontSize: '1rem',
                            fontWeight: 600,
                            color: '#fff'
                          }}>
                            Total : €{stats.total.toFixed(2)}
                          </div>
                        </div>
                      ))}
                    </div>
                    <p style={{margin: '12px 0 0', fontSize: '0.75rem', color: '#888', fontStyle: 'italic'}}>
                      💡 Vapes et perfumes não são contabilizados nas vendas dos prestadores.
                    </p>
                  </div>
                )}

                {/* Tableau des Transactions */}
                <div className="payments-list">
                  <h3>💰 {t.payments.transactionsDetail}</h3>
                  {dailyStats.payments.length === 0 ? (
                    <p style={{textAlign: 'center', color: '#888', padding: '40px'}}>{t.payments.noPaymentsForDate}</p>
                  ) : (
                    <table className="payments-table">
                      <thead>
                        <tr>
                          <th>{t.payments.timeCol}</th>
                          <th>{t.payments.clientCol}</th>
                          <th>{t.payments.serviceProductsCol}</th>
                          <th>{t.payments.amount}</th>
                          <th>{t.payments.methodCol}</th>
                          {superAdminAccess && <th>{t.payments.actionsCol}</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {[...dailyStats.payments].sort((a, b) => {
                          // Trier du plus ancien au plus récent
                          const timeA = a.payment_time || '00:00';
                          const timeB = b.payment_time || '00:00';
                          return timeA.localeCompare(timeB);
                        }).map((payment) => {
                          const serviceText = getServiceById(payment.service_id)?.name || 'N/A';
                          const productsText = payment.products_sold && payment.products_sold.length > 0
                            ? payment.products_sold.map(p => `${p.product_name} (x${p.quantity})`).join(', ')
                            : '';
                          
                          return (
                            <React.Fragment key={payment.id}>
                              <tr>
                                <td>{payment.payment_time || 'N/A'}</td>
                                <td>{payment.client_name}</td>
                                <td>
                                  <div>{serviceText}</div>
                                  {productsText && (
                                    <div style={{fontSize: '0.85em', color: '#888', marginTop: '4px'}}>
                                      🛍️ {productsText}
                                    </div>
                                  )}
                                </td>
                                <td>€{payment.amount.toFixed(2)}</td>
                                <td>
                                  {payment.payment_method === 'cash' && '💵 Espèces'}
                                  {payment.payment_method === 'card' && '💳 Carte'}
                                  {payment.payment_method === 'mbway' && '📱 MBWay'}
                                </td>
                                {superAdminAccess && (
                                  <td>
                                    <button 
                                      className="edit-payment-btn"
                                      onClick={() => handleEditPayment(payment)}
                                      title={t.payments.editPaymentTitle}
                                      style={{padding: '6px 12px', fontSize: '0.85rem'}}
                                    >
                                      ✏️ {t.payments.editPayment}
                                    </button>
                                    <button 
                                      className="delete-payment-btn"
                                      onClick={() => handleDeletePayment(payment)}
                                      title={t.payments.deletePayment}
                                      data-testid={`delete-payment-daily-${payment.id}`}
                                      style={{padding: '6px 12px', fontSize: '0.85rem', marginLeft: '6px', background: 'transparent', border: '1px solid #aa4444', color: '#ff6666', borderRadius: '4px', cursor: 'pointer'}}
                                    >
                                      🗑️
                                    </button>
                                  </td>
                                )}
                              </tr>
                              {payment.notes && (
                                <tr>
                                  <td colSpan={superAdminAccess ? 6 : 5} style={{
                                    padding: '4px 12px 12px 12px',
                                    borderTop: 'none',
                                    background: 'rgba(218, 165, 32, 0.05)'
                                  }}>
                                    <div style={{
                                      fontSize: '0.85em',
                                      color: '#daa520',
                                      fontStyle: 'italic'
                                    }}>
                                      💬 {payment.notes}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </>
            )}

            {/* Vue Mensuelle */}
            {viewMode === 'monthly' && monthlyStats && (
              <>
                <div className="payment-stats">
                  <div 
                    className="stat-card stat-card-total clickable-card"
                    onClick={() => setShowRevenueDetails(!showRevenueDetails)}
                    title="Clique para ver os detalhes"
                  >
                    <h3>{t.payments.totalRevenue}</h3>
                    <div className="stat-value">
                      €{(monthlyStats.total_revenue || 0).toFixed(2)}
                      <span className="detail-indicator">{showRevenueDetails ? '▲' : '▼'}</span>
                    </div>
                  </div>
                  <div className="stat-card">
                    <h3>{t.payments.totalTransactions}</h3>
                    <div className="stat-value">{monthlyStats.total_transactions || 0}</div>
                  </div>
                  
                  {/* Total des Tips - Affiché séparément (hors comptabilité) */}
                  {(monthlyStats.total_tips || 0) > 0 && (
                    <div className="stat-card" style={{
                      background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.2), rgba(218, 165, 32, 0.05))',
                      border: '2px dashed #daa520'
                    }}>
                      <h3 style={{color: '#daa520'}}>💰 {t.payments.tipsOffBooks}</h3>
                      <div className="stat-value" style={{color: '#daa520'}}>
                        €{(monthlyStats.total_tips || 0).toFixed(2)}
                      </div>
                      <div style={{fontSize: '0.75rem', color: '#888', marginTop: '5px'}}>
                        Non inclus dans le revenu
                      </div>
                    </div>
                  )}
                </div>

                {/* Répartition par méthode de paiement */}
                <div className="payment-methods-breakdown">
                  <h3 className="breakdown-title">{t.payments.methodBreakdown}</h3>
                  <div className="payment-methods-stats">
                    <div className="method-card method-cash">
                      <div className="method-icon">💵</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.cash}</div>
                        <div className="method-value">€{(monthlyStats.payment_methods?.cash || 0).toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="method-card method-card-payment">
                      <div className="method-icon">💳</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.card}</div>
                        <div className="method-value">€{(monthlyStats.payment_methods?.card || 0).toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="method-card method-mbway">
                      <div className="method-icon">📱</div>
                      <div className="method-details">
                        <div className="method-name">{t.payments.mbway}</div>
                        <div className="method-value">€{(monthlyStats.payment_methods?.mbway || 0).toFixed(2)}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Receita de Serviços - Affichage conditionnel */}
                {showRevenueDetails && monthlyStats.service_revenue && (
                  <div className="revenue-breakdown-section">
                    <div className="revenue-section-header">
                      <h3 className="revenue-section-title">💇 Receita de Serviços</h3>
                      <div className="revenue-section-total">€{(monthlyStats.service_revenue.total || 0).toFixed(2)}</div>
                    </div>
                    <div className="revenue-methods-mini">
                      <div className="mini-method-card">
                        <span className="mini-method-icon">💵</span>
                        <span className="mini-method-name">{t.payments.cash}</span>
                        <span className="mini-method-value">€{(monthlyStats.service_revenue.by_method?.cash || 0).toFixed(2)}</span>
                      </div>
                      <div className="mini-method-card">
                        <span className="mini-method-icon">💳</span>
                        <span className="mini-method-name">{t.payments.card}</span>
                        <span className="mini-method-value">€{(monthlyStats.service_revenue.by_method?.card || 0).toFixed(2)}</span>
                      </div>
                      <div className="mini-method-card">
                        <span className="mini-method-icon">📱</span>
                        <span className="mini-method-name">{t.payments.mbway}</span>
                        <span className="mini-method-value">€{(monthlyStats.service_revenue.by_method?.mbway || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Receita da Boutique - Affichage conditionnel */}
                {showRevenueDetails && monthlyStats.product_revenue && (
                  <div className="revenue-breakdown-section">
                    <div className="revenue-section-header">
                      <h3 className="revenue-section-title">🛍️ Receita da Boutique</h3>
                      <div className="revenue-section-total">€{(monthlyStats.product_revenue.total || 0).toFixed(2)}</div>
                    </div>
                    <div className="revenue-methods-mini">
                      <div className="mini-method-card">
                        <span className="mini-method-icon">💵</span>
                        <span className="mini-method-name">{t.payments.cash}</span>
                        <span className="mini-method-value">€{(monthlyStats.product_revenue.by_method?.cash || 0).toFixed(2)}</span>
                      </div>
                      <div className="mini-method-card">
                        <span className="mini-method-icon">💳</span>
                        <span className="mini-method-name">{t.payments.card}</span>
                        <span className="mini-method-value">€{(monthlyStats.product_revenue.by_method?.card || 0).toFixed(2)}</span>
                      </div>
                      <div className="mini-method-card">
                        <span className="mini-method-icon">📱</span>
                        <span className="mini-method-name">{t.payments.mbway}</span>
                        <span className="mini-method-value">€{(monthlyStats.product_revenue.by_method?.mbway || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Receita por Prestador (mensuel) */}
                {showRevenueDetails && monthlyStats.barber_revenue && Object.keys(monthlyStats.barber_revenue).length > 0 && (
                  <div className="barber-breakdown-section" data-testid="monthly-barber-breakdown" style={{
                    marginTop: '20px',
                    padding: '16px 20px',
                    background: '#1a1a1a',
                    border: '1px solid #333',
                    borderRadius: '8px'
                  }}>
                    <h3 style={{color: '#daa520', marginTop: 0, marginBottom: '14px'}}>✂️ {t.payments.providerRevenue}</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px'}}>
                      {Object.entries(monthlyStats.barber_revenue).map(([barber, stats]) => (
                        <div key={barber} style={{
                          padding: '14px 16px',
                          background: '#0a0a0a',
                          border: '1px solid #333',
                          borderRadius: '6px'
                        }}>
                          <div style={{fontWeight: 600, color: '#daa520', marginBottom: '10px', fontSize: '0.95rem'}}>
                            {barber}
                            <span style={{
                              float: 'right',
                              fontSize: '0.8rem',
                              color: '#888',
                              fontWeight: 'normal'
                            }}>
                              {stats.count} {stats.count > 1 ? 'prestações' : 'prestação'}
                            </span>
                          </div>
                          <div style={{fontSize: '0.85rem', color: '#ccc', lineHeight: 1.7}}>
                            <div>{t.payments.servicesLabel} : <strong style={{color: '#fff'}}>€{stats.services.toFixed(2)}</strong></div>
                            {stats.products_sales > 0 && (
                              <div>{t.payments.salesLabel} : <strong style={{color: '#fff'}}>€{stats.products_sales.toFixed(2)}</strong></div>
                            )}
                            {stats.tips > 0 && (
                              <div>{t.payments.tipsLabel} : <strong style={{color: '#daa520'}}>€{stats.tips.toFixed(2)}</strong></div>
                            )}
                          </div>
                          <div style={{
                            marginTop: '10px',
                            paddingTop: '10px',
                            borderTop: '1px dashed #333',
                            fontSize: '1rem',
                            fontWeight: 600,
                            color: '#fff'
                          }}>
                            Total : €{stats.total.toFixed(2)}
                          </div>
                        </div>
                      ))}
                    </div>
                    <p style={{margin: '12px 0 0', fontSize: '0.75rem', color: '#888', fontStyle: 'italic'}}>
                      💡 Vapes et perfumes não são contabilizados nas vendas dos prestadores.
                    </p>
                  </div>
                )}
              </>
            )}

            {/* Pagamentos do Mês - UNIQUEMENT en vue mensuelle */}
            {viewMode === 'monthly' && (
              <div className="payments-list">
                <h3>{t.payments.monthlyPayments}</h3>
                {monthlyPayments.length === 0 ? (
                  <div className="no-payments">
                    <p>{t.payments.noPayments}</p>
                  </div>
                ) : (
                  <div className="payments-table">
                    {[...monthlyPayments].sort((a, b) => {
                      // Trier du plus ancien au plus récent (par date puis par heure)
                      const dateA = new Date(a.payment_date + 'T' + (a.payment_time || '00:00'));
                      const dateB = new Date(b.payment_date + 'T' + (b.payment_time || '00:00'));
                      return dateA - dateB;
                    }).map((payment) => (
                      <div key={payment.id} className="payment-row">
                        <div className="payment-info">
                          <div className="client-name">{payment.client_name}</div>
                          <div className="service-info">
                            {translateServiceName(getServiceById(payment.service_id)?.name) || t.payments.noPayments}
                          </div>
                          
                          {/* Afficher les produits vendus s'il y en a */}
                          {payment.products_sold && payment.products_sold.length > 0 && (
                            <div className="products-sold-details">
                              {payment.products_sold.map((product, idx) => (
                                <div key={idx} className="product-sold-line">
                                  + {product.product_name} x{product.quantity} (€{(product.unit_price || 0).toFixed(2)})
                                </div>
                              ))}
                            </div>
                          )}
                          
                          <div className="payment-date">
                            {new Date(payment.payment_date).toLocaleDateString('pt-PT')} {t.payments.at} {payment.payment_time}
                          </div>
                          
                          {/* Afficher les notes/commentaires s'il y en a */}
                          {payment.notes && (
                            <div className="payment-notes" style={{
                              marginTop: '8px',
                              padding: '6px 10px',
                              background: 'rgba(218, 165, 32, 0.1)',
                              borderRadius: '4px',
                              fontSize: '0.85em',
                              color: '#daa520',
                              fontStyle: 'italic'
                            }}>
                              💬 {payment.notes}
                            </div>
                          )}
                        </div>
                        <div className="payment-amount">€{payment.amount.toFixed(2)}</div>
                        <div className="payment-method">
                          {payment.payment_method === 'cash' ? t.payments.cash : 
                           payment.payment_method === 'card' ? t.payments.card : 
                           payment.payment_method === 'mbway' ? t.payments.mbway : payment.payment_method}
                        </div>
                        {superAdminAccess && (
                          <div className="payment-actions">
                            <button 
                              className="edit-payment-btn"
                              onClick={() => handleEditPayment(payment)}
                              title={t.payments.editPaymentTitle}
                            >
                              ✏️ {t.payments.editPayment}
                            </button>
                            <button 
                              className="delete-payment-btn"
                              onClick={() => handleDeletePayment(payment)}
                              title={t.payments.deletePayment}
                              data-testid={`delete-payment-monthly-${payment.id}`}
                              style={{marginLeft: '6px', padding: '6px 12px', background: 'transparent', border: '1px solid #aa4444', color: '#ff6666', borderRadius: '4px', cursor: 'pointer'}}
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {paymentViewMode === 'new' && (
          // New Payment Form
          <div className="new-payment-form">
            <form onSubmit={handlePaymentSubmit} className="payment-form">
              <div className="form-row">
                <div className="form-group" style={{position: 'relative'}}>
                  <label>{t.payments.clientName}</label>
                  <input
                    type="text"
                    name="client_name"
                    value={paymentForm.client_name}
                    onChange={(e) => {
                      setPaymentForm({...paymentForm, client_name: e.target.value});
                      searchClients(e.target.value);
                    }}
                    onFocus={() => {
                      if (clientSuggestions.length > 0) setShowClientSuggestions(true);
                    }}
                    onBlur={() => {
                      // Délai pour permettre le clic sur une suggestion
                      setTimeout(() => setShowClientSuggestions(false), 200);
                    }}
                    placeholder="Nome do Cliente"
                    autoComplete="off"
                    required
                  />
                  {/* Suggestions de clients */}
                  {showClientSuggestions && clientSuggestions.length > 0 && (
                    <div className="client-suggestions">
                      {clientSuggestions.map((client) => (
                        <div 
                          key={client.id} 
                          className="client-suggestion-item"
                          onClick={() => selectClient(client)}
                        >
                          <div className="client-suggestion-name">{client.name}</div>
                          <div className="client-suggestion-details">
                            {client.email && <span>{client.email}</span>}
                            {client.phone && <span>{client.phone}</span>}
                            <span className="client-visits">({client.total_visits} visite{client.total_visits > 1 ? 's' : ''})</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label>{t.payments.email}</label>
                  <input
                    type="email"
                    name="client_email"
                    value={paymentForm.client_email}
                    onChange={(e) => setPaymentForm({...paymentForm, client_email: e.target.value})}
                    placeholder="Email do cliente"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{t.payments.phone}</label>
                  <div className="phone-input-container">
                    <select 
                      className="country-code-select"
                      value={paymentPhoneCountryCode}
                      onChange={(e) => setPaymentPhoneCountryCode(e.target.value)}
                    >
                      <option value="+351">🇵🇹 +351</option>
                      <option value="+33">🇫🇷 +33</option>
                      <option value="+34">🇪🇸 +34</option>
                      <option value="+44">🇬🇧 +44</option>
                      <option value="+49">🇩🇪 +49</option>
                      <option value="+39">🇮🇹 +39</option>
                      <option value="+1">🇺🇸 +1</option>
                      <option value="+41">🇨🇭 +41</option>
                      <option value="+32">🇧🇪 +32</option>
                      <option value="+31">🇳🇱 +31</option>
                    </select>
                    <input
                      type="tel"
                      name="client_phone"
                      value={paymentForm.client_phone}
                      onChange={(e) => setPaymentForm({...paymentForm, client_phone: e.target.value})}
                      placeholder="Telefone do cliente"
                      className="phone-number-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>{t.payments.servicePerformed}</label>
                  <select
                    name="service_id"
                    value={paymentForm.service_id}
                    onChange={(e) => {
                      const serviceId = e.target.value;
                      const service = getServiceById(serviceId);
                      setPaymentForm({
                        ...paymentForm, 
                        service_id: serviceId,
                        amount: service ? service.price : ''
                      });
                    }}
                    required
                  >
                    <option value="">{t.payments.selectService}</option>
                    {services.map((service) => (
                      <option key={service.id} value={service.id}>
                        {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{t.payments.amount}</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    name="amount"
                    value={paymentForm.amount}
                    onChange={(e) => setPaymentForm({...paymentForm, amount: e.target.value})}
                    placeholder="0.00"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>{t.payments.paymentMethod} <span style={{color: '#ff6666'}}>*</span></label>
                  <select
                    value={paymentForm.payment_method}
                    onChange={(e) => setPaymentForm({...paymentForm, payment_method: e.target.value, tips: e.target.value === 'cash' ? '' : paymentForm.tips})}
                    required
                    data-testid="payment-method-select"
                    style={!paymentForm.payment_method ? {borderColor: '#daa520'} : {}}
                  >
                    <option value="">{t.payments.selectPaymentMethod}</option>
                    <option value="cash">{t.payments.cash}</option>
                    <option value="card">{t.payments.card}</option>
                    <option value="mbway">{t.payments.mbway}</option>
                  </select>
                </div>
                
                {/* Champ Tips - seulement pour Carte et MBWay */}
                {(paymentForm.payment_method === 'card' || paymentForm.payment_method === 'mbway') && (
                  <div className="form-group">
                    <label>💰 {t.payments.tipField}</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                      value={paymentForm.tips}
                      onChange={(e) => setPaymentForm({...paymentForm, tips: e.target.value})}
                      style={{background: 'rgba(218, 165, 32, 0.1)', borderColor: '#daa520'}}
                    />
                  </div>
                )}
              </div>

              {/* Sélection du prestataire (obligatoire) */}
              <div className="form-row">
                <div className="form-group" style={{flex: 1}}>
                  <label>
                    ✂️ Prestador <span style={{color: '#ff6666'}}>*</span>
                  </label>
                  <select
                    value={paymentForm.barber}
                    onChange={(e) => setPaymentForm({...paymentForm, barber: e.target.value})}
                    required
                    data-testid="payment-barber-select"
                    style={!paymentForm.barber ? {borderColor: '#daa520'} : {}}
                  >
                    <option value="">{t.payments.selectBarber}</option>
                    {barbers.map(b => (
                      <option key={b} value={b}>{b}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{t.payments.paymentDate}</label>
                  <input
                    type="date"
                    name="payment_date"
                    value={paymentForm.payment_date}
                    onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>{t.payments.paymentTime}</label>
                  <input
                    type="time"
                    name="payment_time"
                    value={paymentForm.payment_time}
                    onChange={(e) => setPaymentForm({...paymentForm, payment_time: e.target.value})}
                    required
                  />
                </div>
              </div>

              {/* Section Produits Vendus */}
              <div className="products-section">
                <h3 style={{color: '#daa520', marginBottom: '15px'}}>{t.payments.productsSold}</h3>
                
                <div className="form-group">
                  <label>{t.payments.addProduct}</label>
                  <select
                    onChange={(e) => {
                      if (e.target.value) {
                        addProduct(e.target.value);
                        e.target.value = ''; // Reset selection
                      }
                    }}
                    style={{marginBottom: '15px'}}
                  >
                    <option value="">{t.payments.selectProduct}</option>
                    {products.filter(p => p.stock_quantity > 0).map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.name} - €{product.price.toFixed(2)}{superAdminAccess ? ` (Stock: ${product.stock_quantity})` : ''}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Liste des produits sélectionnés */}
                {(selectedProducts || []).length > 0 && (
                  <div className="selected-products-list">
                    <h4 style={{color: '#daa520', fontSize: '14px', marginBottom: '10px'}}>
                      {t.payments.selectedProducts}
                    </h4>
                    {(selectedProducts || []).map((product) => (
                      <div key={product.product_id} className="selected-product-item">
                        <div className="product-info">
                          <span className="product-name">{product.product_name || 'Produit'}</span>
                          <span className="product-price">€{(product.unit_price || 0).toFixed(2)}</span>
                        </div>
                        <div className="product-controls">
                          <button
                            type="button"
                            onClick={() => updateProductQuantity(product.product_id, product.quantity - 1)}
                            className="qty-btn"
                          >
                            -
                          </button>
                          <span className="product-quantity">{product.quantity || 0}</span>
                          <button
                            type="button"
                            onClick={() => updateProductQuantity(product.product_id, product.quantity + 1)}
                            className="qty-btn"
                          >
                            +
                          </button>
                          <span className="product-total">= €{(product.total_price || 0).toFixed(2)}</span>
                          <button
                            type="button"
                            onClick={() => removeProduct(product.product_id)}
                            className="remove-btn"
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                    ))}
                    <div className="products-total">
                      <strong>{t.payments.totalProducts}</strong> €{(selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0).toFixed(2)}
                    </div>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>
                  {t.payments.notes}
                  {(() => {
                    const selectedService = getServiceById(paymentForm.service_id);
                    const basePrice = selectedService?.price || 0;
                    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                    const expectedTotal = basePrice + productsTotal;
                    const currentAmount = parseFloat(paymentForm.amount) || 0;
                    const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                    return priceModified ? (
                      <span style={{color: '#ff6b6b', marginLeft: '8px', fontSize: '12px'}}>
                        ⚠️ {t.payments.notesRequired}
                      </span>
                    ) : null;
                  })()}
                </label>
                <textarea
                  name="notes"
                  value={paymentForm.notes}
                  onChange={(e) => setPaymentForm({...paymentForm, notes: e.target.value})}
                  placeholder={(() => {
                    const selectedService = getServiceById(paymentForm.service_id);
                    const basePrice = selectedService?.price || 0;
                    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                    const expectedTotal = basePrice + productsTotal;
                    const currentAmount = parseFloat(paymentForm.amount) || 0;
                    const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                    return priceModified 
                      ? t.payments.notesRequiredPlaceholder 
                      : t.payments.notesPlaceholder;
                  })()}
                  rows="3"
                  style={(() => {
                    const selectedService = getServiceById(paymentForm.service_id);
                    const basePrice = selectedService?.price || 0;
                    const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                    const expectedTotal = basePrice + productsTotal;
                    const currentAmount = parseFloat(paymentForm.amount) || 0;
                    const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                    return priceModified ? {borderColor: '#ff6b6b'} : {};
                  })()}
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? t.payments.saving : t.payments.save}
                </button>
                
                {/* Bouton Client Non Venu - visible seulement si un appointment_id est présent */}
                {paymentForm.appointment_id && (
                  <button 
                    type="button" 
                    className="no-show-btn"
                    onClick={async () => {
                      if (window.confirm(t.payments.confirmNoShow)) {
                        try {
                          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/appointments/${paymentForm.appointment_id}/status`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ status: 'cancelled' })
                          });
                          
                          if (response.ok) {
                            await fetchAppointments(); // Attendre que les appointments soient rechargés
                            alert('Rendez-vous annulé - Client non venu');
                            setPaymentViewMode('list');
                            // Reset form
                            setPaymentForm({
                              client_name: '',
                              client_email: '',
                              service_id: '',
                              amount: '',
                              payment_method: '',
                              notes: '',
                              appointment_id: null
                            });
                            setSelectedProducts([]);
                          } else {
                            alert('Erreur lors de l\'annulation');
                          }
                        } catch (err) {
                          console.error('Erreur:', err);
                          alert('Erreur lors de l\'annulation');
                        }
                      }
                    }}
                    disabled={loading}
                  >
                    ❌ {t.payments.clientNoShow}
                  </button>
                )}
              </div>
            </form>

            {/* Quick Client Selection from Recent Appointments */}
            {appointments.length > 0 && (
              <div className="quick-client-selection">
                <h4>{t.payments.selectFromRecent}</h4>
                <div className="recent-appointments">
                  {appointments.slice(0, 5).map((appointment) => (
                    <button
                      key={appointment.id}
                      type="button"
                      className="client-quick-btn"
                      onClick={() => selectClientFromAppointment(appointment)}
                    >
                      {appointment.client_name} - {translateServiceName(getServiceById(appointment.service_id)?.name)}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Modal d'édition de paiement (Super Admin uniquement) */}
        {/* Popup remerciement enveloppes (toujours en portugais) */}
        {showEnvelopePopup && (
          <div className="modal-overlay" onClick={() => setShowEnvelopePopup(false)}>
            <div className="modal-content" data-testid="envelope-popup" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px', textAlign: 'center', padding: '35px' }}>
              <h2 style={{ color: '#daa520', marginBottom: '15px' }}>🙏 Obrigado!</h2>
              <p style={{ fontSize: '1.05rem', lineHeight: 1.6, color: '#f5f0e6' }}>
                Por favor, envie uma mensagem ao patrão a indicar o valor de cada envelope e o total.
              </p>
              <button
                onClick={() => setShowEnvelopePopup(false)}
                data-testid="envelope-popup-ok"
                style={{ marginTop: '20px', padding: '10px 40px', background: '#daa520', color: '#111', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '1rem' }}
              >
                OK
              </button>
            </div>
          </div>
        )}

        {showEditModal && editingPayment && (
          <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>✏️ {t.payments.editTitle}</h2>
                <button className="modal-close" onClick={() => setShowEditModal(false)}>×</button>
              </div>
              <form onSubmit={handleUpdatePayment} className="payment-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>{t.payments.name}</label>
                    <input
                      type="text"
                      value={paymentForm.client_name}
                      onChange={(e) => setPaymentForm({...paymentForm, client_name: e.target.value})}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>{t.payments.email}</label>
                    <input
                      type="email"
                      value={paymentForm.client_email}
                      onChange={(e) => setPaymentForm({...paymentForm, client_email: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>{t.payments.service}</label>
                    <select
                      value={paymentForm.service_id}
                      onChange={(e) => setPaymentForm({...paymentForm, service_id: e.target.value})}
                      required
                    >
                      {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>{t.payments.amount} (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={paymentForm.amount}
                      onChange={(e) => setPaymentForm({...paymentForm, amount: e.target.value})}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>{t.payments.paymentMethod} <span style={{color: '#ff6666'}}>*</span></label>
                    <select
                      value={paymentForm.payment_method}
                      onChange={(e) => setPaymentForm({...paymentForm, payment_method: e.target.value, tips: e.target.value === 'cash' ? '' : paymentForm.tips})}
                      required
                      data-testid="edit-payment-method-select"
                      style={!paymentForm.payment_method ? {borderColor: '#daa520'} : {}}
                    >
                      <option value="">{t.payments.selectPaymentMethod}</option>
                      <option value="cash">💵 {t.payments.cash}</option>
                      <option value="card">💳 {t.payments.card}</option>
                      <option value="mbway">📱 {t.payments.mbway}</option>
                    </select>
                  </div>
                  
                  {/* Champ Tips dans le modal d'édition - seulement pour Carte et MBWay */}
                  {(paymentForm.payment_method === 'card' || paymentForm.payment_method === 'mbway') && (
                    <div className="form-group">
                      <label>💰 {t.payments.tipField}</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="0.00"
                        value={paymentForm.tips || ''}
                        onChange={(e) => setPaymentForm({...paymentForm, tips: e.target.value})}
                        style={{background: 'rgba(218, 165, 32, 0.1)', borderColor: '#daa520'}}
                      />
                    </div>
                  )}
                  
                  <div className="form-group">
                    <label>{t.payments.paymentDate}</label>
                    <input
                      type="date"
                      value={paymentForm.payment_date}
                      onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>{t.payments.paymentTime}</label>
                    <input
                      type="time"
                      value={paymentForm.payment_time}
                      onChange={(e) => setPaymentForm({...paymentForm, payment_time: e.target.value})}
                      data-testid="edit-payment-time-input"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" style={{flex: 1}}>
                    <label>
                      ✂️ Prestador <span style={{color: '#ff6666'}}>*</span>
                    </label>
                    <select
                      value={paymentForm.barber || ''}
                      onChange={(e) => setPaymentForm({...paymentForm, barber: e.target.value})}
                      data-testid="edit-payment-barber-select"
                    >
                      <option value="">{t.payments.selectBarber}</option>
                      {barbers.map(b => (
                        <option key={b} value={b}>{b}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Section Produits Vendus */}
                <div className="products-section" style={{marginTop: '20px', padding: '15px', background: '#1a1a1a', borderRadius: '8px'}}>
                  <h3 style={{color: '#daa520', marginBottom: '15px'}}>🛍️ {t.payments.productsSold}</h3>
                  
                  <div className="form-group">
                    <label>{t.payments.addProduct}</label>
                    <select
                      onChange={(e) => {
                        if (e.target.value) {
                          addProduct(e.target.value);
                          e.target.value = '';
                        }
                      }}
                      style={{marginBottom: '15px'}}
                    >
                      <option value="">{t.payments.selectProduct}</option>
                      {products.filter(p => p.stock_quantity > 0).map((product) => (
                        <option key={product.id} value={product.id}>
                          {product.name} - €{product.price.toFixed(2)}{superAdminAccess ? ` (Stock: ${product.stock_quantity})` : ''}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Liste des produits sélectionnés */}
                  {(selectedProducts || []).length > 0 && (
                    <div className="selected-products-list">
                      <h4 style={{color: '#daa520', fontSize: '14px', marginBottom: '10px'}}>
                        {t.payments.selectedProducts}
                      </h4>
                      {(selectedProducts || []).map((product) => (
                        <div key={product.product_id} className="selected-product-item">
                          <div className="product-info">
                            <span className="product-name">{product.product_name || 'Produit'}</span>
                            <span className="product-price">€{(product.unit_price || 0).toFixed(2)}</span>
                          </div>
                          <div className="product-controls">
                            <button
                              type="button"
                              onClick={() => updateProductQuantity(product.product_id, product.quantity - 1)}
                              className="qty-btn"
                            >
                              -
                            </button>
                            <span className="product-quantity">{product.quantity || 0}</span>
                            <button
                              type="button"
                              onClick={() => updateProductQuantity(product.product_id, product.quantity + 1)}
                              className="qty-btn"
                            >
                              +
                            </button>
                            <span className="product-total">= €{(product.total_price || 0).toFixed(2)}</span>
                            <button
                              type="button"
                              onClick={() => removeProduct(product.product_id)}
                              className="remove-btn"
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      ))}
                      <div className="products-total">
                        <strong>{t.payments.totalProducts}</strong> €{(selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0).toFixed(2)}
                      </div>
                    </div>
                  )}
                  
                  {(selectedProducts || []).length === 0 && (
                    <p style={{color: '#888', fontSize: '14px', fontStyle: 'italic'}}>
                      Aucun produit dans ce paiement
                    </p>
                  )}
                </div>

                {/* Notes / Observações */}
                <div className="form-group" style={{marginTop: '15px'}}>
                  <label>
                    {t.payments.notes}
                    {(() => {
                      const selectedService = getServiceById(paymentForm.service_id);
                      const basePrice = selectedService?.price || 0;
                      const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                      const expectedTotal = basePrice + productsTotal;
                      const currentAmount = parseFloat(paymentForm.amount) || 0;
                      const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                      return priceModified ? (
                        <span style={{color: '#ff6b6b', marginLeft: '8px', fontSize: '12px'}}>
                          ⚠️ {t.payments.notesRequired}
                        </span>
                      ) : null;
                    })()}
                  </label>
                  <textarea
                    name="notes"
                    value={paymentForm.notes}
                    onChange={(e) => setPaymentForm({...paymentForm, notes: e.target.value})}
                    placeholder={(() => {
                      const selectedService = getServiceById(paymentForm.service_id);
                      const basePrice = selectedService?.price || 0;
                      const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                      const expectedTotal = basePrice + productsTotal;
                      const currentAmount = parseFloat(paymentForm.amount) || 0;
                      const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                      return priceModified 
                        ? t.payments.notesRequiredPlaceholder 
                        : t.payments.notesPlaceholder;
                    })()}
                    rows="3"
                    style={(() => {
                      const selectedService = getServiceById(paymentForm.service_id);
                      const basePrice = selectedService?.price || 0;
                      const productsTotal = (selectedProducts || []).reduce((sum, p) => sum + (p.total_price || 0), 0);
                      const expectedTotal = basePrice + productsTotal;
                      const currentAmount = parseFloat(paymentForm.amount) || 0;
                      const priceModified = paymentForm.service_id && Math.abs(currentAmount - expectedTotal) > 0.01;
                      return priceModified ? {borderColor: '#ff6b6b'} : {};
                    })()}
                  />
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn-cancel" onClick={() => setShowEditModal(false)}>
                    {t.agenda.cancel}
                  </button>
                  <button type="submit" className="btn-save" disabled={loading}>
                    {loading ? t.payments.saving : `💾 ${t.payments.saveChanges}`}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

      </section>
    );
  };

  const renderGallery = () => (
    <section className="gallery-section">
      <div className="section-header">
        <h2 className="section-title">{t.gallery.title}</h2>
      </div>
      <div className="gallery-grid">
        {galleryImages.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );

  const renderShop = () => {
    const categories = ['all', 'styling', 'barba', 'cuidados', 'acessorios'];
    
    const filteredProducts = selectedCategory === 'all' 
      ? products.filter(product => product.visible_in_shop !== false)
      : products.filter(product => {
          const normalizedCategory = product.category.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          const normalizedSelected = selectedCategory.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          return normalizedCategory === normalizedSelected && product.visible_in_shop !== false;
        });

    const getProductName = (product) => {
      if (currentLang === 'en' && product.name_en) return product.name_en;
      if (currentLang === 'fr' && product.name_fr) return product.name_fr;
      if (currentLang === 'es' && product.name_es) return product.name_es;
      return product.name;
    };

    const getProductDescription = (product) => {
      if (currentLang === 'en' && product.description_en) return product.description_en;
      if (currentLang === 'fr' && product.description_fr) return product.description_fr;
      if (currentLang === 'es' && product.description_es) return product.description_es;
      return product.description;
    };

    return (
      <section className="shop-section">
        <div className="section-header">
          <h2 className="section-title">{t.shop.title}</h2>
          <p className="section-subtitle">{t.shop.subtitle}</p>
        </div>
        
        {/* Notice: Products available in-store only */}
        <div className="store-only-notice">
          <div className="notice-icon">🏪</div>
          <p>{t.shop.storeOnlyNotice}</p>
        </div>
        
        {/* Admin Panel Toggle - Only visible with Super Admin access */}
        {superAdminAccess && (
          <div className="admin-toggle">
            <button 
              className="admin-toggle-btn"
              onClick={() => setShowAdminPanel(!showAdminPanel)}
            >
              {t.shop.adminPanel} {showAdminPanel ? '🔓' : '🔒'}
            </button>
          </div>
        )}

        {/* Historique des mouvements de stock - Super Admin uniquement */}
        {superAdminAccess && showAdminPanel && (
          <StockHistory backendUrl={process.env.REACT_APP_BACKEND_URL} />
        )}

        {/* Category Filter */}
        <div className="category-filter">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {t.shop.categories[category]}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loading">{t.shop.loading}</div>
        ) : (
          <div className="products-grid">
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className="flip-card"
                onClick={(e) => {
                  // Toggle flip on mobile (tap)
                  if (window.innerWidth <= 768) {
                    e.currentTarget.classList.toggle('flipped');
                  }
                }}
              >
                <div className="flip-card-inner">
                  {/* Face avant - Image du produit */}
                  <div className="flip-card-front">
                    <img src={product.image_url} alt={getProductName(product)} />
                    <div className="flip-card-brand">{product.brand}</div>
                    <div className="flip-card-name">{getProductName(product)}</div>
                  </div>
                  {/* Face arrière - Description */}
                  <div className="flip-card-back">
                    <div className="flip-card-back-content">
                      <h3 className="flip-card-title">{getProductName(product)}</h3>
                      <span className="flip-card-brand-tag">{product.brand}</span>
                      <p className="flip-card-description">{getProductDescription(product)}</p>
                      <div className="flip-card-details">
                        {product.weight && <span className="flip-card-weight">{product.weight}</span>}
                        <span className={`flip-card-stock ${product.in_stock ? 'in-stock' : 'out-stock'}`}>
                          {product.in_stock ? t.shop.inStock : t.shop.outOfStock}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Admin Panel pour ce produit - Only visible with Super Admin access */}
                {showAdminPanel && superAdminAccess && (
                  <div className="admin-panel">
                    <div className="admin-info">
                      <span>Prix: €{product.price.toFixed(2)}</span>
                      <span>Marge: €{(product.price - (product.cost_price || 0)).toFixed(2)}</span>
                    </div>
                    <div className="stock-update">
                      <input
                        type="number"
                        placeholder={t.shop.newStock}
                        value={stockUpdates[product.id] || ''}
                        onChange={(e) => setStockUpdates(prev => ({
                          ...prev,
                          [product.id]: e.target.value
                        }))}
                        min="0"
                      />
                      <button 
                        className="update-stock-btn"
                        onClick={() => handleUpdateStock(product.id, stockUpdates[product.id])}
                        disabled={!stockUpdates[product.id]}
                      >
                        {t.shop.updateStock}
                      </button>
                    </div>
                  </div>
                )}
                
                {/* Message pour admin normal */}
                {showAdminPanel && adminAccess && !superAdminAccess && (
                  <div className="admin-panel admin-panel-readonly">
                    <div className="admin-info">
                      <span>Custo: €{(product.cost_price || 0).toFixed(2)}</span>
                      <span>Marge: €{(product.price - (product.cost_price || 0)).toFixed(2)}</span>
                      <span>Profit: {(((product.price - (product.cost_price || 0)) / product.price) * 100).toFixed(0)}%</span>
                    </div>
                    <div className="readonly-message">
                      🔒 Modification du stock réservée au Super Admin
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </section>
    );
  };

  const handleUpdateStock = async (productId, newStock) => {
    try {
      setLoading(true);
      const response = await fetch(`${backendUrl}/api/products/${productId}/stock`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product_id: productId,
          stock_quantity: parseInt(newStock)
        }),
      });

      if (response.ok) {
        const result = await response.json();
        
        // Mettre à jour le produit dans la liste
        setProducts(prevProducts => 
          prevProducts.map(p => 
            p.id === productId ? result.product : p
          )
        );
        
        // Reset du form
        setStockUpdates(prev => ({ ...prev, [productId]: '' }));
        setMessage('Stock mis à jour avec succès!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        const error = await response.json();
        setMessage(error.detail || 'Erreur lors de la mise à jour');
      }
    } catch (error) {
      console.error('Error updating stock:', error);
      setMessage('Erreur lors de la mise à jour');
    } finally {
      setLoading(false);
    }
  };

  const renderAppointment = () => {
    // Calculer la date minimum (aujourd'hui)
    const today = new Date().toISOString().split('T')[0];
    
    return (
      <section className="appointment-section">
        <div className="section-header">
          <h2 className="section-title">{t.appointment.title}</h2>
          <p className="section-subtitle">{t.appointment.subtitle}</p>
        </div>
        
        {message && (
          <div className={`message ${message.includes('sucesso') || message.includes('success') || message.includes('succès') || message.includes('éxito') || message.includes('✅') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleAppointmentSubmit} className="appointment-form">
          <div className="form-group" style={{position: 'relative'}}>
            <input
              type="text"
              placeholder={adminAccess ? `${t.appointment.form.name} (auto-complete actif)` : t.appointment.form.name}
              value={appointmentForm.client_name}
              onChange={(e) => {
                setAppointmentForm({...appointmentForm, client_name: e.target.value});
                searchClientsForAppointment(e.target.value);
              }}
              onFocus={() => {
                if (adminAccess && appointmentClientSuggestions.length > 0) setShowAppointmentClientSuggestions(true);
              }}
              onBlur={() => setTimeout(() => setShowAppointmentClientSuggestions(false), 200)}
              required
              minLength="2"
              autoComplete="off"
            />
            {/* Suggestions de clients (Admin uniquement) */}
            {adminAccess && showAppointmentClientSuggestions && appointmentClientSuggestions.length > 0 && (
              <div className="client-suggestions" style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                background: '#1a1a1a',
                border: '1px solid #daa520',
                borderRadius: '8px',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: 1000
              }}>
                {appointmentClientSuggestions.map((client) => (
                  <div
                    key={client.id}
                    onClick={() => selectClientForAppointment(client)}
                    style={{
                      padding: '10px 15px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #333',
                      color: '#fff'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#2a2a2a'}
                    onMouseLeave={(e) => e.target.style.background = 'transparent'}
                  >
                    <div style={{fontWeight: 'bold', color: '#daa520'}}>{client.name}</div>
                    <div style={{fontSize: '12px', color: '#888'}}>
                      {client.email} {client.phone && `• ${client.phone}`}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div className="form-group">
            <input
              type="email"
              placeholder={t.appointment.form.email}
              value={appointmentForm.client_email}
              onChange={(e) => setAppointmentForm({...appointmentForm, client_email: e.target.value})}
              required
            />
          </div>
          
          <div className="form-group">
            <div className="phone-input-container">
              <select 
                className="country-code-select"
                value={phoneCountryCode}
                onChange={(e) => setPhoneCountryCode(e.target.value)}
              >
                <option value="+351">🇵🇹 +351</option>
                <option value="+33">🇫🇷 +33</option>
                <option value="+34">🇪🇸 +34</option>
                <option value="+44">🇬🇧 +44</option>
                <option value="+49">🇩🇪 +49</option>
                <option value="+39">🇮🇹 +39</option>
                <option value="+1">🇺🇸 +1</option>
                <option value="+41">🇨🇭 +41</option>
                <option value="+32">🇧🇪 +32</option>
                <option value="+31">🇳🇱 +31</option>
              </select>
              <input
                type="tel"
                placeholder={t.appointment.form.phone}
                value={appointmentForm.client_phone}
                onChange={(e) => setAppointmentForm({...appointmentForm, client_phone: e.target.value})}
                required
                minLength="9"
                className="phone-number-input"
              />
            </div>
          </div>
          
          <div className="form-group">
            <select
              value={appointmentForm.service_id}
              onChange={(e) => setAppointmentForm({...appointmentForm, service_id: e.target.value})}
              required
            >
              <option value="">{t.appointment.form.service}</option>
              {/* Services groupés par catégorie, triés par prix croissant */}
              <optgroup label={`── ${t.services.categories.regular} ──`}>
                {services.filter(s => s.category === 'Regular' && s.name !== "Vente Seule").sort((a, b) => a.price - b.price).map((service) => (
                  <option key={service.id} value={service.id}>
                    {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                  </option>
                ))}
              </optgroup>
              <optgroup label={`── ${t.services.categories.premium} ──`}>
                {services.filter(s => s.category === 'Premium' && s.name !== "Vente Seule").sort((a, b) => a.price - b.price).map((service) => (
                  <option key={service.id} value={service.id}>
                    {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                  </option>
                ))}
              </optgroup>
              <optgroup label={`── ${t.services.categories.barbe} ──`}>
                {services.filter(s => s.category === 'Barbe' && s.name !== "Vente Seule").sort((a, b) => a.price - b.price).map((service) => (
                  <option key={service.id} value={service.id}>
                    {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                  </option>
                ))}
              </optgroup>
              <optgroup label={`── ${t.services.categories.colorations} ──`}>
                {services.filter(s => s.category === 'Colorations' && s.name !== "Vente Seule").sort((a, b) => a.price - b.price).map((service) => (
                  <option key={service.id} value={service.id}>
                    {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                  </option>
                ))}
              </optgroup>
              <optgroup label={`── ${t.services.categories.soins} ──`}>
                {services.filter(s => s.category === 'Soins' && s.name !== "Vente Seule").sort((a, b) => a.price - b.price).map((service) => (
                  <option key={service.id} value={service.id}>
                    {translateServiceName(service.name)} - €{service.price.toFixed(2)}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>
          
          <div className="form-group">
            <div className="date-input-container">
              <button
                type="button"
                className="date-selector-btn"
                onClick={() => setShowCalendar(true)}
              >
                {appointmentForm.appointment_date 
                  ? new Date(appointmentForm.appointment_date).toLocaleDateString(
                      currentLang === 'fr' ? 'fr-FR' : currentLang === 'en' ? 'en-GB' : currentLang === 'es' ? 'es-ES' : 'pt-PT', 
                      {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long', 
                        day: 'numeric'
                      })
                  : t.appointment.form.date
                }
              </button>
              {showCalendar && (
                <div className="calendar-overlay">
                  {renderCalendar()}
                </div>
              )}
            </div>
            <small className="date-hint">
              {t.appointment.openingHours}
            </small>
          </div>
          
          <div className="form-group">
            <select
              value={appointmentForm.appointment_time}
              onChange={(e) => setAppointmentForm({...appointmentForm, appointment_time: e.target.value})}
              required
              disabled={!appointmentForm.appointment_date || availableTimes.length === 0}
            >
              <option value="">{t.appointment.form.time}</option>
              {availableTimes.map((time) => (
                <option key={time} value={time}>{time}</option>
              ))}
            </select>
            {!appointmentForm.appointment_date && (
              <small className="time-hint">{t.appointment.form.selectDateFirst}</small>
            )}
            {appointmentForm.appointment_date && availableTimes.length === 0 && (
              <small className="time-hint">{t.appointment.form.loadingTimes}</small>
            )}
          </div>
          
          <div className="form-group">
            <textarea
              placeholder={t.appointment.form.notes}
              value={appointmentForm.notes}
              onChange={(e) => setAppointmentForm({...appointmentForm, notes: e.target.value})}
              rows="4"
            />
          </div>
          
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? '...' : t.appointment.form.submit}
          </button>
        </form>
      </section>
    );
  };

  const renderContent = () => {
    switch (currentSection) {
      case 'home':
        return renderHome();
      case 'services':
        return renderServices();
      // Gallery temporairement désactivée - en attente de vraies photos
      // case 'gallery':
      //   return renderGallery();
      case 'shop':
        return renderShop();
      case 'agenda':
        return renderAgenda();
      case 'payments':
        return renderPayments();
      case 'appointment':
        return renderAppointment();
      default:
        return renderHome();
    }
  };

  return (
    <div className="App">
      {/* Modale de confirmation de rendez-vous */}
      {showConfirmationModal && (
        <div className="confirmation-modal-overlay" onClick={() => setShowConfirmationModal(false)}>
          <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">✅</div>
            <h2 className="modal-title">{t.appointment.confirmationModal.title}</h2>
            <p className="modal-message">{t.appointment.confirmationModal.message}</p>
            <p className="modal-email-info">{t.appointment.confirmationModal.emailInfo}</p>
            <p className="modal-spam-warning">{t.appointment.confirmationModal.spamWarning}</p>
            <button 
              className="modal-close-btn" 
              onClick={() => setShowConfirmationModal(false)}
            >
              {t.appointment.confirmationModal.close}
            </button>
          </div>
        </div>
      )}
      
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-text">MAFI BARBER</span>
          </div>
          
          <nav className={`nav ${isMobile ? 'mobile-nav' : ''}`}>
            <a 
              href="#home" 
              className={currentSection === 'home' ? 'active' : ''}
              onClick={() => setCurrentSection('home')}
            >
              {isMobile ? <Home size={18} strokeWidth={1.5} /> : t.nav.home}
            </a>
            <a 
              href="#services" 
              className={currentSection === 'services' ? 'active' : ''}
              onClick={() => setCurrentSection('services')}
            >
              {isMobile ? <Scissors size={18} strokeWidth={1.5} /> : t.nav.services}
            </a>
            <a 
              href="#shop" 
              className={currentSection === 'shop' ? 'active' : ''}
              onClick={() => setCurrentSection('shop')}
            >
              {isMobile ? <ShoppingBag size={18} strokeWidth={1.5} /> : t.nav.shop}
            </a>
            {/* Agenda - Visible pour admin et mode barber (lecture seule) */}
            {(adminAccess || weakAdminAccess) && (
              <a 
                href="#agenda" 
                className={currentSection === 'agenda' ? 'active' : ''}
                onClick={() => setCurrentSection('agenda')}
              >
                {isMobile ? <ClipboardList size={18} strokeWidth={1.5} /> : t.nav.agenda}
              </a>
            )}
            {/* Payments - Only visible with admin access */}
            {adminAccess && (
              <a 
                href="#payments" 
                className={currentSection === 'payments' ? 'active' : ''}
                onClick={() => setCurrentSection('payments')}
              >
                {isMobile ? <Wallet size={18} strokeWidth={1.5} /> : t.payments.title.toUpperCase()}
              </a>
            )}
            <a 
              href="#appointment" 
              className={currentSection === 'appointment' ? 'active' : ''}
              onClick={() => setCurrentSection('appointment')}
            >
              {isMobile ? <Calendar size={18} strokeWidth={1.5} /> : t.nav.appointment}
            </a>
          </nav>
          
          <div className="language-selector">
            <select 
              value={currentLang} 
              onChange={(e) => { setCurrentLang(e.target.value); localStorage.setItem('mafi_lang', e.target.value); }}
              className="lang-select"
            >
              <option value="pt">PT</option>
              <option value="fr">FR</option>
              <option value="en">EN</option>
              <option value="es">ES</option>
            </select>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main">
        <div className="container">
          {renderContent()}
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>MAFI BARBER</h3>
              <p>{t.tagline}</p>
              <p style={{marginTop: '0.5rem'}}>
                <a href="tel:+351924719857" style={{color: '#daa520', textDecoration: 'none', letterSpacing: '1px'}}>
                  📞 +351 924 719 857
                </a>
              </p>
            </div>
            <div className="footer-section">
              <h4>{currentLang === 'fr' ? 'Informations' : currentLang === 'en' ? 'Information' : currentLang === 'es' ? 'Información' : 'Informações'}</h4>
              <p>
                <a href="https://maps.app.goo.gl/oLCGqXe2F71XEvKH6" target="_blank" rel="noopener noreferrer" style={{color: '#ffffff', textDecoration: 'none'}}>
                  📍 Rua Direita 16/18, 5400-220 Chaves, Portugal
                </a>
              </p>
              <p>🕐 {currentLang === 'fr' ? 'Lun-Dim: 9h-20h (RDV)' : currentLang === 'en' ? 'Mon-Sun: 9am-8pm (by appointment)' : currentLang === 'es' ? 'Lun-Dom: 9h-20h (con cita)' : 'Seg-Dom: 9h-20h (com marcação)'}</p>
              <p>📧 <a href="mailto:mafibarber.suporte@hotmail.com" style={{color: '#ffffff', textDecoration: 'none'}}>mafibarber.suporte@hotmail.com</a></p>
            </div>
            <div className="footer-section">
              <h4>{currentLang === 'fr' ? 'Réseaux Sociaux' : currentLang === 'en' ? 'Social Media' : currentLang === 'es' ? 'Redes Sociales' : 'Redes Sociais'}</h4>
              <p>
                Instagram: <a href="https://instagram.com/mafi.barber" target="_blank" rel="noopener noreferrer" style={{color: '#daa520', textDecoration: 'none'}}>@mafi.barber</a>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Mafi Barber. {currentLang === 'fr' ? 'Tous droits réservés.' : currentLang === 'en' ? 'All rights reserved.' : currentLang === 'es' ? 'Todos los derechos reservados.' : 'Todos os direitos reservados.'}</p>
            {/* Logo fleur de lys cliquable - 5 taps pour accès admin */}
            <div 
              className="footer-logo-secret" 
              onClick={handleLogoTap}
              style={{
                cursor: 'pointer',
                fontSize: '24px',
                color: '#daa520',
                marginTop: '10px',
                userSelect: 'none',
                WebkitTapHighlightColor: 'transparent'
              }}
              title="⚜"
            >
              ⚜
            </div>
          </div>
        </div>
      </footer>

      {/* Modal Admin Password - S'ouvre après 5 taps sur le logo */}
      {showAdminPanel && !adminAccess && (
        <div className="admin-password-modal">
          <div className="admin-password-content">
            <h2>🔐 Acesso Admin</h2>
            <p>Digite a senha de administrador:</p>
            <input
              type="password"
              placeholder="Senha..."
              autoFocus
              onKeyPress={async (e) => {
                if (e.key === 'Enter') {
                  const password = e.target.value;
                  const inputEl = e.target;
                  const role = await adminServerLogin(password);
                  if (role === 'admin') {
                    applyAdminRole(role);
                    setShowAdminPanel(false);
                    setCurrentSection('payments');
                    alert('✅ Acesso Admin concedido!');
                  } else if (role === 'superadmin') {
                    applyAdminRole(role);
                    setShowAdminPanel(false);
                    setCurrentSection('payments');
                    alert('✅ Acesso Super Admin concedido!');
                  } else if (role === 'barber') {
                    applyAdminRole(role);
                    setShowAdminPanel(false);
                    setCurrentSection('agenda');
                    alert('✅ Acesso Barber concedido (apenas consulta da agenda)!');
                  } else {
                    alert('❌ Senha incorreta!');
                    inputEl.value = '';
                  }
                }
              }}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                border: '2px solid #daa520',
                borderRadius: '8px',
                marginTop: '15px',
                background: '#1a1a1a',
                color: '#ffffff'
              }}
            />
            <div style={{marginTop: '15px', display: 'flex', gap: '10px'}}>
              <button
                onClick={() => setShowAdminPanel(false)}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: '#666',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {t.agenda.cancel}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;